export const Spanish = {
  lang: 'es',
  wizard: {
    createAccount: 'Crea tu cuenta gratuita',
    noCreditCard: 'Sin tarjeta de crédito, cancela en cualquier momento',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo Electrónico',
    role: 'Cargo',
    dialCode: 'País',
    fullNumber: 'País y teléfono',
    password: 'Contraseña',
    saveButton: 'Enviar',
    captchaError: 'Captcha no ha sido validado',
    inputError: 'Completar campo',
    emailExistsError: 'El correo electrónico se encuentra en uso',
    emailCheckUnavailable:
      'No pudimos verificar este correo. Vuelve a intentarlo en un momento.',
    emailError: 'Correo electrónico inválido',
    emailInfo: 'Con este correo puedes entrar a la aplicación móvil y web',
    passwordError: 'Debe contener al menos 6 caracteres',
    privacyMessage: 'Haciendo click aceptas que estás de acuerdo con la ',
    privacy: 'Política de Privacidad',
    preparingForm: 'Estamos creando tu cuenta y preparando el formulario',
    preparingForm2: 'Esto puede tardar unos segundos',
    preparingForm3: 'Estamos preparando el formulario',
    userHasAccount: '¿Ya tienes cuenta?',
    login: 'Inicia sesión',
    onboardingVideo:
      'Mira este breve video y descubre cómo Datascope puede transformar tus procesos y hacer tu trabajo más fácil',
    onboardingVideoTitle: '¿Qué puede hacer Datascope por ti?',
    onboardingVideoSkip: 'Continuar',
    onboardingResetModal: {
      title: 'Aún no terminas de configurar tu cuenta',
      message:
        'No terminaste de configurar tu cuenta. ¿Quieres continuar donde la dejaste o empezar desde cero?',
      cancelButtonText: 'Comenzar de nuevo',
      confirmButtonText: 'Continuar',
      error: 'Error restableciendo la información de la cuenta',
    },
    onboardingLogoutModal: {
      title: '¿Estás seguro que quieres salir del proceso de configuración?',
      message: 'Si cierras sesión, podrás retomarlo más tarde al volver a iniciar sesión.',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Cerrar sesión',
    },
    back: 'Volver',
    intro: '¡Hola! Empecemos con lo básico',
    introDescription:
      'Ayúdanos a conocerte mejor para que podamos personalizar tu experiencia y ofrecerte justo lo que necesitas.',
    companyName: 'Nombre de tu empresa',
    industry: 'Tu industria',
    phoneNumber: 'Tu teléfono',
    next: 'Siguiente',
    phoneNumberError: 'El número de teléfono debe tener al menos 8 dígitos',
    firstNameError: 'El nombre es obligatorio',
    lastNameError: 'El apellido es obligatorio',
    companyNameError: 'El nombre de la empresa es obligatorio',
    industryError: 'La industria es obligatoria',
    noResults: 'No hay resultados',
    searchCountry: 'Buscar país...',
    selectOption: 'Selecciona una opción',
    namePlaceholder: 'Escribe tu nombre',
    companyPlaceholder: 'Escribe el nombre de tu empresa',
    search: 'Buscar',
    formErrors: 'Por favor completa todos los campos requeridos',
    industries: {
      agriculture: 'Agro',
      food: 'Alimentos',
      automotive: 'Automotriz',
      construction: 'Construcción',
      consulting: 'Consultoría',
      energy: 'Energía',
      facility: 'Facility Services',
      forestry: 'Forestal',
      engineering: 'Ingeniería',
      cleaning: 'Limpieza y Mantenimiento',
      logistics: 'Logística',
      machinery: 'Maquinaria',
      manufacturing: 'Manufactura',
      mining: 'Minería',
      retail: 'Retail',
      public: 'Sector Público',
      environment: 'Servicios Ambientales',
      health: 'Servicios de Salud',
      communication: 'Telecomunicaciones',
      transport: 'Transporte y Carga',
      wine: 'Vinos',
    },
    roles: {
      management: 'Gerencia',
      consulting: 'Asesoría o Consultoría',
      owner: 'Dueño/a',
      leadership: 'Jefatura',
      student: 'Estudiante',
      independent: 'Independiente',
      analyst: 'Analista',
      other: 'Otro',
    },
    roleRequired: 'Por favor selecciona un rol',
    roleQuestion: 'Ahora cuéntanos, ¿Cuál es tu rol en la organización?',
    roleQuestionDescription: 'Esto nos ayudará a brindarte una mejor experiencia',
    areas: {
      security: 'Seguridad e higiene',
      quality: 'Calidad',
      operations: 'Operaciones/Servicios (OT/OS)',
      audit: 'Auditoría',
      general: 'Uso general',
    },
    areaRequired: 'Por favor selecciona un área',
    areaQuestion: '¿En qué área te gustaría enfocarte hoy?',
    areaQuestionDescription: 'Selecciona el área que más te interesa',
    selectOptions: 'Selecciona las opciones que te interesen',
    selectRequired: 'Por favor selecciona al menos una opción',
    interests: {
      security: {
        question: '¿Qué te gustaría gestionar en seguridad e higiene?',
        options: {
          register_talks: 'Registro de charlas',
          fatality_risks: 'Riesgos de fatalidad',
          risks_matrices: 'Matrices de riesgos',
          safety_work_analysis: 'Análisis seguro del trabajo',
          accidents: 'Accidentes e incidentes',
          inspection_checklist: 'Checklist de inspecciones',
          training_records: 'Registros de capacitaciones',
        },
      },
      quality: {
        question: '¿Qué aspecto de calidad te gustaría gestionar?',
        options: {
          standard_procedures: 'Procedimientos Operativos Estándar (POE)',
          preoperational_verifications: 'Verificaciones preoperacionales',
          quality_control: 'Control de calidad',
          audit_plans: 'Planes de auditoría',
          non_conformity_records: 'Registros de no conformidades',
          legal_records: 'Registros legales',
        },
      },
      operations: {
        question: '¿Qué operaciones deseas administrar?',
        options: {
          maintenance_programs: 'Programas de mantenimiento',
          calibrations: 'Calibraciones',
          installations: 'Instalaciones',
          failure_records: 'Registros de fallas',
          daily_reports: 'Reportes diarios',
          certifications: 'Certificaciones',
          warranties: 'Garantías',
          consumption_records: 'Registros de consumo',
          progress_records: 'Registros de avances',
        },
      },
      audit: {
        question: '¿Qué tipo de auditoría te gustaría gestionar?',
        options: {
          quality_audits: 'Auditorías de calidad',
          safety_audits: 'Auditorías de higiene y seguridad',
          equipment_audits: 'Auditorías de equipamentos',
          norms_compliance: 'Cumplimiento de normativas',
          register_audits: 'Registros de auditorías',
          performance_evaluations: 'Evaluaciones de desempeño',
        },
      },
      general: {
        question: '¿Qué funcionalidad general deseas utilizar?',
        options: {
          polls: 'Encuestas',
          inventory: 'Control de inventario',
          attendance: 'Control de asistencia',
        },
      },
    },
    moreThan: 'Más de',
    selectOneOption: 'Por favor selecciona una opción',
    personnelCount: '¿Cuántas personas trabajan en este proceso actualmente?',
    personnelCountDescription: 'Selecciona el número de personas que utilizarán la plataforma',
    complete: 'Finalizar',
  },
  wizardFinish: {
    buildYourFirstForm: 'Crea tu primer formulario',
    yourPick: 'Tu elección',
    formTemplates: 'Plantillas de formularios',
    createForm: 'Crear formulario desde cero',
    importForm: 'Importar Google Form',
    welcome: '¡Bienvenido!',
    welcomeDescription1: 'A partir de ahora, podrás ',
    welcomeDescription2:
      'ingresar a la plataforma web y móvil utilizando las credenciales recien ingresadas.',
    welcomeDescription3:
      'Recuerda que para comenzar a recopilar datos, simplemente debes descargar la aplicación desde Google Play o App Store en tu teléfono o tableta.',
  },
  onboardingTemplates: {
    title: 'Te recomendamos estos formularios según tu uso',
    subtitle: 'Selecciona uno para empezar a trabajar de inmediato',
    answerNow: 'Responder ahora',
    exploreOthers: 'Explorar otros templates',
    aiFormBuilderCta: 'Crea tu formulario con AI en segundos.',
    aiFormBuilderLink: 'Ir al creador con AI',
    aiFormBuilderTitle: 'Crea tu formulario con AI en segundos',
    aiFormBuilderSubtitle:
      'Describe el formulario que necesitás y nuestro agente lo creará en segundos.',
    aiFormBuilderButton: 'Crear con AI',
    recentlyViewedLabel: 'Recién Visto',
    aiFormBuilderRecommendationsTitle: 'Recomendaciones de templates que puedes crear y usar',
    aiFormBuilderNoMatchText: '¿No encontraste lo que buscabas?',
    aiFormBuilderNoMatchButton: 'Crea un formulario con AI',
  },
  plannings: {
    integrations: {
      title: 'Integración Planificación',
      gsheetsIntegrationLabel: 'Ir a Google Sheets',
      gsheetsNewLinkUrl: 'https://sheets.new/',
      infoTextPart1:
        'Para garantizar una integración adecuada, privada y segura, comparte tu documento con permisos de',
      infoTextPart2: 'editor',
      infoTextPart3: 'únicamente a',
      inputLabel: 'Nuevo enlace',
      inputPlaceholder: 'Ingresa el enlace del documento a integrar',
      optional: '(Opcional)',
      save: 'Guardar',
      cancel: 'Cancelar',
      copyUrl: '¡URL copiada!',
      copyEmail: '¡Correo copiado!',
      created: '¡Integración configurada exitosamente!',
      saved: '¡Cambios guardados con éxito!',
      deleted: 'Integración eliminada con éxito',
      savingError: 'Error al configurar la integración',
      removeTitle: '¿Quitar la integración con Google Sheets?',
      removeBody:
        'La hoja dejará de recibir actualizaciones de la planificación desde DataScope. El documento en Google Drive no se elimina.',
      removeConfirm: 'Quitar integración',
      removeCancel: 'Cancelar',
    },
    title: 'Planificaciones',
    subtitle: 'Gestiona planificaciones de tareas recurrentes con responsables y progreso.',
    new: 'Nueva planificación',
    create: 'Crear',
    planningTypes: 'Plantillas',
    import: 'Importar',
    export: 'Exportar',
    search: 'Buscar por nombre planificación',
    clearFilters: 'Borrar filtros',
    actions: 'Acciones',
    of: 'de',
    loading: 'Cargando planificaciones…',
    pricing: {
      inUse: 'en uso',
      quotaTooltip:
        'Cuentan las planificaciones activas, atrasadas y pausadas. Borradores y archivadas no consumen cupo.',
      legend:
        'Tu plan incluye {limit} planificaciones en uso a la vez (activas, atrasadas o pausadas). Borradores y archivadas no consumen cupo.',
      nearLimitWarning:
        'Te queda 1 planificación disponible en tu plan. Las completadas o archivadas liberan cupo.',
      limitModal: {
        title: 'Límite de planificaciones alcanzado',
        description:
          'Tu plan Professional incluye hasta {limit} planificaciones en uso a la vez (activas, atrasadas o pausadas). Borradores y archivadas no consumen cupo.',
        feature1: 'Planificaciones ilimitadas con el plan Enterprise',
        feature2: 'Cubre toda tu operación sin liberar cupo cada vez',
        feature3: 'Tu equipo sigue operando sin interrupciones',
        upgradeButton: 'Desbloquear planificaciones ilimitadas',
        continueButton: 'Seguir con mi plan actual',
        upgradeIntercomMessage:
          'Hola, quiero ampliar mi plan para tener planificaciones ilimitadas.',
      },
      landing: {
        title: 'Planifica y haz seguimiento de tu operación',
        question: '¿Para qué usar Planificaciones?',
        intro: 'Con esta funcionalidad es posible:',
        bullet1:
          'Agrupar tareas bajo un plan de seguridad, mantenimiento, auditoría o calidad, con responsables y período definidos.',
        bullet2:
          'Ver el avance de cada plan en tiempo real, sin perseguir a nadie ni armar planillas.',
        bullet3: 'Detectar planificaciones atrasadas a tiempo, antes de que sean un problema.',
        knowPlans: 'Conocer los planes',
        contactSales: 'Hablar con ventas',
        availability: 'Disponible en los planes Professional y Enterprise.',
        contactSalesIntercomMessage:
          'Hola, quiero saber más sobre Planificaciones y los planes que la incluyen.',
        demoTitle: 'Así funciona en tu operación',
        demoMobileTitle: 'Tu equipo ejecuta desde la app móvil',
        demoMobileBody:
          'Las tareas de cada plan llegan a la app del equipo en terreno. Cada respuesta actualiza el avance del plan automáticamente.',
        demoWebTitle: 'Tú sigues el avance desde la web',
        demoWebBody:
          'La vista de planificaciones muestra el progreso, los responsables y el estado de cada plan en tiempo real. Las atrasadas se marcan solas.',
        previous: 'Anterior',
        next: 'Siguiente',
        webImageAlt: 'Vista de planificaciones en la web',
        mobileTasksAlt: 'Tareas del plan en la app móvil',
        mobileDoneAlt: 'Plan completado en la app móvil',
      },
    },
    createMenu: {
      planning: 'Crear planificación',
      planningType: 'Crear plantilla',
    },
    stateTabs: {
      all: 'Todas',
      active: 'Activas',
      completed: 'Completadas',
      archived: 'Archivadas',
      late: 'Atrasadas',
      draft: 'Borradores',
      paused: 'Pausadas',
    },
    filterChips: {
      date: 'Fecha',
      datePopover: 'Selecciona el rango de fechas',
      location: 'Lugar',
      locationPopover: 'Filtra por lugar',
      supervisor: 'Supervisor',
      supervisorPopover: 'Filtra por supervisor',
      planningType: 'Tipo',
      planningTypePopover: 'Filtra por tipo',
      planningTypeSearch: 'Buscar tipo',
      asset: 'Activo',
      assetPopover: 'Filtra por activo',
      assetSearch: 'Buscar activo',
      empty: 'Sin resultados',
      allTab: 'Todos',
      groupTab: 'Grupos',
    },
    columns: {
      code: 'ID',
      name: 'Planificación',
      asset: 'Activo',
      period: 'Periodo',
      progress: 'Progreso',
      state: 'Estado',
      supervisor: 'Supervisor',
      planningType: 'Plantilla',
    },
    assetsView: {
      viewLabel: 'Vista:',
      toggleGeneral: 'General',
      toggleAssets: 'Activos',
      activePlanningOne: '1 planificación activa',
      activePlanningOther: '{count} planificaciones activas',
      next: 'Próximo:',
      nextPlanning: 'Próxima planificación:',
      nextPlanningToday: 'Hoy',
      nextPlanningInDaysOne: 'En 1 día',
      nextPlanningInDaysOther: 'En {days} días',
      unassignedPlanning: 'Planificación sin activo',
      temporalCycleType: 'Temporal',
      columns: {
        type: 'Tipo',
        id: 'ID',
        projectedDate: 'Fecha proyectada',
        executionDate: 'Fecha ejecución',
        completion: 'Cumplimiento',
        state: 'Estado',
      },
      cycleStates: {
        completed: 'Completado',
        pending: 'Programado',
        in_progress: 'En progreso',
        draft: 'Borrador',
        active: 'Activa',
        paused: 'Pausada',
        late: 'Atrasada',
        archived: 'Archivada',
      },
    },
    timeline: {
      toggleTable: 'Tabla',
      toggleTimeline: 'Cronograma',
      today: 'Hoy',
      emptyState: {
        title: 'No tienes planificaciones disponibles',
        hint: 'Crea una o ajusta los filtros',
      },
      loadError: {
        title: 'No pudimos cargar el cronograma',
        hint: 'Ocurrió un error. Por favor, intenta nuevamente.',
      },
      tooltip: {
        stateScheduled: 'Estado: Programada',
        stateInProgress: 'Estado: En progreso',
        stateCompleted: 'Estado: Completada',
        stateCompletedLate: 'Estado: Completada con atraso',
        stateOverdue: 'Estado: Atrasada',
        statePaused: 'Estado: Pausada',
        statePausedMeterInactive: 'Sin actividad del medidor',
        statePausedAssetDeactivated: 'Activo desactivado',
        pendingTasksOne: '1 tarea pendiente',
        pendingTasksOther: '{count} tareas pendientes',
        windowLabel: 'Ventana',
        realizedLabel: 'Realizado',
      },
      enterprise: {
        badge: 'Funcionalidad Enterprise',
        title: 'Visualiza toda tu planificación mensual en una sola vista',
        description:
          'Deja atrás las planillas paralelas y mantén toda tu planificación de mantenimiento organizada en una sola vista.',
        bullet1: 'Ve todas las mantenciones del mes en una sola vista.',
        bullet2: 'Detecta atrasos y mantenimientos superpuestos antes de que afecten la operación.',
        bullet3: 'Comparte el plan con tu equipo en PDF.',
        cta: 'Actualizar plan',
      },
      export: {
        pdf: 'PDF',
        excel: 'Excel',
        generating: 'Generando cronograma PDF...',
        ready: 'Tu archivo está listo. La descarga comenzará en unos segundos.',
        failed: 'No fue posible generar el archivo. Inténtalo nuevamente.',
        noResultsToExport: 'No hay resultados para exportar',
      },
      drawer: {
        openPlanning: 'Abrir planificación',
        close: 'Cerrar',
      },
      rowsHeaderGeneral: 'Planificaciones',
      rowsHeaderActivos: 'Activos',
      legend: {
        temporal: 'Temporal',
      },
      print: {
        title: 'Cronograma de planificaciones',
        assetTypesLabel: 'Tipo de activo',
        locationsLabel: 'Lugar',
        joinTwo: '{first} y {second}',
        andMore: '{first} y {count} más',
        pageFooterLabel: 'Página',
      },
    },
    editedIndicator: 'Modificada',
    rowActions: {
      detail: 'Ver detalle',
      edit: 'Editar',
      continueEditing: 'Seguir editando',
      pause: 'Pausar',
      resume: 'Reanudar',
      archive: 'Archivar',
      unarchive: 'Desarchivar',
      delete: 'Eliminar',
    },
    editPublished: {
      title: 'Editar planificación',
      back: 'Volver a Planificación',
      backLink: 'Volver',
      nameLabel: 'Nombre',
      save: 'Guardar cambios',
      cancel: 'Cancelar',
      next: 'Siguiente',
      stepBack: 'Atrás',
      confirmTitle: 'Editar planificación',
      appliesNow: 'El nombre y los supervisores se actualizan de inmediato.',
      appliesNextCycle: 'La frecuencia y el template se aplican desde el próximo ciclo.',
      step1AlertTemporal:
        'Al guardar los cambios, el nombre y los supervisores se actualizan de inmediato. La frecuencia y la fecha de finalización se aplicarán a partir del próximo ciclo.',
      step1AlertTemporalNoFreq:
        'Al guardar los cambios, el nombre y los supervisores se actualizan de inmediato. La frecuencia y la fecha de finalización no se pueden modificar para este tipo de planificación.',
      step1AlertMeter:
        'Al guardar los cambios, el nombre y los supervisores se actualizan de inmediato. El motor de predicción se recalculará automáticamente con la nueva configuración.',
      step2Alert:
        'Los cambios en las tareas se aplicarán a partir del próximo ciclo. Si necesitas agregar o quitar responsables del ciclo actual, hazlo desde el detalle de la planificación.',
      step2AlertShared:
        'Los responsables se editan una sola vez en el listado y el cambio aplica a todas las tareas: agregar una persona aplica desde ahora; quitarla rige desde el próximo ciclo y no borra lo ya hecho.',
      tasksSectionTitle: 'Tareas de la planificación',
      lockedTypeTooltip: 'El tipo de planificación no puede modificarse una vez publicada.',
      lockedStartDateTooltip:
        'La fecha de inicio no puede modificarse una vez publicada la planificación.',
      lockedAssetTooltip: 'El activo no puede modificarse una vez publicada la planificación.',
      lockedEntryPointTooltip:
        'La última mantención declarada se fija al crear y no puede modificarse una vez publicada.',
      confirmSupervisorsImmediate:
        'Los cambios en los supervisores se reflejarán de inmediato, incluso en el ciclo que está en curso.',
      confirmScheduleNextCycle:
        'Los cambios en la frecuencia y la fecha de finalización se reflejarán a partir del próximo ciclo de la planificación.',
      confirmMeterImmediate: 'Los cambios en el nombre y los supervisores se aplicarán de inmediato.',
      confirmMeterEngineNextRecalc:
        'Los cambios en la configuración del motor de predicción se tendrán en cuenta a partir del próximo recálculo de la planificación.',
      confirmMeterImmediateAndEngine:
        'Los cambios en los supervisores se aplicarán de inmediato. Los cambios en la configuración del motor de predicción se tendrán en cuenta para calcular las próximas planificaciones a partir del próximo recálculo.',
      responsibles: {
        title: 'Responsables de las tareas',
        subtitle: 'Se definen una sola vez y aplican a todas las tareas de esta planificación.',
        empty: 'Sin responsables. La planificación deja de generar tareas hasta agregar a alguien.',
        add: 'Agregar responsable',
        addLink: 'Agregar responsables',
        groupSuffix: 'grupo',
        groupsNote:
          'Se elige un grupo. La tarea se asigna al grupo (una respuesta por grupo); no se mezcla con usuarios sueltos.',
        removeTitle: 'Quitar responsable',
        removeExplanation:
          'Deja de recibir tareas desde el próximo ciclo. Lo ya realizado se conserva.',
        cancelOpenTasks: 'Cancelar también sus tareas pendientes del ciclo actual',
        remove: 'Quitar',
        confirmNameSupervisorsImmediate:
          'Los cambios en el nombre y los supervisores se aplicarán de inmediato.',
        confirmFrequencyNextCycle:
          'Los cambios en la frecuencia se reflejarán a partir del próximo ciclo.',
        addedNote:
          'Se agrega a {names}. Aplica desde ahora a todas las tareas de esta planificación, en el ciclo en curso y en los próximos.',
        removedNote:
          '{names} dejará de recibir tareas de esta planificación a partir del próximo ciclo. Las tareas ya completadas no se verán afectadas.',
        cancelPendingLabel: 'Cancelar también las tareas pendientes de este ciclo',
        cancelPendingHint: 'Las tareas se marcarán como Canceladas y permanecerán en el historial.',
      },
    },
    toasts: {
      archived: '«{name}» archivada',
      unarchived: '«{name}» vuelve a estar vigente',
      deleted: 'Planificación eliminada',
      savedChanges: 'Cambios guardados',
      error: 'No se pudo completar la acción.',
    },
    states: {
      all: 'Todas',
      draft: 'Borrador',
      active: 'Activa',
      paused: 'Pausada',
      late: 'Atrasada',
      archived: 'Archivada',
    },
    counts: {
      total: 'Total planificaciones',
      active: 'Activas',
      paused: 'Pausadas',
      late: 'Atrasadas',
      archived: 'Archivadas',
      draft: 'Borradores',
    },
    frequencies: {
      daily: 'Diaria',
      weekly: 'Semanal',
      biweekly: 'Cada 2 semanas',
      monthly: 'Mensual',
      quarterly: 'Trimestral',
      semiannual: 'Semestral',
    },
    cycleWord: {
      daily: 'Día',
      weekly: 'Semana',
      biweekly: 'Ciclo',
      monthly: 'Mes',
      quarterly: 'Trimestre',
      semiannual: 'Semestre',
    },
    pagination: {
      results: 'Resultados',
      previous: 'Anterior',
      next: 'Siguiente',
    },
    empty: {
      title: 'No tienes planificaciones disponibles',
      hint: 'Crea tu primera planificación o ajusta los filtros.',
    },
    filters: {
      state: 'Estado',
      asset: 'Activo',
      planningType: 'Plantilla',
      supervisor: 'Supervisor',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
      anyType: 'Todas las plantillas',
      anyAsset: 'Cualquier activo',
    },
    error: {
      loadList: 'Error al cargar planificaciones',
      createPlanning: 'Error al crear la planificación',
      createTaskAssign: 'Error al crear la tarea',
      publish: 'Error al publicar la planificación',
    },
    wizard: {
      title: 'Crear Planificación',
      cancel: 'Cancelar',
      back: 'Atrás',
      next: 'Siguiente',
      saveDraft: 'Guardar borrador',
      publish: 'Crear',
      details: {
        planningType: 'Plantilla',
        planningTypeStandalone: 'Planificación estándar (Sin personalizar)',
        name: 'Nombre planificación',
        namePlaceholder: 'Escribe el nombre',
        startDate: 'Fecha de inicio',
        startDatePlaceholder: 'Selecciona la fecha',
        frequency: 'Frecuencia de la planificación',
        ends: 'Finalización:',
        endsNever: 'Nunca',
        endsDate: 'Fecha:',
        endsDatePlaceholder: 'DD/MM/AAAA',
        endsMaxReps: 'Después de:',
        endsMaxRepsUnit: 'repeticiones',
        supervisor: 'Supervisor',
        supervisorPlaceholder: 'Selecciona los supervisores',
        asset: 'Activo',
        assetRequired: 'Este tipo requiere un activo',
        location: 'Lugar',
        locationPlaceholder: 'Selecciona una ubicación',
      },
      meter: {
        strategyPreviewTitle: 'Vista previa de la estrategia',
        cumulativeLabel: 'Usar programación acumulativa',
        asset: 'Activo',
        assetPlaceholder: 'Selecciona un activo',
        planningConfigTitle: 'Configuración de la planificación',
        predictionConfigTitle: 'Configuración del motor de predicción',
        predictionSubtitle:
          'Los responsables serán notificados al iniciar la ventana de ejecución de cada planificación',
        assetMeterHelper: 'Solo verás los activos que tienen un medidor asociado',
        noAssetsForMeter: 'No existen activos con {meter} configurado.',
        configureAssets: 'Configurar activos',
        locationLabel: 'Lugar',
        locationFromAsset: 'Se completa con el activo',
        predictionTitle: 'Motor de predicción',
        modeAutomatic: 'Cálculo automático',
        modeAutomaticDesc: 'Usa el historial de lecturas del medidor para proyectar las fechas',
        modeAutomaticDisabledDesc:
          'Este activo no tiene suficientes lecturas del horómetro para calcular el promedio automáticamente.',
        modeManual: 'Ingresar promedio manualmente',
        modeManualDesc: 'Define tú el promedio de uso diario',
        calculationWindowLabel: 'Rango de cálculo',
        calculationWindowSuffix: 'meses hacia atrás',
        perDay: '{unit}/día',
        manualDailyAverageLabel: 'Promedio de uso',
        currentValueLabel: 'Medición actual',
        rateLine:
          'Tasa: {rate} {unit}/día, basado en {reading_count} lecturas en los últimos {effective_window_months} meses',
        projectionTitle: 'Proyección próximas planificaciones',
        projectedDateLabel: 'Fecha proyectada',
        entryTitle: 'Última mantención ejecutada',
        entrySubtitle:
          'Opcional. Declara de dónde viene el activo para que el ciclo arranque desde ahí y no dé por hecho todo lo anterior.',
        entryClear: 'Quitar',
        entryMilestoneLabel: 'Hito ejecutado',
        entryMilestonePlaceholder: 'Selecciona un hito',
        entryMilestoneHint: 'Elige el activo primero para ver los hitos disponibles.',
        entryReadingLabel: 'Lectura al ejecutarlo',
        entryLockedSubtitle: 'Se declara al crear y no se puede cambiar después de publicar.',
        entryRejectedByServer: 'El servidor rechazó esta declaración. Vuelve a elegir el hito.',
        entryRejectedByServerReading: 'El servidor rechazó esta declaración. Revisa la lectura.',
        entryReadingOutOfRange: 'Debe estar entre {min} y {max} para este hito.',
        entryAboveCurrentNote:
          'La lectura declarada supera la lectura actual del medidor ({current}). Se acepta: normalmente significa que la lectura registrada está atrasada.',
        entryDueCount: 'El activo entra con {count} mantenciones por ejecutar: {list}.',
        entryDueCountOne: 'El activo entra con 1 mantención por ejecutar: {list}.',
        entryNoneDue: 'El activo entra al día: el medidor no pasó ninguna mantención sin ejecutar.',
        entryNotDeclaredHint:
          'Sin declarar la última mantención, se asume que todo lo anterior a {value} ya se ejecutó.',
        recalcNote:
          'Las fechas y ventanas se recalculan automáticamente según la actividad reciente del horómetro.',
        clampWarning:
          'El rango solicitado supera el historial disponible del activo. Se calculará con las lecturas registradas entre el {start} y el {end}.',
        emptyState: 'Sin datos suficientes; ingresa un promedio manual',
        windowTooNarrow:
          'No hay suficientes lecturas en el rango seleccionado. Amplía la ventana de cálculo.',
        manualPending:
          'Estas proyecciones se ajustarán automáticamente cuando exista suficiente data real del medidor.',
        errorState: 'No se pudo calcular la proyección.',
        retry: 'Reintentar',
        levelEvery: 'Cada {interval} {unit}',
        ownCount: '{count} tareas de este nivel',
        inheritedCount: '{count} heredadas',
        inheritedSuffix: ' (Heredada)',
        inheritedFrom: '(Heredada de {code})',
        editForLevel: 'Editar la tarea solo para {code}',
        createTask: 'Crear tarea',
        taskCreated: 'Tarea creada',
        estimatedDate: 'Fecha estimada de la tarea',
        estimatedStart: 'Inicio estimado',
        estimatedEnd: 'Fin estimado',
        basedOnTitle: 'Basado en:',
        basedOnAverage: 'Uso promedio del medidor',
        basedOnHistory: 'Historial del activo',
        basedOnStrategy: 'Estrategia mega ciclo de planificaciones',
        estimatedDatePending: 'Sin fecha estimada disponible',
        readOnlyTitle: 'Fecha estimada',
        readOnlySubtitle:
          'Las fechas se calculan a partir de la proyección del medidor y no son editables.',
        levelsEmpty: 'Selecciona una estrategia para ver los niveles',
        emptyLevel: 'Este nivel no tiene formularios asociados',
      },
      tasks: {
        introStandalone:
          'Para crear esta planificación, debes asignar formularios y crear tareas con ellos',
        introPreset: 'Para crear esta planificación, asigna los siguientes formularios como tareas',
        addForm: 'Agregar formulario',
        createTask: 'Crear tarea',
        taskCreated: 'Tarea creada',
        editTask: 'Editar tarea',
        editTaskOf: 'Editar tarea de:',
        nextCycle: 'Próximo ciclo:',
        dateSeparator: 'al',
        dateSeparatorSameDay: 'a',
        notifySuccess: 'Notificación enviada',
        loadingPlanning: 'Creando planificación…',
        removeForm: 'Eliminar formulario',
        emptyTypeTitle: 'Esta plantilla aún no tiene formularios asociados',
        emptyTypeLink: 'Asignar formularios al tipo',
        sharedResponsiblesRequired: 'Primero agrega responsables. Las tareas heredan ese listado.',
        sharedResponsiblesSaving: 'Guardando responsables…',
      },
      taskDialog: {
        title: 'Crear tarea',
        mobileUser: 'Responsable',
        location: 'Lugar',
        cycleDay: 'Día del ciclo',
        durationHours: 'Duración (horas)',
        description: 'Descripción',
        scheduledSendDaysBefore: 'Programar envío (días antes)',
        submit: 'Guardar tarea',
        cancel: 'Cancelar',
      },
      validation: {
        required: 'Campo obligatorio',
        invalid: 'Valor inválido',
        endDateRequired: 'La fecha de término es obligatoria.',
        publishMismatch: 'Faltan o sobran tareas para los formularios del set.',
        publishMissingForms: 'Agrega al menos un formulario antes de publicar.',
        publishGeneric: 'No se pudo publicar la planificación.',
        formSyncError: 'No se pudieron guardar los cambios en los formularios. Inténtalo de nuevo.',
        publishNoAccess: 'Tu plan no incluye Planificaciones. Conoce los planes que la incluyen.',
      },
    },
    detail: {
      back: 'Volver a Planificación',
      actionsMenu: 'Más acciones',
      history: {
        title: 'Historial de cambios',
        close: 'Cerrar',
        empty: 'Sin cambios registrados.',
        addedResponsible: 'Agregó a',
        removedResponsible: 'Quitó a',
        updatedResponsibles: 'Actualizó responsables',
        effect: {
          immediate: 'Aplica de inmediato',
          next_cycle: 'Aplica desde el próximo ciclo',
          next_recalc: 'Aplica en el próximo recálculo',
        },
        fields: {
          name: 'Nombre',
          frequency: 'Frecuencia',
          ends: 'Finalización',
          end_date: 'Fecha de finalización',
          max_reps: 'Repeticiones',
          supervisors: 'Supervisores',
          cumulative: 'Programación acumulativa',
          manual_daily_average: 'Promedio diario manual',
          calculation_window_months: 'Ventana de cálculo',
          prediction_mode: 'Modo de predicción',
        },
        endsValues: {
          never: 'Nunca',
          end_date: 'En una fecha',
          max_reps: 'Tras N repeticiones',
        },
      },
      meter: {
        nextPlanning: 'Próxima planificación',
        available: 'disponible',
        overdue: 'atrasada',
        remaining: 'Faltan',
        daysRemaining: '~{days} días',
        cumulative: 'Programación acumulativa',
        closed: 'Programación cerrada',
        currentReading: 'Lectura actual',
        currentReadingDynamic: '{meter} actual',
        lastCompletedLabel: 'Último ciclo completado',
        lastCompletedAt: 'Ejecutado a {value}',
        lastReading: 'Última lectura: {when}',
        projectedDate: 'Fecha proyectada',
        lastRecalc: 'Último recálculo: {when}',
        usageRate: 'Tasa de uso',
        ratePerDay: '{value}/día',
        rateWindow: 'promedio últimos {months} meses',
        rateManual: 'tasa manual',
        noRate: 'Sin tasa disponible',
        responsibles: 'Responsables',
        asset: 'Activo',
        strategyTitle: 'Estrategia {name} - {total}',
        tasksCount: '{count} tareas',
        tasksCountOne: '1 tarea',
        projectionTitle: 'Proyección de planificación',
        columns: {
          id: 'ID',
          type: 'Tipo',
          reading: 'Lectura',
          date: 'Fecha',
          projectedDate: 'Fecha proyectada',
          tasks: 'Tareas',
          participants: 'Participantes',
          state: 'Estado',
          milestone: 'Periodo',
        },
        tasksInherited: '{count} tareas + {inherited} heredadas',
        tasksOnly: '{count} tareas',
        inheritedFrom: 'Heredada de {code}',
        status: {
          pending: 'Pendiente',
          in_progress: 'En curso',
          completed: 'Completada',
        },
        noEstimate: 'Sin fecha estimada',
        notAvailable: 'No disponible',
        pausedChip: 'Pausado',
        assetDeactivated: 'Desactivado',
        assetInactive: 'Sin actividad hace {days} días',
        pausedBannerAssetDeactivated:
          'La proyección de la planificación está pausada hasta que el activo vuelva a activarse',
        pausedBannerMeterInactive:
          'La proyección de la planificación está pausada hasta que el activo vuelva a registrar actividad.',
        pausedBannerManual: 'La proyección de la planificación está pausada.',
        projectedDateTooltip: 'Última fecha proyectada antes de pausarse la planificación',
        emptyMilestones: 'Sin proyección disponible',
        unassignedTask: 'Sin asignar',
        inheritedSuffix: ' (Heredada)',
        configTitle: 'Configuración de proyección',
        windowLabel: 'Ventana de cálculo',
        windowHelp: 'Lecturas históricas usadas para calcular la tasa de uso',
        windowValue: '{months} meses',
        rateLabel: 'Tasa de uso',
        rateHelp: 'Promedio diario de uso del equipo',
        lastUpdate: 'Última actualización: {when}',
        recalcAuto: '(recálculo automático)',
        readingsTitle: 'Lecturas recientes del medidor',
        readingsColumns: {
          date: 'Fecha',
          origin: 'Origen',
          value: 'Valor',
        },
        viewAll: 'Ver historial completo',
        emptyReadings: 'Sin lecturas registradas',
        today: 'Hoy',
        yesterday: 'Ayer',
      },
      cycleNav: 'Ciclo',
      sectionInfo: 'Información de la planificación',
      sectionTasks: 'Tareas del plan',
      updatedAgo: 'Actualizado hace {when}',
      newTask: 'Nueva tarea',
      searchTasks: 'Buscar por nombre formulario',
      emptyTasks: 'No hay tareas disponibles',
      tasksCompleted: '{completed}/{total} tareas completadas',
      planCompleted: '¡Felicidades! Tu equipo ha completado todas las tareas exitosamente',
      cycleLabel: {
        daily: 'Día',
        weekly: 'Semana',
        biweekly: 'Ciclo',
        monthly: 'Mes',
        quarterly: 'Trimestre',
        semiannual: 'Semestre',
      },
      cycleList: {
        searchPlaceholder: 'Buscar por fecha o período',
        goToCurrent: 'Ver período actual',
        empty: 'Sin ciclos para mostrar',
        noResults: 'Sin resultados',
      },
      columns: {
        id: 'ID',
        form: 'Formulario',
        user: 'Usuario',
        userAndGroups: 'Usuarios y grupos',
        startDate: 'Fecha de inicio',
        state: 'Estado',
        responses: 'Respuestas',
        actions: 'Acciones',
        duration: 'Duración: {value}',
      },
      responses: '{count}/{total} respondieron',
      userFilter: {
        title: 'Usuarios',
        popover: 'Filtra por usuario',
        empty: 'Sin usuarios',
      },
      tabs: {
        all: 'Todas',
        pending: 'Asignadas',
        accepted: 'Aceptadas',
        completed: 'Completas',
        incomplete: 'Incompletas',
        rejected: 'Rechazadas',
        cancelled: 'Canceladas',
      },
      taskStatus: {
        sent: 'Asignada',
        pending: 'Asignada',
        in_progress: 'Aceptada',
        accepted: 'Aceptada',
        completed: 'Completada',
        rejected: 'Rechazada',
        incomplete: 'Incompleta',
        cancelled: 'Cancelada',
        scheduled: 'Programada',
        deleted: 'Eliminada',
      },
      rowActions: {
        menuLabel: 'Acciones de la tarea',
        detail: 'Editar',
        viewAnswer: 'Ver respuesta',
        reassign: 'Reasignar tarea',
        notify: 'Notificar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
      },
      cancel: {
        title: 'Cancelar tarea',
        subtitle: 'Esta acción es irreversible. Indica el motivo de la cancelación.',
        reason: 'Motivo',
        reasonPlaceholder: 'Escribe la razón aquí…',
        confirm: 'Cancelar tarea',
        keep: 'Volver',
        errorAlreadyCompleted: 'No puedes cancelar una tarea ya completada.',
        errorAlreadyCancelled: 'Esta tarea ya estaba cancelada.',
        errorMissingReason: 'El motivo es obligatorio.',
        errorGeneric: 'No se pudo cancelar la tarea.',
      },
      reassign: {
        title: 'Reasignar tarea',
        subtitle: 'Selecciona un nuevo responsable.',
        confirm: 'Reasignar',
        groupLabel: 'Grupo',
        errorGeneric: 'No se pudo reasignar la tarea.',
        selectResponsible: 'Selecciona responsable',
        selectPlaceholder: 'Selecciona un responsable',
        search: 'Buscar',
        bannerText:
          'Este cambio aplica solo para este ciclo de la tarea. Los próximos ciclos seguirán asignados a',
        rowTooltipLead: 'Responsable modificado para este ciclo.',
        rowTooltipOriginal: 'Original: {name}',
      },
      pause: {
        title: 'Pausar planificación',
        body: 'Las tareas del ciclo actual seguirán visibles. No se crearán nuevos ciclos hasta reanudar.',
        confirm: 'Pausar',
      },
      resume: {
        title: 'Reanudar planificación',
        body: 'La planificación volverá a estar activa. La fecha de fin se extenderá por los días de pausa.',
        confirm: 'Reanudar',
      },
      archive: {
        title: 'Archivar planificación',
        body: 'La planificación pasa a Archivadas y sus tareas pendientes quedan congeladas. Puedes desarchivarla cuando quieras.',
        confirm: 'Archivar',
      },
      delete: {
        title: 'Eliminar planificación',
        body: 'Vas a eliminar «{name}» de tu vista. Esta acción es irreversible: sus datos se conservan en el sistema, pero no podrás recuperarla desde aquí.',
        confirm: 'Eliminar',
      },
      lifecycleErrors: {
        not_in_draft: 'Esta planificación ya fue publicada.',
        missing_forms: 'Agrega al menos un formulario antes de publicar.',
        forms_mismatch: 'El ciclo 0 no cubre exactamente los formularios requeridos.',
        already_paused: 'Esta planificación ya está pausada.',
        not_paused: 'Solo puedes reanudar una planificación pausada.',
        already_archived: 'Esta planificación ya fue archivada.',
        not_archived: 'Solo puedes desarchivar una planificación archivada.',
        rule_completed:
          'No se puede desarchivar: la agenda de la planificación ya se completó. Extiende la agenda antes de desarchivar.',
        generic: 'No se pudo completar la acción.',
      },
    },
    importDrawer: {
      title: 'Importar planificaciones',
      close: 'Cerrar',
      step1: {
        title: 'Paso 1: Descarga el archivo',
        description:
          'Descarga el archivo de ejemplo. Contendrá una hoja para configurar planificaciones y otra hoja para configurar tareas de estas. Asegúrate de campos marcados con * para importar correctamente.',
        download: 'Descargar plantilla',
      },
      step2: {
        title: 'Paso 2: Edita el archivo',
        description: 'Completa la Hoja 1 (Planificaciones) y la Hoja 2 (Tareas) según el formato.',
      },
      step3: {
        title: 'Paso 3: Sube el archivo',
        dropZone: 'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora.',
        browse: 'Seleccionar archivo',
        upload: 'Subir',
      },
      result: {
        title: 'Resultado del import',
        plannings_created: 'Planificaciones creadas',
        plannings_published: 'Planificaciones publicadas',
        tasks_created: 'Tareas creadas',
        failed: 'Fallidas',
        skipped: 'Omitidas',
        back: 'Volver a intentar',
        errors: 'Errores',
        details: 'Omitidas y advertencias',
        sheet: 'Hoja',
        row: 'Fila',
        message: 'Mensaje',
        statuses: {
          pending: 'Pendiente',
          processing: 'Procesando',
          completed: 'Completado',
          failed: 'Fallido',
        },
        entryStatuses: {
          skipped: 'Omitida',
          warning: 'Advertencia',
        },
        sheets: {
          plannings: 'Planificaciones',
          tasks: 'Tareas',
        },
        errors_global: {
          file_unreadable:
            'No pudimos leer el archivo. Asegúrate de que sea un Excel válido (.xlsx) generado desde la plantilla.',
          missing_tasks_sheet:
            'No encontramos la hoja "Tareas" en el archivo. Descarga la plantilla y úsala como base.',
          s3_download_failed: 'El archivo no se pudo recuperar. Por favor, vuelve a subirlo.',
          unknown_error:
            'Ocurrió un error inesperado durante el import. Si persiste, contacta a soporte.',
        },
        draftsCreatedWarningOne:
          'Se creó {count} planificación en borrador antes de que el import fallara. Puedes revisarla y publicarla manualmente desde la lista, o eliminarla.',
        draftsCreatedWarningOther:
          'Se crearon {count} planificaciones en borrador antes de que el import fallara. Puedes revisarlas y publicarlas manualmente desde la lista, o eliminarlas.',
      },
      errors: {
        upload: 'No se pudo subir el archivo.',
        emptyFile: 'Selecciona un archivo primero.',
      },
    },
    types: {
      title: 'Plantillas',
      back: 'Volver a planificaciones',
      createType: 'Crear plantilla',
      editAction: 'Editar',
      deleteAction: 'Eliminar',
      deleteConfirm: '¿Eliminar esta plantilla?',
      defaultBadge: 'Predeterminado',
      genericName: 'Planificación genérica (Sin personalizar)',
      form: {
        createTitle: 'Crear plantilla',
        editTitle: 'Editar plantilla',
        subtitle:
          'Define la información que estará predefinida al momento de crear la planificación',
        formsTitle: 'Formularios',
        formsSubtitle: 'Define que debe ejecutarse en esta planificación',
        addForms: 'Agregar formularios',
        iconLabel: 'Ícono',
        iconsLabel: 'Íconos',
        colorsLabel: 'Colores',
        name: 'Nombre',
        namePlaceholder: 'Escribe el nombre',
        prefix: 'Prefijo del ID',
        prefixHelper:
          'Define un prefijo para identificar fácilmente las planificaciones de este tipo. Se agregará al inicio del ID (ej: PLAN-1)',
        prefixExample: 'Las planificaciones de este tipo se numerarán como {prefix}-1',
        supervisor: 'Supervisor',
        supervisorPlaceholder: 'Selecciona los supervisores',
        frequency: 'Frecuencia de la planificación',
        allowFrequencyOverride: 'Permitir modificar frecuencia al crear planificación',
        allowFrequencyOverrideHelp:
          'Si está activo, el usuario podrá cambiar la frecuencia al crear una planificación de este tipo.',
        assetRequired: 'Requiere activo para crear planificación',
        assetRequiredHelp:
          'Si está activo, será obligatorio asignar un activo al crear una planificación de este tipo.',
        allowEdit: 'Permitir editar la planificación después de creada',
        allowEditHelp:
          'Permite actualizar la configuración de las planificaciones creadas a partir de este tipo. Los cambios solo se aplicarán a las próximas ejecuciones y no afectarán las que ya estén en curso.',
        sharedResponsibles: 'Los mismos responsables para todas las tareas',
        sharedResponsiblesHelp:
          'Las tareas de las planificaciones de este tipo comparten un único listado de responsables: se define una vez al crear la planificación y editarlo aplica a todas las tareas. Agregar una persona aplica desde ahora; quitarla rige desde el próximo ciclo y no borra lo ya hecho.',
        cancel: 'Cancelar',
        create: 'Crear',
        save: 'Guardar',
        meter: {
          cycleCardTitle: 'Configuración del ciclo',
          cycleCardSubtitle: 'Define como se dispara cada ciclo de la planificación',
          cycleTemporalTitle: 'Temporal',
          cycleTemporalDesc: 'El ciclo se programa por calendario o cada X días',
          cycleMeterTitle: 'Medidor (Requiere activo)',
          cycleMeterDesc: 'El ciclo se programa cuando el medidor alcanza un valor definido',
          meterLabel: 'Medidor',
          meterPlaceholder: 'Selecciona un medidor',
          meterHelper:
            'Solo podrás asociar activos con este medidor configurado al crear la planificación',
          strategyLabel: 'Estrategia de planificación',
          strategyPlaceholder: 'Selecciona una estrategia',
          previewTitle: 'Vista previa de la estrategia',
          inactivityPause: {
            title: 'Activar pausa automática por inactividad',
            subtitle:
              'Pausa la planificación cuando el medidor no registre nuevas lecturas y la reanuda automáticamente cuando vuelvan a registrarse.',
            checkboxLabel: 'Pausar automáticamente por inactividad del equipo',
            tooltip:
              'Si no se registran nuevas lecturas durante el período configurado, la planificación se pausará automáticamente. El supervisor recibirá una notificación por correo y la planificación se reanudará cuando vuelvan a registrarse lecturas.',
            daysPrefix: 'Después de',
            daysSuffix: 'días sin lecturas',
          },
          strategyEditor: {
            createStrategy: '+ Crear estrategia',
            title: 'Crear estrategia de planificación',
            nameLabel: 'Nombre estrategia',
            namePlaceholder: 'Ej: Estrategia 200/600 horas',
            levelsTitle: 'Niveles de planificación',
            codeLabel: 'Nombre',
            codePlaceholder: 'Ej: Inspección',
            intervalLabel: 'Umbral',
            intervalPlaceholder: 'Ej: 200',
            addLevel: 'Agregar nivel',
            removeLevel: 'Quitar nivel',
            deleteStrategy: 'Eliminar estrategia',
            save: 'Crear',
            cancel: 'Cerrar',
            createSuccess: 'Estrategia creada',
            createError: 'No pudimos crear la estrategia. Inténtalo nuevamente.',
            deleteError: 'No pudimos eliminar la estrategia. Puede estar en uso por un tipo de planificación.',
            validation: {
              nameRequired: 'Ingresa un nombre para la estrategia.',
              atLeastOne: 'Agrega al menos un nivel.',
              codeRequired: 'Cada nivel necesita un nombre.',
              positive: 'El umbral debe ser mayor que 0.',
              ascending: 'Los umbrales deben ser estrictamente ascendentes.',
              unique: 'Los umbrales no pueden repetirse.',
            },
          },
          previewEmpty: 'Selecciona una estrategia para ver el megaciclo',
          executionWindowTitle: 'Ventana de ejecución',
          executionWindowSubtitle:
            'Define cuándo se asignarán las tareas de la planificación y cuánto tiempo estarán disponibles.',
          windowStartLabel: 'Inicio de la planificación:',
          windowStartOptions: {
            one_day_before: '1 día antes',
            three_days_before: '3 días antes',
            one_week_before: '1 semana antes',
            fifteen_days_before: '15 días antes',
            on_projected_date: 'En la fecha proyectada',
          },
          durationValueLabel: 'Duración disponible',
          durationUnits: { days: 'Días', weeks: 'Semanas' },
          executionSummary:
            'Las tareas se asignarán {startLabel} de la fecha proyectada y estarán disponibles durante {value} {unit}.',
          executionSummaryOnDate:
            'Las tareas se asignarán en la fecha proyectada y estarán disponibles durante {value} {unit}.',
          accumulateLabel: 'Acumular tareas entre niveles',
          accumulateTooltip:
            'Cada nivel incluye automáticamente las tareas de los niveles anteriores. (Un nivel 3 incluirá las tareas del nivel 1 y 2)',
          levelEvery: 'Cada {interval} {unit}',
          ownCount: 'Tareas de este nivel: {count}',
          inheritedCount: 'Tareas heredadas: {count}',
          inheritedSuffix: ' (Heredada)',
          addFormToLevel: 'Agregar formulario',
          levelsEmpty: 'Selecciona una estrategia para configurar los niveles',
          removeInheritedTitle: 'Quitar formulario heredado',
          removeInheritedBody:
            'Quitar un formulario heredado es un cambio en la plantilla y afectará a las planificaciones futuras. ¿Deseas continuar?',
          removeInheritedCancel: 'Cancelar',
          removeInheritedConfirm: 'Quitar',
        },
      },
      errors: {
        prefixTaken: 'Este prefijo ya está en uso por otra plantilla.',
        deleteHasPlannings: 'No puedes eliminar un tipo con planificaciones vivas.',
        deleteLastType: 'No puedes eliminar la última plantilla.',
        generic: 'No se pudo guardar el tipo.',
      },
    },
  },
  task_assigner: {
    planning_task_tooltip: 'Parte de: {planning}',
    pricing: {
      landing: {
        availability: 'Disponible en Professional y Enterprise',
        title: 'Asigna tareas a tu equipo y haz seguimiento de su avance',
        intro:
          'Coordina el trabajo de tu equipo, monitorea el avance y mantén el control de cada tarea desde DataScope.',
        bullet1: 'Asigna tareas a personas o grupos.',
        bullet2: 'Haz seguimiento del avance y vencimientos desde DataScope.',
        bullet3: 'Exporta resultados y mantén trazabilidad del cumplimiento.',
        knowPlans: 'Conocer los planes',
        contactSales: 'Hablar con ventas',
        contactSalesIntercomMessage:
          'Hola, quiero saber más sobre Tareas asignadas y los planes que la incluyen.',
        demoTitle: '¿Qué puedes hacer con Tareas asignadas?',
        demoWebTitle: 'Asigna tareas y monitorea su estado',
        demoWebBody:
          'Crea tareas para personas o grupos y revisa su avance desde un solo lugar. Visualiza tareas pendientes, vencidas y completadas con métricas actualizadas en tiempo real.',
        demoAppTitle: 'Cada persona recibe sus tareas en la app',
        demoAppBody:
          'Las tareas llegan directamente a la app de cada responsable. Pueden completarse en terreno, con o sin conexión, y cada respuesta queda registrada para su seguimiento.',
        previous: 'Anterior',
        next: 'Siguiente',
        illustrationAlt: 'Ilustración de Tareas asignadas',
        webImageAlt: 'Vista de asignación de tareas en la web',
        appImageAlt: 'Tareas asignadas en la app móvil',
      },
    },
    planningSection: {
      title: 'Fecha y hora',
      subtitle:
        'Define en que momento del ciclo se realizará la tarea y cuánto tiempo estará disponible',
      cycleDayField: 'Día y hora de ejecución en el ciclo',
      hourField: 'Hora de ejecución del día',
      timeField: 'Hora de inicio',
      ofDays: 'De {total} días',
      ofHours: 'De {total} horas',
      durationField: 'Duración disponible',
      day: 'día',
      hour: 'hora',
      units: { hours: 'Horas', days: 'Días' },
      infoBanner:
        'La tarea estará disponible en el {cycleWord} {cycleDay} del ciclo y estará disponible durante {duration} {unit}',
      currentCycle: 'Ciclo {cycle}: Disponible del {from} al {to}',
      nextCycle: 'Ciclo {cycle}: Se reprogramará del {from} al {to}',
      allowLate: 'Permitir responder después de la fecha límite',
      scheduleTitle: 'Programar envío de la tarea',
      scheduleSubtitle:
        'Define cuántos días antes del inicio de la tarea se enviará al responsable',
      scheduleOptions: {
        start: 'Al inicio de la tarea',
        oneDay: '1 día antes',
        threeDays: '3 días antes',
        oneWeek: '1 semana antes',
      },
    },
    only_once: 'Solo una vez',
    working_days: 'Solo días hábiles',
    daily: 'Diariamente',
    weekly: 'Semanalmente',
    monthly: 'Mensualmente',
    yearly: 'Anualmente',
    custom: 'Customizado',
    task_frequency: 'Frecuencia de tareas',
    task_frequency_info:
      'La opción de frecuencia de la tarea está disponible solo cuando se asigna una única fecha',
    assigned: 'Asignadas',
    completed: 'Completas',
    pending: 'Aceptadas',
    incomplete: 'Incompletas',
    states: {
      completed: 'Completa',
      inProgress: 'Aceptada',
      pending: 'Pendiente',
      incomplete: 'Incompleta',
      rejected: 'Rechazada',
      scheduled: 'Programada',
      sent: 'Asignada',
      cancelled: 'Cancelada',
      deleted: 'Eliminada',
      projected: 'Proyectado',
    },
    cards: {
      totalTasks: 'Total tareas',
      completed: 'Completas',
      pending: 'Aceptadas',
      incomplete: 'Incompletas',
      rejected: 'Rechazadas',
      scheduled: 'Programadas',
      sent: 'Asignadas',
    },
    your_assigned_tasks: 'Tus tareas asignadas',
    filtersTitle: 'Filtros',
    filters: {
      clearFilters: 'Borrar filtros',
      dateRange: {
        title: 'Fecha',
        popoverTitle: 'Filtrar por fecha de ejecución',
      },
      location: {
        title: 'Lugar',
        popoverTitle: 'Filtrar por lugar',
        noLocations: 'No se encontraron lugares',
      },
      form: {
        title: 'Formulario',
        popoverTitle: 'Filtrar por formularios',
        inactive: 'Inactivo',
        deleted: 'Eliminado',
        forms: 'Formularios',
        folders: 'Carpetas',
        noForms: 'No se encontraron formularios',
      },
      status: {
        title: 'Estado',
        popoverTitle: 'Filtrar por estado',
      },
      user: {
        title: 'Usuarios',
        popoverTitle: 'Filtrar por usuarios',
        noUsers: 'No se encontraron usuarios',
        noGroups: 'No se encontraron grupos',
        deactivated: 'Desactivado',
        allTab: 'Usuarios',
        groupTab: 'Grupos',
      },
      taskId: {
        title: 'ID tarea',
        popoverTitle: 'Filtrar por ID tarea',
        label: 'ID tarea',
        placeholder: 'Escribe el ID',
      },
      origin: {
        title: 'Origen',
        popoverTitle: 'Filtrar por origen',
        individual: 'Individual',
        planning: 'Planificación',
        group: 'Grupal',
      },
    },
    searchBarPlaceholder: 'Buscar por nombre formulario...',
    new_task: 'Nueva Tarea',
    edit_task: 'Editar Tarea',
    edit_group_task: 'Editar tarea grupal',
    createForm: {
      title: 'Crear nueva tarea',
      usersField: {
        label: 'Usuarios',
        editLabel: 'Usuario',
        groupLabel: 'Grupo',
        addCta: '+ Agregar usuarios',
        addCtaMore: '+ Agregar usuarios',
        editAddCta: '+ Agregar usuario',
        sharedModeNotice:
          'Los responsables se definen a nivel de la planificación y aplican a todas las tareas.',
        editResponsiblesLink: 'Editar responsables',
      },
      usersDrawer: {
        title: 'Agregar usuarios',
        searchPlaceholder: 'Buscar usuario o grupo de usuarios',
        allUsersLabel: 'Usuarios',
        allGroupsLabel: 'Grupos de usuarios',
        noUsersFound: 'No se encontraron usuarios',
        noGroupsFound: 'No se encontraron grupos',
        groupMemberSingular: 'miembro',
        groupMembersPlural: 'miembros',
        alreadyAssignedTooltip: 'Ya está asignado a este formulario',
        close: 'Cerrar',
        selectTypeDescription:
          'Selecciona cómo deseas asignar esta tarea. Puedes asignarla a usuarios o grupos de usuarios.',
        usersCardTitle: 'Usuarios',
        usersCardDescription: 'Selecciona uno o más usuarios para asignar la tarea',
        groupsCardTitle: 'Grupos de usuarios',
        groupsCardDescription: 'Selecciona uno o más grupos para asignar la tarea',
        selectedSingular: 'seleccionado',
        selectedPlural: 'seleccionados',
        usersBlockedTooltip: 'Para asignar usuarios, elimina los grupos seleccionados.',
        groupsBlockedTooltip: 'Para asignar grupos, elimina los usuarios seleccionados.',
        usersLockedTooltip: 'Esta planificación asigna por grupo y no se puede cambiar a usuarios.',
        groupsLockedTooltip: 'Esta planificación asigna por usuarios y no se puede cambiar a grupo.',
        changeSelection: 'Cambiar selección',
      },
      formsField: {
        label: 'Formularios',
        editLabel: 'Formulario',
        addCta: '+ Seleccionar formularios',
        addCtaMore: '+ Seleccionar formularios',
        editAddCta: '+ Seleccionar formulario',
      },
      formsDrawer: {
        title: 'Formularios',
        infoBanner:
          'Si seleccionas varios formularios, crearás varias tareas con los seleccionados',
        searchPlaceholder: 'Buscar formulario, carpeta...',
        tabs: {
          forms: 'Formularios',
          folders: 'Carpetas',
        },
        noForms: 'No se encontraron formularios',
        deleted: 'Eliminado',
        inactive: 'Inactivo',
        close: 'Cerrar',
      },
      otherFields: {
        locationLabel: 'Lugar',
        locationPlaceholder: 'Selecciona un lugar',
        assetLabel: 'Activo',
        descriptionLabel: 'Descripción',
        descriptionPlaceholder: 'Escribe una descripción de la tarea',
      },
      subtasksField: {
        label: 'Tareas a realizar',
        placeholder: 'Escribe una tarea',
        addCta: '+ Agregar tarea',
        enterHelper: 'Presiona Enter para agregar otra tarea',
        removeAriaLabel: 'Eliminar tarea',
      },
      infoContainer: {
        title: 'Información de la tarea',
        subtitle: 'Define los detalles generales de la tarea, responsables y dónde se realizará.',
      },
      scheduleContainer: {
        title: 'Fecha y hora',
        subtitle: 'Define cuándo se realizará la tarea y cuánto tiempo estará disponible.',
        dateFieldLabel: 'Fecha y hora',
        gapFieldLabel: 'Duración de la tarea en horas',
        gapPlaceholder: 'Ej. 24',
        lateResponseLabel: 'Permitir responder después de la fecha límite',
        duration: {
          prefix: 'Duración: ',
          year: 'año',
          years: 'años',
          month: 'mes',
          months: 'meses',
          week: 'semana',
          weeks: 'semanas',
          day: 'día',
          days: 'días',
          hour: 'hora',
          hours: 'horas',
          minute: 'minuto',
          minutes: 'minutos',
          and: 'y',
        },
      },
      participationContainer: {
        title: 'Participación',
        subtitle:
          'Indica si la tarea debe ser respondida obligatoriamente o si los usuarios pueden decidir realizarla.',
        mandatoryTitle: 'Obligatoria',
        mandatoryDescription: 'Todos los usuarios deben responder la tarea',
        voluntaryTitle: 'Voluntaria',
        voluntaryDescription: 'Todos los usuarios pueden aceptar/rechazar la tarea',
        forOneTitle: 'Solo una respuesta por grupo',
        forOneDescription:
          'La primera persona que acepte la tarea la completará para todo el grupo',
      },
      remindersContainer: {
        title: 'Recordatorios',
        subtitle:
          'Las notificaciones se enviarán automáticamente según la fecha de vencimiento de la tarea.',
        question: '¿Cuánto antes del vencimiento quieres recibir un recordatorio?',
        channelsLabel: 'Canal de notificación',
        disabledChipTooltip:
          'Esta opción no puede ser seleccionada dada la actual configuración de fecha y hora de la tarea',
        timePresets: {
          min15: '15 min',
          min30: '30 min',
          hour1: '1 hora',
          day1: '1 día',
          day3: '3 días',
          week1: '1 semana',
        },
        channels: {
          notification: 'Notificación en app',
          email: 'Correo electrónico',
        },
      },
    },
    tasks: 'Tareas',
    massive_search: 'Buscar por usuario, formulario o lugar...',
    user: 'Usuario',
    form: 'Formulario',
    place: 'Lugar',
    date: 'Fecha',
    date_and_time: 'Fecha y Hora',
    gap: 'Duración',
    state: 'Estado',
    save: 'Guardar',
    users: 'Usuarios',
    users_and_groups: 'Usuarios y grupos',
    description: 'Descripción',
    hour: 'Hora',
    alert: 'alerta',
    delete: 'Eliminar',
    cancel: 'cancelar',
    accept: 'aceptar',
    notify: 'Notificar',
    view_group_detail: 'Ver detalle del grupo',
    view_group: 'Ver grupo',
    group_label: 'Grupo',
    notify_user: 'Quieres notificar a ',
    sure: '¿Estás seguro?',
    delete_task: 'Vas a borrar una tarea',
    delete_tasks: 'Quieres borrar estas tareas: ',
    reset: 'Restablecer',
    old_version: 'Version Antigua',
    task_created: 'Tarea Creada',
    our_problem: 'Tenemos un problema',
    task_update: 'Tarea actualizada con éxito',
    export: 'Exportar',
    date_necessary: 'Es necesaria una fecha',
    required: 'Requerido',
    blanck: 'Hay campos vacios',
    notification_sent: 'Notificación enviada con éxito',
    notification_skipped: 'La tarea no admite notificación en su estado actual',
    notifications_sent: 'Notificaciones enviadas con éxito',
    tasks_delete:
      'Tareas eliminadas con éxito. Espera unos minutos para ver los cambios reflejados.',
    task_delete: 'Tarea eliminada con éxito',
    new_place: 'Nuevo lugar',
    start: 'Comienzo',
    end: 'Final',
    history: 'Historial',
    actions: 'Acciones',
    dobleClick: 'Doble click en la tarea = abrir detalles',
    shiftMouse: 'shift + rueda del ratón = mover cronograma izquerda/derecha',
    altMouse: 'alt + rueda del ratón = zoom in/out',
    timeline: 'Cronograma',
    taskAssignID: 'ID tarea asignada',
    selected_range: 'Rango seleccionado',
    notifications: 'Agregar notificaciones',
    add_notification: 'Agrega una notificación',
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    weeks: 'semanas',
    months: 'meses',
    years: 'años',
    notification: 'Notificación',
    email: 'Email',
    max_one_date: 'Máximo una fecha en modo edición',
    max_one_user: 'Máximo un usuario en modo edición',
    no_location_warning: 'No se ha especificado un lugar, o este puede haber sido eliminado.',
    showing_results_for: 'Mostrando resultados para',
    task: 'Tarea',
    no_tasks_available: 'No tienes tareas disponibles en este momento',
    gap_hours: 'Duración de la tarea en horas',
    allow_late_submission:
      'Permitir responder la tarea posterior a que se haya cumplido la fecha establecida',
    add_tasks: 'Agregar tareas',
    add_tasks_caption:
      'Puedes agregar tareas rápidamente separándolas con comas "," o presionando Enter',

    configuration: 'Configuración',
    voluntary_task:
      'Hacer voluntaria esta tarea (Todos los usuarios pueden aceptar/rechazar la tarea)',
    mandatory_task: 'Hacer obligatoria esta tarea (Todos los usuarios deben responder la tarea)',
    notification_type: 'Tipo de notificación',
    notification_time: 'Tiempo',
    notification_period: 'Periodo de tiempo',
    app_notification: 'Notificación en app',
    confirmation_title_prefix: '¿Estás seguro que quieres crear ',
    confirmation_title_suffix: ' tareas?',
    confirmation_title_suffix_singular: ' tarea?',
    confirmation_title_suffix_one: 'tareas por',
    confirmation_title_suffix_one_singular: 'tarea por',
    confirmation_title_suffix_two: 'días?',
    edit_confirmation_title: '¿Estás seguro de que deseas editar esta tarea?',
    success_message:
      '¡Tareas creadas exitosamente! Por favor, espera unos segundos para que se reflejen. Recuerda refrescar la página para visualizarlas.',
    update_success_message: '¡Tarea actualizada exitosamente!',
    forms_info: 'Si seleccionas varios formularios, crearás varias tareas con los seleccionados',
    asset: 'Activo',
    asset_autocomplete_hint: 'El activo asignado se autocompletará en el formulario si corresponde',
    filters_asset_title: 'Activo',
    edit: 'Editar',
    show_answer: 'Ver respuesta',
    notify_title: '¿Estás seguro que quieres notificar al siguiente usuario?',
    bulk_notify_title: '¿Estás seguro que quieres notificar a los siguientes usuarios?',
    notify_group_title: '¿Estás seguro que quieres notificar a los usuarios del siguiente grupo?',
    edit_group_title: '¿Estás seguro que quieres editar esta tarea?',
    edit_group_description:
      'Esta tarea solo se puede editar para los usuarios que no la han comenzado. ¿Deseas continuar?',
    continue_action: 'Continuar',
    delete_title: '¿Estás seguro que quieres eliminar esta tarea?',
    delete_description: 'Se eliminará  y no la podrás recuperar',
    delete_group_description: 'Se eliminará para todos los usuarios y no la podrás recuperar',
    delete_member_description:
      'Si la eliminas, desaparecerá de la lista de tareas pendientes del usuario y no la podrá responder',
    bulk_delete_title_one: '¿Estás seguro que quieres eliminar',
    bulk_delete_title_two: 'tareas?',
    bulk_delete_description:
      'Si las eliminas, desaparecerá de la lista de tareas pendientes de los usuarios y no las podrán responder',
    bulk_actions: 'Acciones masivas',
    creation_date: 'Fecha creación',
    start_date: 'Fecha inicio',
    answers: 'Respuestas',
    backToTasks: 'Volver a Tareas',
    groupDetail: {
      searchPlaceholder: 'Buscar por usuario o correo',
      emailColumn: 'Correo',
      onTimeColumn: 'A tiempo',
      onTimeYes: 'Sí',
      onTimeNo: 'No',
      emptyMembers: 'Esta tarea grupal no tiene miembros asignados',
      answerDrawerTitle: 'Respuesta del miembro',
      bulkSelectedSingular: 'seleccionado',
      bulkSelectedPlural: 'seleccionados',
      bulkDeleteTitle: 'Eliminar miembros seleccionados',
      bulkDeleteText:
        '¿Estás seguro que quieres eliminar %{count} miembros de esta tarea grupal? Los miembros que ya respondieron no se eliminarán.',
      bulkDeleteSummary: '%{deleted} eliminados, %{skipped} omitidos',
      bulkNotifyTitle: 'Notificar miembros seleccionados',
      bulkNotifyText:
        '¿Estás seguro que quieres notificar a los %{count} miembros seleccionados? Solo se enviará la notificación a los miembros pendientes.',
      mandatoryBanner: {
        for_everyone: 'Esta tarea tiene configurada la opción: Respuesta obligatoria',
        for_nobody: 'Esta tarea tiene configurada la opción: Respuesta voluntaria',
        for_one: 'Esta tarea tiene configurada la opción: Permitir que solo una persona responda',
      },
    },
    duration: 'Duración:',
    answered: 'respondieron',
    out_of_time: 'Fuera de tiempo',
    late: 'tarde',
    no_location: 'Sin lugar',
    task_does_not_exist: 'La tarea no existe',
    location_copied: 'Lugar copiado al portapapeles',
    completed_tasks_cannot_be_deleted: 'Las tareas completadas no pueden ser eliminadas',
    some_tasks_skipped_due_to_answers:
      'Se omitieron %{count} tarea(s) porque ya tienen respuestas y no pueden eliminarse',
    no_tasks_were_modified: 'No se modificó ninguna tarea',
    complete_task: 'Completar tarea',
    complete_task_description: '¿Quieres completar esta tarea ahora?',
    complete_task_button: 'Completar',
    reject_task_button: 'Rechazar',
    accept_task_button: 'Aceptar',
    accept_reject_confirmation:
      'Puedes aceptarla y completarla, o rechazarla si no puedes realizarla.',
    import: {
      title: 'Importar Tareas',
      step1Title: 'Paso 1: Descargar plantilla',
      step1Description:
        'Descarga el archivo Excel de ejemplo. Asegúrate de completar los campos marcados con * para importar tu archivo correctamente.',
      downloadExample: 'Descargar ejemplo',
      step2Title: 'Paso 2: Editar el archivo',
      step2Description:
        'Completa la plantilla con los datos de tus tareas. Asegúrate de que todos los campos requeridos estén completados.',
      step2MoreInfo: 'Más información aquí',
      step3Title: 'Paso 3: Subir tu archivo',
      step3Description:
        'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora. Podría tardar unos minutos en procesarse.',
      dragDropText: 'Arrastra y suelta tu archivo Excel aquí',
      browseText: 'o búscalo en tu computador',
      replaceText: 'Reemplazar',
      fileUploadedText: 'Tu archivo ha sido cargado',
      fileUploadError: 'Tu archivo no pudo ser cargado',
      invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
      importError: 'Error al importar tareas',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      success: 'Tareas importadas con éxito. Espera unos segundos para que se reflejen.',
      errorTitle: 'Detectamos un error.',
      templateDownloadError: 'Error al descargar la plantilla',
      downloadingTemplate: 'Descargando...',
      baseTemplateUrl: 'https://s3-us-west-2.amazonaws.com/data-scope/templates/',
      templateFileLegacy: `task_assign_es3_v1.xlsx`,
      templateFileV5: `task_assign_es_v5.xlsx`,
      templateFileLegacyV6: `task_assign_es3_v2.xlsx`,
      templateFileV6: `task_assign_es_v6.xlsx`,
      templateFileGroupV6: `task_assign_es_v6_group.xlsx`,
      requirements: {
        title: 'Requisitos del archivo',
        uniqueIds: "Evita valores repetidos en 'ID'.",
        duplicateIdMessage: "El ID '{id}' está repetido. Se usará el último valor.",
        formNameComplete: "Columna 'Nombre Formulario' completa.",
        missingFormNameMessage: "Falta el nombre del formulario en '{cell}'.",
        missingFormNameColumn: "No se encontró la columna 'Nombre Formulario'.",
        userEmailComplete: "Si es una tarea individual, 'Email Usuario' completa.",
        userEmailCompleteLegacy: "Columna 'Email Usuario' completa.",
        missingUserEmailMessage: "Falta el correo del usuario en '{cell}'.",
        missingUserEmailColumn: "No se encontró la columna 'Email Usuario'.",
        groupFieldsComplete:
          "Si es una tarea grupal, 'Nombre del grupo' y 'Tipo de asignación' completas.",
        missingGroupNameMessage: "Falta el nombre del grupo en '{cell}'.",
        missingAssignmentTypeMessage: "Falta el tipo de asignación en '{cell}'.",
        dateAndGapComplete: "Columnas 'Fecha/Hora Inicio' y 'Margen de horas' completas.",
        missingStartDateMessage: "Falta la fecha de inicio en '{cell}'.",
        missingStartDateColumn: "No se encontró la columna 'Fecha/Hora Inicio'.",
        missingGapMessage: "Falta el margen de horas en '{cell}'.",
        missingGapColumn: "No se encontró la columna 'Margen de horas'.",
        seeMore: 'Ver {count} más',
        seeLess: 'Ver menos',
      },
      confirmIncomplete: {
        title: 'Algunas filas están incompletas',
        body: 'Detectamos {skipped} de {total} fila(s) con datos incompletos en campos obligatorios. Esas filas serán omitidas y se importará(n) {valid} fila(s) válida(s). ¿Quieres continuar?',
        cancel: 'Cancelar',
        confirm: 'Importar {valid} fila(s)',
      },
      helpUrl:
        'https://help.mydatascope.com/es/articles/2852072-como-importar-tareas-de-forma-masiva',
      errors: {
        invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
        importError:
          'Error al importar tareas. Por favor, verifica que tus datos tengan el formato correcto.',
        templateDownloadError: 'Error al descargar la plantilla',
        errorTitle: 'Detectamos un error.',
      },
    },
    import_audit: {
      title: 'Historial de importaciones',
      tab: 'Historial',
      menuImportNow: 'Importar ahora',
      menuViewHistory: 'Ver historial',
      genericImportError:
        'Hubo un problema al procesar esta importacion. Si el problema persiste, contacta a soporte.',
      taskImportsTab: 'Tareas importadas',
      backToTasks: 'Volver a Asignar tareas',
      rowsTitle: 'Filas',
      emptyState: 'No hay importaciones recientes',
      viewDetails: 'Ver detalle',
      back: 'Volver a historial',
      retrySuccess: 'Tarea creada correctamente',
      retryError: 'No se pudo crear la tarea',
      statuses: {
        pending: 'Pendiente',
        processing: 'Procesando',
        completed: 'Completada',
        failed: 'Fallida',
        created: 'Creada',
        updated: 'Actualizada',
        skipped: 'Omitida',
        resolved_manually: 'Resuelta',
      },
      error_codes: {
        task_form_not_found: 'Formulario no encontrado',
        mobile_user_not_found: 'Usuario no encontrado',
        date_unparseable: 'Fecha invalida',
        assign_id_in_use: 'ID en uso (tarea en progreso o completada)',
        validation_failed: 'Error de validacion',
      },
      columns: {
        file: 'Archivo',
        date: 'Fecha',
        triggeredBy: 'Importado por',
        status: 'Estado',
        summary: 'Resumen',
        rowNumber: 'Fila',
        assignId: 'ID tarea',
        task: 'Formulario',
        user: 'Usuario',
        error: 'Error',
        actions: 'Acciones',
      },
      summary: {
        read: '%{n} leidas',
        created: '%{n} creadas',
        updated: '%{n} actualizadas',
        failed: '%{n} fallidas',
        skipped: '%{n} omitidas',
      },
      fixAndRetry: 'Corregir',
      resolvedBy: 'Resuelta por',
      resolvedByHelp: 'Usuario que corrigio y reintento esta fila manualmente',
      resolvedAssignId: 'ID asignado',
      locationCreated: 'Lugar creado automaticamente',
      idReplaced: 'ID solicitado: %{requested} — usado: %{used}',
      changedFields: 'Cambios',
      fixModal: {
        title: 'Corregir fila %{row}',
        submit: 'Crear tarea',
        cancel: 'Cancelar',
        submitting: 'Creando...',
      },
    },
    exportModal: {
      title: 'Exportar tareas asignadas',
      bannerWithRange:
        'Se exportarán las tareas cuya fecha de ejecución se encuentre dentro del rango de fechas %{from} - %{to}',
      bannerWithoutRange: 'Se exportarán las tareas según los filtros aplicados',
      filenameLabel: 'Nombre del archivo',
      filenameHelp: 'Puedes cambiar el nombre antes de exportar',
      cancel: 'Cancelar',
      submit: 'Exportar',
      defaultFilenamePrefix: 'tareas-asignadas-exportadas',
    },
    integrations: {
      button: 'Google Sheets',
      title: 'Integración Tareas Asignadas',
      gsheetsIntegrationLabel: 'Ir a Google Sheets',
      gsheetsNewLinkUrl: 'https://sheets.new/',
      infoTextPart1:
        'Para garantizar una integración adecuada, privada y segura, comparte tu documento con permisos de',
      infoTextPart2: 'editor',
      infoTextPart3: 'únicamente a',
      inputLabel: 'Nuevo enlace',
      inputPlaceholder: 'Ingresa el enlace del documento a integrar',
      optional: '(Opcional)',
      save: 'Guardar',
      cancel: 'Cancelar',
      copyUrl: '¡URL copiada!',
      copyEmail: '¡Correo copiado!',
      created: '¡Integración configurada exitosamente!',
      saved: '¡Cambios guardados con éxito!',
      deleted: 'Integración eliminada con éxito',
      savingError: 'Error al configurar la integración',
      removeTitle: '¿Quitar la integración con Google Sheets?',
      removeBody:
        'La hoja dejará de recibir actualizaciones de tareas asignadas desde DataScope. El documento en Google Drive no se elimina.',
      removeConfirm: 'Quitar integración',
      removeCancel: 'Cancelar',
    },
  },
  form_answer: {
    answer_again: 'Responder de nuevo',
    submit_button: 'Enviar',
    edit_button: 'Editar',
    edit_form: 'Editar formulario',
    incomplete_edit_alert: 'Debes responder todas las preguntas requeridas',
    incomplete_submit_alert: 'Aún no subes ninguna respuesta',
    error_submit_alert: 'Hubo un error al intentar subir tu respuesta',
    error_edit_alert: 'Hubo un error al intentar editar tu respuesta',
    sync_pending_message:
      'Esta respuesta aún se está sincronizando. Podrás editarla en unos momentos.',
    no_edit_alert: 'No has editado tu respuesta aún',
    no_answer_alert: 'Tu respuesta esta vacía',
    required_question: 'Esta pregunta es obligatoria',
    withinMarginRangeError: 'Ingresa una lectura entre {min} y {max}.',
    withinMarginMinimumError: 'Ingresa una lectura mayor o igual que {min}.',
    withinMarginExactError: 'Ingresa exactamente {min}.',
    no_options: 'No hay opciones',
    invalid_question_type_1: 'Pregunta de tipo ',
    invalid_question_type_2:
      'Este tipo de pregunta no puede ser respondida/editada en nuestra plataforma web. Por favor descargue la aplicación móvil de DataScope.',
    some_invalid_question_types:
      'Advertencia: Este formulario incluye tipos de pregunta no válidos para la versión web de DataScope.',
    download_mobile: 'Descarga nuestra aplicación móvil aquí',
    download_mobile_link: 'https://datascope.page.link/3N7P',
    answer_placeholder: 'Tu respuesta',
    simple_text_placeholder: 'Tu respuesta de texto',
    text_rut_placeholder: 'Tu RUT de respuesta',
    text_container_placeholder: 'Tu ID de contenedor',
    invalidRutError: 'RUT inválido',
    invalidContainerError: 'ID de contenedor inválido',
    text_email_placeholder: 'Tu email de respuesta',
    select_your_date: 'Selecciona una fecha',
    select_your_datetime: 'Selecciona fecha y hora',
    select_your_time: 'Selecciona un horario',
    datetime_errors: {
      invalidDate: 'Fecha inválida',
      minDate: 'La fecha no alcanza el mínimo permitido',
      maxDate: 'La fecha supera el máximo permitido',
    },
    add_repeatable_questions: 'Agregar otro grupo de preguntas',
    signature_type: 'Firma',
    photo_type: 'Foto',
    barcode_type: 'Código de barras',
    filter_elements: 'Buscar elemento...',
    exact_match: 'Coincidencia exacta',
    exact_match_tooltip: 'Busca el texto exactamente como fue escrito',
    search_suggestions_title: 'Sugerencias de búsqueda',
    search_action: 'Buscar',
    search_general_hint: 'Búsqueda general en preguntas y respuestas',
    search_exact_hint: 'Coincidencia exacta de la frase',
    upload_image: 'Subir Imagen',
    no_image_loaded: 'No se ha subido ninguna imágen',
    upload_file: 'Subir Archivo',
    uploading_file: 'Subiendo...',
    unsupported_file_type: 'Este tipo de archivo no está permitido para esta pregunta',
    exceeded_max_number_files:
      'Has excedido la cantidad máxima de archivos permitidos para esta pregunta',
    image_max_size_exceeded: 'Uno o más de sus archivos superan el límite de',
    image_max_amount_exceeded_part_one: 'Puedes subir hasta',
    image_max_amount_exceeded_part_two: 'imágenes por comentario',
    image_upload_error: 'Ocurrió un error subiendo las imágenes, por favor intente nuevamente',
    photo_gps_notice: 'Las imágenes cargadas desde el navegador pueden no incluir ubicación GPS.',
    no_signature_loaded: 'No has cargado ninguna firma',
    clear: 'Limpiar',
    save_canvas: 'Guardar',
    modify_signature: 'Modificar',
    next: 'Siguiente',
    previous: 'Atrás',
    success_message: 'Hemos recibido tu respuesta correctamente',
    download_app_suggestion:
      '¿Buscando una forma más conveniente y más rápida de responder tus formularios?',
    confirm_section_change:
      'Esta sección tiene una pregunta obligatoria que aún no ha respondido correctamente. ¿Desea continuar de todos modos?',
    load_more_data: 'Cargar más datos',
    no_data_left: 'No quedan datos para cargar',
    clear_all: 'Borrar todo',
    no_header_warning:
      'El creador de esta pregunta no especificó los encabezados de lista de las listas relacionadas.',
    more_answers_alert: 'Baja para ver más',
    subform_limit: 'Límite de grupos de preguntas alcanzado',
    subform_min: 'Por favor agrega el número mínimo de respuestas',
    multi_option_placeholder: 'Selecciona una opción',
    locked_asset_hint: 'Este activo fue asignado en la tarea',
    image: 'Imagen',
    download: 'Descargar',
    multiple_options: 'Selecciona múltiples opciones',
    group: 'Grupo',
    start: 'Comienzo',
    end: 'Fin',
    invalid_date: 'Fecha inválida',
    invalid_time: 'Hora inválida',
    invalid_datetime: 'Fecha y Hora inválida',
    locationUpdate: {
      description: 'Debes seleccionar una opción para cambiar su lugar',
      lastLocationLabel: 'Último lugar',
      currentLocationLabel: 'Lugar actual',
      currentLocationPlaceholder: 'Selecciona una opción',
    },
    optionComments: {
      addNote: 'Añadir una nota',
      removeNote: 'Eliminar nota',
      writeComment: 'Escribe un comentario...',
      requiredNote: 'Comentario requerido',
      addNoteMobile: 'Nota',
      addImage: 'Adjuntar Imagen',
      addImageMobile: 'Imagen',
      removeNoteMobile: 'Eliminar',
      requiredImage: 'Imagen requerida',
      requiredFinding: 'Ticket requerido',
      deleteImageWarningTitle: '¿Estás seguro que quieres eliminar esta imagen?',
      deleteImageWarningSubTitle: 'Una vez que la elimines, no la podrás recuperar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
    },
    drag_drop_file: 'Arrastra y suelta aquí tus archivos',
    or_browse_for_file: 'o búscalos en tu computador',
    missingRequiredAnswersAlert:
      '¡Ups! Parece que aún faltan algunas preguntas por responder. Por favor, completa todas las preguntas requeridas para poder continuar.',
    totalPercentage: 'Porcentaje total',
    enterSampleTotal: 'Ingresa el total de la muestra',
    forbidden_access:
      'Parece que no tienes permiso para editar este formulario. Solicítalo para poder realizar modificaciones',
    automated_signature_on_response:
      'Este formulario tiene firma configurada. La solicitud se enviará a los usuarios asignados al finalizar el formulario.',
    electronic_signature: 'Firma electrónica',
    sign_now: 'Firmar ahora',
    sign_later: 'Firmar más tarde',
    sign_modal_description: 'Este formulario requiere tu firma, ¿quieres firmar ahora?',
    leave_form_title: 'Estás saliendo del formulario',
    leave_form_message:
      'Tienes cambios sin guardar en esta respuesta. Si sales de esta vista ahora, se perderán. ¿Deseas salir y descartar los cambios?',
    leave_stay_button: 'Seguir editando',
    leave_confirm_button: 'Salir y descartar',
    exit_form_title: 'Salir del formulario incompleto',
    exit_form_message: '¿Está seguro de que quiere salir del formulario?',
    exit_cancel_button: 'Cancelar',
    exit_confirm_button: 'Sí',
    draft_found_title: 'Se encontró un borrador',
    draft_found_message:
      'Tienes respuestas guardadas de una sesión anterior en este formulario. ¿Cómo quieres continuar?',
    draft_continue_button: 'Continuar con el borrador',
    draft_start_fresh_button: 'Comenzar uno nuevo',
    draft_recovered_banner:
      'Borrador recuperado. Revisa los adjuntos y campos de firmas en caso de aplicar.',
    signature_creation_failed: 'Hubo un error al firmar el formulario',
    saveSuccessAndRedirect: '¡Respuesta guardada correctamente! Redirigiendo a tus firmas...',
    saveAndSignSuccessAndRedirect:
      '¡Respuesta guardada y firmada correctamente! Redirigiendo a tus firmas...',
    subtasks: 'Tareas',
    editingActivity: 'Editando actividad',
    selectActivityAndDuration: 'Selecciona actividad y duración',
    update: 'Actualizar',
    add: 'Agregar',
    to: 'a',
    activityPlaceholder: 'Actividad',
    durationPlaceholder: 'Duración',
    durationExceedsLimit: 'La duración supera el tiempo restante',
    cancel: 'Cancelar',
    requiredQuestionIncomplete: 'Todas las horas de trabajo deben ser asignadas',
    deleteActivityMessage: '¿Estás seguro de querer eliminar esta actividad?',
    allActivitiesRegistered: 'Todas las horas asignadas',
    workingTimeNotSet: 'Horas de trabajo no establecidas',
    remainingTimePrefix: 'Te falta asignar',
    activityNotSelected: 'Actividad faltante',
    editActivity: 'Editar',
    insertBelow: 'Insertar abajo',
    deleteActivity: 'Eliminar',
    addActivity: 'Agregar actividad',
    noAssignedLocations:
      'No tienes lugares asignados para este formulario. Contacta a tu administrador.',
    filterAssetsByLocationBlocked: 'Selecciona primero un lugar para ver los activos disponibles.',
    filterAssetsByLocationNoAssets: 'El lugar seleccionado no tiene activos asignados.',
  },
  percentage: 'Porcentaje',
  build_your_own_form: 'Construye tu propio formulario con DataScope',
  back_to_taskForms: 'Volver a lista de formularios',
  date_fns: 'es',
  yes: 'Sí',
  no: 'No',
  insert_value: 'Inserte un valor',
  and: 'Y',
  invalidEmail: 'Email inválido',
  ok: 'OK',
  group: 'Grupo',
  folder: 'Folder',
  clearAll: 'Borrar todos',
  users: 'Usuarios',
  forms: 'Formularios',
  actions: 'Acciones',
  select: 'Seleccionar',
  selectAll: 'Seleccionar todos',
  form_builder: {
    formName: 'Nombre del formulario',
    saveForm: 'Guardar',
    title: 'Título',
    titleDescription: 'Título corto para identificar la pregunta. Aparece al exportar los datos.',
    instruction: 'Descripción',
    instructionDescription:
      'Texto más extenso para mostrar en la app. No aparece al exportar datos (Opcional)',
    questionType: 'Cambiar tipo de pregunta',
    copy: 'Duplicar pregunta',
    delete: 'Eliminar pregunta',
    add: 'Agregar nueva pregunta',
    advanced: 'Opciones avanzadas',
    type: 'Tipo',
    date: 'Fecha',
    dateAndTime: 'Fecha y Hora',
    time: 'Hora',
    alternativeColumns: 'Columnas alternativas',
    addOption: 'Agregar opción',
    dataListSource: 'Fuente lista datos',
    changeDataList: 'Cambiar lista de datos',
    listValues: 'Valores lista',
    addListValue: 'Agregar valor lista',
    deleteAlternative: 'Eliminar alternativa',
    required: 'Obligatorio',
    validateRutChile: 'RUT (Chile)',
    validateMail: 'Correo electrónico',
    validateContainer: 'ID de contenedor',
    validate: 'Validar',
    codeType: 'Cambiar tipo de código',
    disableGallery: 'Deshabilitar galería',
    maxImagesPerItem: 'Max. imágenes por ítem',
    moveUp: 'Mover hacia arriba',
    moveDown: 'Mover hacia abajo',
    alternative: 'Alternativa',
    snackBarShared: 'invitaciones enviadas',
    snackBar: 'Tu formulario se ha guardado correctamente!',
    activityStartTimeRequired: 'Define la hora de inicio de la jornada para continuar.',
    newListData: 'Nueva Lista De Datos',
    section: 'Agregar Sección',
    sectionName: 'Sección sin nombre',
    duplicateSection: 'Duplicar sección',
    deleteSection: 'Eliminar sección',
    delSectionsQuestions: 'Eliminar seccion y preguntas',
    areYouSure: '¿Estás seguro/a?',
    cancel: 'Cancelar',
    sectionAlertOne:
      'Se eliminará la sección, pero las preguntas se sumarán a la sección anterior.',
    sectionAlertTwo: 'Se eliminará la sección y también las preguntas que contiene.',
    yesDelete: 'Sí, eliminar',
    questionAlert: 'Esta pregunta se eliminará de forma permanente',
    questionAlertWithAssetLinksPrefix:
      'Esta pregunta se eliminará de forma permanente junto con sus ',
    questionAlertWithAssetLinksHighlight: 'vinculaciones a datos del activo',
    copyName: 'Copia',
    nameAlert: 'Las preguntas deben tener nombres distintos.',
    isRepeated: 'está repetido.',
    if: 'si',
    is: 'es',
    to: 'a',
    goTo: 'ir a',
    sectionNameTag: 'Nombre sección',
    skipQuestions: 'Saltar preguntas',
    equal: 'igual',
    dif: 'diferente',
    contains: 'contiene',
    notContains: 'no contiene',
    empty: 'vacía',
    notEmpty: 'no vacía',
    skipOnlyMobile: 'Solo aplica para formularios móviles',
    disableSkip: 'Este tipo de pregunta no está habilitada para saltos',
    next: 'siguiente pregunta',
    end: 'terminar formulario',
    payingAlert:
      'Esta funcionalidad no está disponible en el plan gratuito, debe activar su plan en la configuración / facturación.',
    showPercent: 'Mostrar porcentaje',
    showSamplingPercent: 'Mostrar porcentaje muestreo',
    showPrice: 'Mostrar precio',
    showAvg: 'Mostrar promedio',
    showFactor: 'Mostrar multiplicación',
    camQuality: 'Calidad de cámara',
    high: 'Alta',
    mid: 'Media',
    low: 'Baja',
    recommended: 'recomendado',
    photoAlert: 'la sincronización podría tardar más',
    sectionNameAlert:
      'No deberían existir secciones con el mismo nombre. Por favor renombra la sección: ',
    formatType: 'Tipos de formato',
    audioDuration: 'Duración de audio',
    secondsLabel: 'segundos',
    cannotCombineWithVoiceAudioRecording: 'No se puede combinar con grabación de audio',
    anyIncludeAllFormatsExceptVoiceAudioRecording:
      'Cualquiera incluye todos los tipos de archivo, excepto grabación de audio',
    voiceAudioRecording: 'Grabación de audio',
    any: 'Cualquiera',
    howToCreate: 'Cómo crear formularios',
    good: 'Bueno',
    regular: 'Regular',
    bad: 'Malo',
    newOption: 'Nueva opción',
    moveSection: 'Mover sección',
    oldShareForm: 'Comparte este form con un enlace público',
    shareForm: 'Enlace Formulario',
    shareEmail: 'Comparte via email',
    shareWhatsapp: 'Comparte via WhatsApp',
    shareWhatsappMessage: 'Envía tu formulario junto con un mensaje a través de WhatsApp',
    shareWhatsappMessageApi: 'Hola, te invito a responder el formulario {form_name}: ',
    formMadePublic: 'Se ha habilitado el link del formulario',
    undoFormPublic: 'El link del formulario se ha deshabilitado',
    shareForm2: 'Comparte este formulario',
    shareFormTip:
      'Cualquier persona, tanto usuarios registrados como no registrados, podrá completar este formulario web si comparte el enlace público con ellos. Sus respuestas quedarán registradas a nombre de un usuario genérico.',
    shareFormOn: 'Hacer este formulario público',
    shareFormOff: 'Remover acceso público',
    shareViaEmailTip: 'Puedes incluir más de un correo con enter, espacio o coma',
    quantity: 'Cantidad máxima de archivos',
    new: 'Nuevo!',
    warning: 'Temporalmente sólo disponible para formularios web',
    testYourForm1: 'Descarga nuestra App oficial en ',
    testYourForm2: 'Posteriormente puedes iniciar sesión con estas mismas credenciales.',
    testYourForm3: '¡Prueba tu formulario en nuestra app!',
    testYourForm4:
      '¡Escanea este código QR con la cámara de tu celular para visualizar tu formulario!',
    testYourForm5:
      '¡Escanea este código QR con la cámara de tu celular para descargar nuestra app y visualizar tu formulario!',
    copyLink: 'Copiar enlace',
    copiedLink: 'Copiado!',
    visitForm: 'Visitar',
    accessYourForm: 'Accede a tu formulario aquí',
    downloadApp: 'Descarga nuestra app',
    ok: 'ok',
    and: 'y',
    greater: 'Mayor que',
    greaterOrEqual: 'Mayor o igual que',
    less: 'Menor que',
    lessOrEqual: 'Menor o igual que',
    between: 'Entre',
    notBetween: 'No está entre',
    betweenQuestionOffset: 'Entre valor pregunta y desplazamiento',
    withinMargin: 'Dentro del margen de la última lectura',
    withinMarginBack: 'Margen hacia atrás',
    withinMarginForward: 'Margen hacia adelante',
    withinMarginLastReading: 'la última lectura del medidor',
    withinMarginExactly: 'exactamente',
    withinMarginRequiresMeter: 'Requiere usar esta pregunta para actualizar un medidor',
    withinMarginNotInRepeatable: 'No disponible dentro de un grupo de preguntas repetibles',
    withinMarginUnlinkedWarning: 'Esta validación no se aplicará hasta que la pregunta vuelva a estar vinculada a un medidor.',
    withinMarginInert: 'Esta validación está desactivada por ahora. La configuración se conserva y volverá a aplicarse cuando se reactive.',
    // Keys here are intentionally duplicated from form_builder's numeric-mode
    // keys rather than cross-read (see betweenQuestionOffset vs.
    // form_builder.betweenQuestionOffset above) — a numeric-mode rewording
    // should never silently change this panel. Divergent wording between the
    // two ("Entre pregunta y desplazamiento" vs. "Entre valor pregunta y
    // desplazamiento") is deliberate per D19, not a typo to unify.
    dateValidation: {
      addValidation: 'Agregar validación',
      validationType: 'Tipo de validación',
      fixedRange: 'Rango fijo',
      fixedRangeDescription: 'En relación a la fecha de la respuesta',
      fixedRangeDescriptionTime: 'En relación a la hora de la respuesta',
      relativeRange: 'Rango relativo',
      relativeRangeDescription: 'En relación a otra pregunta de fecha del formulario',
      relativeRangeDescriptionTime: 'En relación a otra pregunta de hora del formulario',
      rangeCondition: 'Condición temporal',
      selectRangeCondition: 'Selecciona una opción',
      predefinedConditions: 'Predefinidas',
      customConditions: 'Personalizadas',
      offset: 'Desplazamiento',
      hours: 'horas',
      days: 'días',
      day: 'día',
      hour: 'hora',
      timeModeWarning: 'Hora no considera cambios de día. Usa Fecha y hora para rangos entre días.',
      relativeTimeModeWarning:
        'Hora no considera cambios de día. Usa Fecha y hora para comparar entre días.',
      pickQuestion: 'Selecciona una pregunta',
      noQuestionsAvailable: 'No hay preguntas disponibles para comparación',
      validationComparisonType: 'Tipo de comparación',
      betweenQuestionOffset: 'Entre pregunta y desplazamiento',
      minimumValue: 'Valor mínimo',
      maximumValue: 'Valor máximo',
      and: 'y',
      minimumValueForOffsetIs: 'El desplazamiento mínimo permitido es de',
      maximumValueForOffsetIs: 'El desplazamiento máximo permitido es de',
      onlyToday: 'Solo hoy',
      noFutureDates: 'No permitir fechas futuras',
      noPastDates: 'No permitir fechas pasadas',
      onlyCurrentTime: 'Solo hora actual',
      noFutureTimes: 'No permitir horas futuras',
      noPastTimes: 'No permitir horas pasadas',
      after: 'Después que',
      afterOrEqual: 'Después o igual que',
      before: 'Antes que',
      beforeOrEqual: 'Antes o igual que',
      between: 'Entre',
      notBetween: 'No está entre',
      rangeValidationErrorMessageForDate: 'El valor debe ser de al menos 1 día.',
      rangeValidationErrorMessageForTime: 'El valor debe estar entre 1 y 23 horas.',
      rangeValidationErrorMessageForDateTime: 'El valor debe ser de al menos 24 horas.',
      notBetweenTimeWindowTooWideMessage: 'La suma de ambos valores debe ser menor a 24 horas.',
      date_only_today: 'Selecciona la fecha de hoy.',
      date_no_future: 'Ingresa una fecha igual o anterior a hoy.',
      date_no_past: 'Ingresa una fecha igual o posterior a hoy.',
      date_after_tomorrow: 'Ingresa la fecha de mañana.',
      date_after_days:
        'Ingresa una fecha desde mañana hasta los próximos {{numOfOffsetDays}} {{stringOfOffsetDays}}.',
      date_after_or_equal_days:
        'Ingresa una fecha desde hoy hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} después.',
      date_before_yesterday: 'Ingresa la fecha de ayer.',
      date_before_days:
        'Ingresa una fecha desde ayer hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} atrás.',
      date_before_or_equal_days:
        'Ingresa una fecha desde hoy hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} atrás.',
      date_between_days:
        'Ingresa una fecha entre {{numOfLeftDays}} {{stringOfLeftDays}} antes y {{numOfRightDays}} {{stringOfRightDays}} después de hoy.',

      time_only_now: 'Ingresa la hora actual.',
      time_no_future: 'Ingresa una hora igual o anterior a ahora.',
      time_no_past: 'Ingresa una hora igual o posterior a la hora actual.',
      time_after_next_hour: 'Ingresa una hora dentro de la próxima hora.',
      time_after_hours:
        'Ingresa una hora dentro de las próximas {{hours}} {{stringOfOffsetHours}}.',
      time_after_or_equal_hours:
        'Ingresa una hora desde ahora o hasta {{hours}} {{stringOfOffsetHours}} después.',
      time_before_last_hour: 'Ingresa una hora dentro de la última hora.',
      time_before_hours:
        'Ingresa una hora hasta {{numOfOffsetHours}} {{stringOfOffsetHours}} antes de este momento.',
      time_before_or_equal_hours:
        'Ingresa una hora desde ahora o hasta {{numOfOffsetHours}} {{stringOfOffsetHours}} atrás.',
      time_between_hours:
        'Ingresa una hora desde {{numOfLeftHours}} {{stringOfLeftHours}} antes hasta {{numOfRightHours}} {{stringOfRightHours}} después de este momento.',

      datetime_only_today: 'Selecciona una fecha y hora de hoy.',
      datetime_no_future: 'Ingresa una fecha y hora igual o anterior a ahora.',
      datetime_no_past: 'Ingresa una fecha y hora igual o posterior a la hora actual.',
      datetime_after:
        'Ingresa una fecha y hora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} y {{numOfOffsetHours}} {{stringOfOffsetHours}} después de este momento.',
      datetime_after_days_only:
        'Ingresa una fecha y hora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} después de este momento.',
      datetime_after_or_equal:
        'Ingresa una fecha y hora desde ahora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} y {{numOfOffsetHours}} {{stringOfOffsetHours}} después.',
      datetime_after_or_equal_days_only:
        'Ingresa una fecha y hora desde ahora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} después.',
      datetime_before:
        'Ingresa una fecha y hora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} y {{numOfOffsetHours}} {{stringOfOffsetHours}} atrás.',
      datetime_before_days_only:
        'Ingresa una fecha y hora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} atrás.',
      datetime_before_or_equal:
        'Ingresa una fecha y hora desde ahora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} y {{numOfOffsetHours}} {{stringOfOffsetHours}} antes.',
      datetime_before_or_equal_days_only:
        'Ingresa una fecha y hora desde ahora hasta {{numOfOffsetDays}} {{stringOfOffsetDays}} antes.',
      datetime_between:
        'Ingresa una fecha y hora entre {{numOfLeftDays}} {{stringOfLeftDays}} y {{numOfLeftHours}} {{stringOfLeftHours}} antes y {{numOfRightDays}} {{stringOfRightDays}} y {{numOfRightHours}} {{stringOfRightHours}} después de este momento.',
      datetime_between_days_only:
        'Ingresa una fecha y hora entre {{numOfLeftDays}} {{stringOfLeftDays}} antes y {{numOfRightDays}} {{stringOfRightDays}} después de este momento.',
      datetime_between_left_days_only:
        'Ingresa una fecha y hora entre {{numOfLeftDays}} {{stringOfLeftDays}} antes y {{numOfRightDays}} {{stringOfRightDays}} y {{numOfRightHours}} {{stringOfRightHours}} después de este momento.',
      datetime_between_right_days_only:
        'Ingresa una fecha y hora entre {{numOfLeftDays}} {{stringOfLeftDays}} y {{numOfLeftHours}} {{stringOfLeftHours}} antes y {{numOfRightDays}} {{stringOfRightDays}} después de este momento.',
      date_relative_after: 'Inserte una fecha después de {{limit}}.',
      date_relative_after_or_equal: 'Inserte una fecha igual o posterior a {{limit}}.',
      date_relative_before: 'Inserte una fecha antes de {{limit}}.',
      date_relative_before_or_equal: 'Inserte una fecha igual o anterior a {{limit}}.',
      date_relative_between: 'Inserte una fecha entre {{minLimit}} y {{maxLimit}}.',
      date_relative_not_between:
        'Inserte una fecha fuera del rango entre {{minLimit}} y {{maxLimit}}.',
      date_relative_between_question_offset: 'Inserte una fecha entre {{minLimit}} y {{maxLimit}}.',
      datetime_relative_after: 'Inserte una fecha y hora después de {{limit}}.',
      datetime_relative_after_or_equal: 'Inserte una fecha y hora igual o posterior a {{limit}}.',
      datetime_relative_before: 'Inserte una fecha y hora antes de {{limit}}.',
      datetime_relative_before_or_equal: 'Inserte una fecha y hora igual o anterior a {{limit}}.',
      datetime_relative_between: 'Inserte una fecha y hora entre {{minLimit}} y {{maxLimit}}.',
      datetime_relative_not_between:
        'Inserte una fecha y hora fuera del rango entre {{minLimit}} y {{maxLimit}}.',
      datetime_relative_between_question_offset:
        'Inserte una fecha y hora entre {{minLimit}} y {{maxLimit}}.',
      time_relative_after: 'Inserte una hora después de {{limit}}.',
      time_relative_after_or_equal: 'Inserte una hora igual o posterior a {{limit}}.',
      time_relative_before: 'Inserte una hora antes de {{limit}}.',
      time_relative_before_or_equal: 'Inserte una hora igual o anterior a {{limit}}.',
      time_relative_between: 'Inserte una hora entre {{minLimit}} y {{maxLimit}}.',
      time_relative_not_between:
        'Inserte una hora fuera del rango entre {{minLimit}} y {{maxLimit}}.',
      time_relative_between_question_offset: 'Inserte una hora entre {{minLimit}} y {{maxLimit}}.',

      date_not_between_days:
        'Ingresa una fecha fuera del rango entre {{numOfLeftDays}} {{stringOfLeftDays}} antes y {{numOfRightDays}} {{stringOfRightDays}} después de hoy.',
      time_not_between_hours:
        'Ingresa una hora fuera del rango entre {{numOfLeftHours}} {{stringOfLeftHours}} antes y {{numOfRightHours}} {{stringOfRightHours}} después de este momento.',
      datetime_not_between:
        'Ingresa una fecha y hora fuera del rango entre {{numOfLeftDays}} {{stringOfLeftDays}} y {{numOfLeftHours}} {{stringOfLeftHours}} antes y {{numOfRightDays}} {{stringOfRightDays}} y {{numOfRightHours}} {{stringOfRightHours}} después de este momento.',
      datetime_not_between_days_only:
        'Ingresa una fecha y hora fuera del rango entre {{numOfLeftDays}} {{stringOfLeftDays}} antes y {{numOfRightDays}} {{stringOfRightDays}} después de este momento.',
      datetime_not_between_left_days_only:
        'Ingresa una fecha y hora fuera del rango entre {{numOfLeftDays}} {{stringOfLeftDays}} antes y {{numOfRightDays}} {{stringOfRightDays}} y {{numOfRightHours}} {{stringOfRightHours}} después de este momento.',
      datetime_not_between_right_days_only:
        'Ingresa una fecha y hora fuera del rango entre {{numOfLeftDays}} {{stringOfLeftDays}} y {{numOfLeftHours}} {{stringOfLeftHours}} antes y {{numOfRightDays}} {{stringOfRightDays}} después de este momento.',

      datetime: {
        afterMessage:
          'La fecha y hora debe ser posterior al momento en que se responde el formulario, con un máximo de {days} {daysUnit} y {hours} {hoursUnit} después.',
        afterOrEqualMessage:
          'La fecha y hora debe ser igual o posterior al momento en que se responde el formulario, con un máximo de {days} {daysUnit} y {hours} {hoursUnit} después.',
        beforeMessage:
          'La fecha y hora debe ser anterior al momento en que se responde el formulario, con un máximo de {days} {daysUnit} y {hours} {hoursUnit} atrás.',
        beforeOrEqualMessage:
          'La fecha y hora debe ser el día en que se responde el formulario o hasta {days} {daysUnit} y {hours} {hoursUnit} atrás.',
        betweenMessage:
          'La fecha y hora debe estar dentro del rango que va desde {daysBefore} {daysBeforeUnit} y {hoursBefore} {hoursBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} y {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
        notBetweenMessage:
          'La fecha y hora debe estar fuera del rango que va desde {daysBefore} {daysBeforeUnit} y {hoursBefore} {hoursBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} y {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
        relativeAfterMessage:
          'La fecha y hora debe ser posterior a {questionName} más {days} {daysUnit} y {hours} {hoursUnit}.',
        relativeAfterOrEqualMessage:
          'La fecha y hora debe ser igual o posterior a {questionName} más {days} {daysUnit} y {hours} {hoursUnit}.',
        relativeBeforeMessage:
          'La fecha y hora debe ser anterior a {questionName} más {days} {daysUnit} y {hours} {hoursUnit}.',
        relativeBeforeOrEqualMessage:
          'La fecha y hora debe ser igual o anterior a {questionName} más {days} {daysUnit} y {hours} {hoursUnit}.',
        relativeBetweenMessage:
          'La fecha y hora debe estar entre {minQuestionName} y {maxQuestionName}.',
        relativeNotBetweenMessage:
          'La fecha y hora no debe estar entre {minQuestionName} y {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'La fecha y hora debe estar entre {questionName} y {questionName} más {days} {daysUnit} y {hours} {hoursUnit}.',
      },
      date: {
        afterMessage:
          'La fecha debe ser posterior al día en que se responde el formulario, con un máximo de {days} {daysUnit} después.',
        afterOrEqualMessage:
          'La fecha debe ser el día en que se responde el formulario o hasta {days} {daysUnit} después.',
        beforeMessage:
          'La fecha debe ser anterior al día en que se responde el formulario, con un máximo de {days} {daysUnit} atrás.',
        beforeOrEqualMessage:
          'La fecha debe ser el día en que se responde el formulario o hasta {days} {daysUnit} atrás.',
        betweenMessage:
          'La fecha debe estar dentro del rango que va desde {daysBefore} {daysBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} después del momento en que se responde el formulario.',
        notBetweenMessage:
          'La fecha debe estar fuera del rango que va desde {daysBefore} {daysBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} después del momento en que se responde el formulario.',
        relativeAfterMessage: 'La fecha debe ser posterior a {questionName} más {days} {daysUnit}.',
        relativeAfterOrEqualMessage:
          'La fecha debe ser igual o posterior a {questionName} más {days} {daysUnit}.',
        relativeBeforeMessage: 'La fecha debe ser anterior a {questionName} más {days} {daysUnit}.',
        relativeBeforeOrEqualMessage:
          'La fecha debe ser igual o anterior a {questionName} más {days} {daysUnit}.',
        relativeBetweenMessage: 'La fecha debe estar entre {minQuestionName} y {maxQuestionName}.',
        relativeNotBetweenMessage:
          'La fecha no debe estar entre {minQuestionName} y {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'La fecha debe estar entre {questionName} y {questionName} más {days} {daysUnit}.',
      },
      time: {
        afterMessage:
          'La hora debe ser posterior al momento en que se responde el formulario, con un máximo de {hours} {hoursUnit} después.',
        afterOrEqualMessage:
          'La hora debe ser en el momento en que se responde el formulario o hasta {hours} {hoursUnit} después.',
        beforeMessage:
          'La hora debe ser a lo más {hours} {hoursUnit} antes del momento en que se responde el formulario.',
        beforeOrEqualMessage:
          'La hora debe ser en el momento en que se responde el formulario o hasta {hours} {hoursUnit} atrás.',
        betweenMessage:
          'La hora debe estar dentro del rango que va desde {hoursBefore} {hoursBeforeUnit} antes hasta {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
        notBetweenMessage:
          'La hora debe estar fuera del rango que va desde {hoursBefore} {hoursBeforeUnit} antes hasta {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
        relativeAfterMessage:
          'La hora debe ser posterior a {questionName} más {hours} {hoursUnit}.',
        relativeAfterOrEqualMessage:
          'La hora debe ser igual o posterior a {questionName} más {hours} {hoursUnit}.',
        relativeBeforeMessage:
          'La hora debe ser anterior a {questionName} más {hours} {hoursUnit}.',
        relativeBeforeOrEqualMessage:
          'La hora debe ser igual o anterior a {questionName} más {hours} {hoursUnit}.',
        relativeBetweenMessage: 'La hora debe estar entre {minQuestionName} y {maxQuestionName}.',
        relativeNotBetweenMessage:
          'La hora no debe estar entre {minQuestionName} y {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'La hora debe estar entre {questionName} y {questionName} más {hours} {hoursUnit}.',
      },
    },
    number: 'Número',
    noValidation: 'Sin validación',
    validNumberWarning: 'Ingresa un número válido',
    validSetWarning: 'Ingresa un rango válido',
    separator: 'Separador',
    separatorWarning: 'Ingresa un separador válido',
    relatedList: 'Lista relacionada',
    updateAssetData: 'Actualizar datos',
    filterAssetsByLocation: 'Filtrar activos por lugar',
    filterAssetsByLocationTitle: 'Filtrar activos por lugar',
    filterAssetsByLocationPlaceholder: 'Selecciona una pregunta de lugar',
    filterAssetsByLocationSameRow: 'Lugar dentro de la pregunta repetible',
    filterAssetsByLocationWholeForm: 'Lugar fuera de la pregunta repetible',
    filterAssetsByLocationCreateQuestion: 'Crear pregunta de lugar',
    filterAssetsByLocationNewQuestionName: 'Lugar',
    selectData: 'Selecciona el dato del activo a actualizar',
    selectMeterQuestion: 'Elige la pregunta que captará el dato',
    meterConfigBannerMeter:
      'El sistema actualizará automáticamente la información del activo con los datos registrados en este formulario.',
    addMeterQuestion: 'Agregar otra pregunta que capture el dato',
    addMeterConfiguration: 'Agregar medidor',
    createNumberQuestion: 'Crear pregunta tipo número',
    createSelectMetadataQuestion: 'Crear pregunta tipo selección lista datos',
    header: 'Encabezado',
    headerPlaceholder: 'País | Ciudad | Calle',
    headerWarning: 'Debes ingresar un encabezado que contenga al separador',
    headerDefault: 'Lista sin encabezado',
    deprecatedWarning: 'Este tipo de pregunta ya no es compatible',
    combineAlert1: 'Solo se pueden añadir preguntas al grupo de preguntas repetibles.',
    combineAlert2:
      'Una pregunta dentro de un grupo de preguntas repetibles no puede contener otro grupo de preguntas repetibles.',
    combineAlertTitle: 'Error',
    emptySubform: 'Vaciar',
    emptySubformAlert:
      'El grupo de preguntas repetibles no puede estar vacío, una pregunta ha sido creada automáticamente.',
    emptySubformAlertTitle: 'Cuidado',
    emptySubformTooltip: 'Eliminar todas las preguntas del grupo de preguntas repetibles',
    removeSubformQuestionTooltip: 'Eliminar pregunta del grupo de preguntas repetibles',
    subformRemoveConfirm:
      'Esta pregunta se eliminará de este grupo de preguntas repetibles y se agregará al formulario principal.',
    subformEmptyConfirm:
      'Todas las preguntas se eliminarán del grupo de preguntas repetibles y se agregarán al formulario principal.',
    confirm: 'Confirmar',
    subformLimit: 'Limitar repeticiones',
    subformWarning: 'Para más de 5 repeticiones, actualiza tu plan en configuración > facturación',
    answer: 'Responder',
    includeComments: 'Comentario',
    commentsFormLabel:
      'Selecciona las respuestas en las que deseas incluir un comentario obligatorio',
    textCommentBtnTooltip: 'Texto Requerido',
    imageCommentBtnTooltip: 'Imagen Requerida',
    findingCommentBtnTooltip: 'Ticket Requerido',
    imageCommentBtnTooltipDisabled: 'No puedes agregar más de 500 imágenes en total',
    share: 'Compartir',
    mobileTab: 'Celular',
    webTab: 'Computador',
    max: 'Máximo',
    min: 'Mínimo',
    asCount: 'Conteo',
    dataListSearchModalTitle: 'Mis listas',
    editLists: 'Editar listas',
    editLocations: 'Editar lugares',
    editAssets: 'Editar activos',
    use: 'Usar',
    usedInThisForm: 'Usadas en este formulario',
    otherLists: 'Otras listas',
    customLists: 'Personalizadas',
    locations: 'Lugares',
    selectAll: 'Seleccionar todos',
    customLocations: 'Lugares personalizados',
    searchInListPlaceholder: 'Buscar en esta lista...',
    locationAccessAlert:
      'Algunos usuarios podrían no ver esta pregunta si no tienen acceso a los lugares seleccionados',
    customListsDescription:
      'Almacena cualquier tipo de datos que requieras consultar (incluye lugares antiguos)',
    locationsDescription: 'Centraliza y controla la información de tus espacios físicos',
    assetsDescription: 'Gestiona activos con toda su información, ubicación y medidores',
    selectDataListInstruction: 'Selecciona la lista de datos que mejor se ajuste a tu pregunta',
    multi_photo: 'Múltiples fotos',
    mobileOnlyAlert:
      'Disponible solo en la app. Si haces esta pregunta obligatoria, podrás responder el formulario desde web, pero la pregunta no aparecerá.',
    oldLocationsListWarning:
      'Estás usando una lista de lugares antigua. Crea una nueva para aprovechar los beneficios.',
    availableAppWeb: 'Disponible en web y app',
    imageDisabledByLimit:
      'La opción de imagen fue deshablitada. No es posible subir más de 500 imágenes en total',
    formBuilderBlockedAlertPart1:
      'No tienes permisos para editar este formulario. Si quieres crear o editar formularios ',
    formBuilderBlockedAlertPart2: 'actualiza tu plan',
    formBuilderBlockedAlertPart3: ' ahora y desbloquea la productividad sin límites',
    formNameExists: 'El nombre del formulario ya existe',
    saveError: 'Error al guardar el formulario',
    formLockedForEditing: 'El formulario está bloqueado para la edición.',
    validationFixedRange: 'Rango fijo',
    validationRelativeRange: 'Rango relativo(solo disponible en app)',
    validationComparisonType: 'Tipo de comparación',
    validationSelectComparisonType: 'Selecciona tipo de comparación',
    minimumValue: 'Valor mínimo',
    maximumValue: 'Valor máximo',
    offset: 'Desplazamiento',
    pickQuestion: 'Selecciona una pregunta',
    noQuestionsAvailable: 'No hay preguntas disponibles para comparación',
    validationType: 'Tipo de validación',
    theNumberMustBe: 'El número debe ser',
    theNumberMustNotBe: 'El número no debe ser',
    than: 'que',
    plus: 'más',
    minus: 'menos',
    hoursLabel: 'hrs',
    hourLabel: 'hr',
    andMinutesLabel: 'y',
    minuteLabel: 'minuto',
    minutesLabel: 'minutos',
    activityStartTime: 'Selecciona la hora de inicio de jornada',
    activityDuration: 'Selecciona la duración de la jornada',
    activityInterval: 'Selecciona el intervalo de tiempo',
    activityDurationHours: 'Horas',
    activityDurationMinutes: 'Minutos',
    hourWord: 'hora',
    hoursWord: 'horas',
    workdayEndsAt: 'La jornada finalizará a las {time}.',
    workdayEndsAtNextDay: 'La jornada finalizará a las {time} del día siguiente.',
    activityIntervalPlaceholderDisabled: 'Configura la duración primero',
    activityIntervalPlaceholderEmpty: 'Selecciona un intervalo',
    activityIntervalHelperText: 'Las opciones disponibles dependen de la duración configurada.',
    activityIntervalRequired: 'Selecciona un intervalo para poder guardar.',
    activityPeriodTimeIncomplete:
      'Hay preguntas de actividad sin duración o sin intervalo. Complétalas para guardar el formulario.',
    activityDurationInvalid: 'La duración debe ser de al menos 5 minutos.',
    every: 'Cada',
    chooseSelectMetadataQuestion: 'Selecciona una pregunta tipo {select_metadata}',
    chooseNumberQuestion: 'Selecciona una pregunta tipo {number}',
    tabs: {
      builder: 'Editor de formularios',
      integrations: 'Integraciones',
      signature: 'Firma',
      email: 'Email',
      pdf: 'PDF',
    },
    dynamicSignatureModificationAlert: {
      title: 'Algunas firmas podrían dejar de funcionar',
      description:
        'Los cambios que estás realizando podrían afectar las firmas electrónicas asociadas a estas preguntas.\nSi continúas, esas firmas podrían desactivarse.',
      continue: 'Continuar',
      cancel: 'Cancelar',
    },
  },
  help: {
    multi_option: 'Selecciona una alternativa en una lista de elementos',
    select_metadata: 'Selecciona una alternativa dentro de una lista de datos dinámica',
    select_option_metadata: 'Selecciona una alternativa para cada elemento de la lista',
    select_option_metadata_comments:
      'Selecciona alternativas fijas para cada elemento de una lista de datos dinámica',
    track_code: 'Permite asignar un código de seguimiento especifico para cada formulario',
    static_text: 'Permite agregar textos fijos como una instrucción del formulario',
    select_check_metadata: 'Selecciona múltiples elementos en una lista de datos dinámica',
    select_number_metadata: 'Selecciona un número para cada elemento de la lista de datos dinámica',
    select_text_metadata: 'Escribe un texto por cada elemento de una lista de datos dinámica',
    table: 'Crea un grupo de preguntas que puedes responder más de una vez',
  },
  types: {
    text: 'Texto',
    date: 'Fecha/Hora',
    number: 'Número',
    signature: 'Firma',
    barcode: 'Escáner',
    photo: 'Foto',
    multi_photo: 'Foto',
    multi_option: 'Selección Única',
    select_option_metadata: 'Checklist',
    select_option_metadata_comments: 'Checklist',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Número Lista Datos',
    select_text_metadata: 'Texto Lista Datos',
    static_text: 'Instrucción',
    select_metadata: 'Selección Lista Datos',
    table: 'Grupo de Preguntas Repetibles',
    attachment: 'Adjuntar Archivo',
    deprecated: 'Deprecada',
    select_activity_period_time: 'Actividad Lista Datos',
  },
  links: {
    appStore: 'https://itunes.apple.com/us/app/datascope-forms/id1132697668?l=es&ls=1&mt=8',
    playStore: 'https://app.datascope.io/apk',
    appLink: 'https://datascope.page.link/3N7P',
  },
  listManager: {
    dataListSource: 'Fuente de datos',
    name: 'Nombre',
    description: 'Descripción',
    code: 'Código',
    listItems: 'Elementos de la lista',
    emptyList: 'Esta lista no tiene elementos',
    attribute1: 'Atributo 1',
    attribute2: 'Atributo 2',
    listSubtitle:
      'Podrás usar estas listas en las preguntas tipo: Checklist, checkbox, número lista datos, texto lista datos y selección lista datos',
    seeAll: 'Ver todas las listas',
    seeObj: 'Ver elementos de la lista',
    edit: 'Editar lista',
    editObj: 'Editar elemento',
    delete: 'Eliminar lista',
    deleteAction: 'Eliminar',
    deleteObj: 'Eliminar elemento',
    nameInUse: 'Nombre ya está en uso',
    codeInUse: 'Código ya está en uso',
    nameEmpty: 'El nombre no puede estar vacío',
    itemsStillEditing: 'Hay items en edición. Confírmalos o cancélalos antes de guardar.',
    deleteObjectWarning: '¿Estás seguro/a de que quieres eliminar este elemento de la lista?',
    deleteYes: 'Sí, eliminar',
    confirmDeleteItemsTitle: '¿Estás seguro que quieres eliminar {count} items?',
    confirmDeleteItemsDesc:
      'Se eliminarán, pero las respuestas previamente enviadas no se verán afectadas',
    saveChanges: 'Guardar',
    cancel: 'Cancelar',
    itemsOf: 'Elementos de:',
    addNewItem: '+ Nuevo elemento',
    page: 'Página ',
    of: ' de ',
    close: 'Cerrar',
    legacy: 'Ir al manejador de listas completo',
    locations: 'Lugares',
    assets: 'Activos',
    customLists: 'Listas personalizadas',
    search: 'Buscar',
    searchPlaceholder: 'Buscar por nombre lista, creador, nombre formulario',
    import: 'Importar',
    importSuccess: 'Listas cargadas exitosamente. Pueden tardar algunos segundos en reflejarse',
    importError: 'Error al importar lista',
    importDescription: 'Sube un archivo XLS, XLSX o CSV con los datos de la lista. Máximo 5MB.',
    export: 'Exportar',
    newList: 'Nueva lista',
    switchToLegacy: 'Volver a la versión anterior',
    switchToNew: 'Volver a la versión nueva',
    duplicate: 'Duplicar',
    createdAt: 'Fecha de creación',
    type: 'Tipo',
    items: 'Items',
    creator: 'Creador',
    usedIn: 'Usada en',
    usedInDescription: 'Formularios que usan esta lista',
    notUsed: 'Esta lista no está siendo usada en ningún formulario.',
    noResults: 'No se encontraron listas',
    emptyTitle: 'No tienes listas personalizadas',
    emptyDescription:
      'Crea tu primera lista para organizar datos que podrás usar en tus formularios.',
    deleteConfirmTitle: 'Eliminar lista',
    deleteSuccess: 'Listas eliminadas correctamente',
    deleteError: 'Error al eliminar listas',
    duplicateSuccess: 'Lista duplicada correctamente',
    duplicateError: 'Error al duplicar lista',
    createList: 'Crear lista',
    editList: 'Editar lista',
    details: 'Detalles',
    listName: 'Nombre de la lista',
    listDescriptionOptional: 'Descripción de la lista (opcional)',
    listType: 'Tipo de lista',
    typeStandard: 'Estándar',
    typePrice: 'Precio',
    typePercent: 'Porcentaje',
    typeStandardDesc: "Utiliza la pregunta 'Lista de datos'",
    typePriceDesc: "Utiliza la pregunta 'Número de lista de datos'",
    itemAttributes: 'Atributos items',
    attributesExportHelper: 'Se verán reflejados en la exportación PDF',
    attributeNamePlaceholder: 'Nombre atributo',
    listItemsSection: 'Items lista',
    addItemsHelper: 'Agrega los items que contendrá esta lista',
    addItem: 'Agregar item',
    noItemsYet: 'No hay items agregados en este momento',
    create: 'Crear',
    update: 'Actualizar',
    formInfoHelper:
      'En la respuesta del formulario solo verás los ítems de esta lista que hayan sido seleccionados',
    actions: 'Acciones',
    newItem: 'Nuevo item',
    list: 'Lista',
    searchByNameCode: 'Buscar por nombre, código',
    lastResponse: 'Última respuesta',
    results: 'Resultados',
    itemSelected: 'item seleccionado',
    itemsSelected: 'items seleccionados',
    confirmDeleteItems: '¿Estás seguro de eliminar {count} items?',
    confirmDeleteItem: '¿Estás seguro de eliminar "{name}"?',
    listNotFound: 'Lista no encontrada',
    nameItem: 'Nombre item',
    textType: 'Texto',
    imageType: 'Imagen',
    nameRequired: 'El nombre es requerido',
    codeOptional: 'Codigo (opcional, se genera automaticamente)',
    codeInvalid: 'Solo letras, numeros, espacios y guion bajo',
    codeTooLong: 'Maximo 30 caracteres',
    auditLogsTitle: 'Registros de importacion',
    importsTab: 'Listas importadas',
    menuImportNow: 'Importar ahora',
    menuViewHistory: 'Ver historial',
    statusStarted: 'Iniciado',
    statusProcessing: 'Procesando',
    statusCompleted: 'Completado',
    statusFailed: 'Error',
    typeSingle: 'Simple',
    typeMassive: 'Masivo',
    colDate: 'Fecha',
    colUser: 'Usuario',
    colType: 'Tipo',
    colList: 'Lista',
    colFile: 'Archivo',
    colStatus: 'Estado',
    colResult: 'Resultado',
    colDuration: 'Duracion',
    noImportsFound: 'No hay importaciones registradas',
    listsCount: 'listas',
    itemsDeleted: 'items eliminados',
    deleteItemsError: 'Error al eliminar items',
    reorderError: 'No se pudo guardar el nuevo orden',
    reorderErrorListChanged: 'La lista cambió mientras reordenabas. Recarga e intenta de nuevo',
    reorderItem: 'Reordenar {name}',
    orderListNoticeTitle: '¿Quieres reordenar los items?',
    orderListNoticeBody: 'Habilita esta opción para arrastrarlos y cambiar su posición.',
    orderListButton: 'Habilitar',
    orderListSuccess: 'Lista ordenada. Ya puedes arrastrar los items',
    orderListError: 'No se pudo ordenar la lista. Intenta de nuevo',
    noItemsInList: 'No hay items en esta lista',
    searchForm: 'Buscar formulario',
    noFormsFound: 'No se encontraron formularios',
    lastResponseSent: 'Última respuesta enviada usando esta lista',
    selectedList: 'lista seleccionada',
    selectedLists: 'listas seleccionadas',
    importTitle: 'Importar listas personalizadas',
    importStep1: 'Paso 1: Descarga el archivo',
    importStep1Desc: 'Descarga el Excel ejemplo. Asegúrate de campos marcados con',
    importStep1Desc2: 'para importar tu archivo correctamente.',
    importStep2: 'Paso 2: Edita el archivo',
    importStep3: 'Paso 3: Sube el archivo',
    importStep3Desc: 'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora.',
    downloadTemplate: 'Descargar ejemplo',
    exportList: 'Exportar lista',
    dragDropExcel: 'Arrastra y suelta aquí tu Excel',
    browseComputer: 'búscalo',
    fileUploaded: 'Tu archivo ha sido cargado',
    fileNotLoaded: 'Tu archivo no pudo ser cargado',
    replaceFile: 'Reemplazar',
    fileRequirements: 'Requisitos del archivo',
    reqNameColumn: "Columna 'Nombre' completa.",
    reqUniqueValues: "Columnas 'Nombre' y 'Código' deben tener valores únicos.",
    reqMaxItems: 'Máximo 10.000 items por lista.',
    assignListNames: 'Asigna un nombre para cada lista cargada',
    formatError: 'Formato incorrecto. El archivo debe ser .XLSX o .CSV',
    multiSheetError:
      'El archivo contiene múltiples hojas. Para importar múltiples listas, usa el importador desde la página principal de listas.',
    importing: 'Importando...',
    invalidListId: 'ID de lista inválido',
    duplicateCodeError: "El código '{key}' está repetido {count} veces",
    duplicateNameError: "El nombre '{key}' está repetido {count} veces",
    templateExampleItem: 'Ejemplo item',
    templateExampleDesc: 'Descripción ejemplo',
    inYourComputer: 'en tu computador',
    orPrefix: 'o',
    listNameLabel: 'Nombre lista',
    sheetLabel: 'Hoja',
    deleteConfirmTitlePlural: 'Eliminar {count} listas',
    deleteConfirmDescSingle: '¿Estás seguro que deseas eliminar "{name}"?',
    deleteConfirmDescPlural:
      '¿Estás seguro que deseas eliminar {count} listas? Esta acción no se puede deshacer.',
    deleting: 'Eliminando...',
    form: 'formulario',
    forms: 'formularios',
  },
  locations: {
    summary: {
      tabs: { summary: 'Resumen del lugar', info: 'Información del lugar' },
      header: {
        copyLink: 'Copiar enlace del lugar',
        copyLinkSuccess: 'Enlace del lugar copiado',
        copyLinkError: 'No se pudo copiar el enlace',
        edit: 'Editar',
        origin: 'Lugar de origen',
        code: 'Código',
        subLocationsOne: '1 Sublugar',
        subLocationsOther: '{count} Sublugares',
        scopedTo: 'Viendo: {name}',
      },
      dateFilter: { title: 'Filtrar por fecha' },
      viewAll: 'Ver todos',
      dragToReorder: 'Arrastra para reordenar',
      dragHandleAriaLabel: 'Reordenar {name}. Presiona espacio y usa las flechas.',
      inheritedLabel: 'Heredado',
      close: 'Cerrar',
      seeMore: 'Ver {count} más',
      seeLess: 'Ver menos',
      searchPlaceholder: 'Buscar',
      errorLoading: 'No pudimos cargar este bloque.',
      retry: 'Reintentar',
      accessDenied: 'No tienes acceso a este lugar.',
      blocks: {
        users: {
          title: 'Usuarios',
          searchPlaceholder: 'Buscar por nombre o rol',
          empty: 'No hay usuarios en este alcance.',
          emptySearch: 'No se encontraron usuarios',
          emptySearchHint: 'Intenta buscar con otro nombre.',
          noPermission: 'No tienes permiso para ver los usuarios de este lugar.',
        },
        answers: {
          title: 'Respuestas de formulario',
          searchPlaceholder: 'Buscar por ID o nombre de formulario',
          empty: 'No hay respuestas en este alcance',
          emptySearch: 'No se encontraron respuestas',
          emptySearchHint: 'Intenta buscar con otro nombre.',
          editAnswer: 'Editar respuesta',
          downloadPdf: 'Descargar PDF',
          noState: 'Sin estado',
        },
        assets: {
          title: 'Activos',
          searchPlaceholder: 'Buscar por nombre o tipo de activo',
          empty: 'No hay activos en este lugar.',
          emptySearch: 'No se encontraron activos',
          emptySearchHint: 'Intenta buscar con otro nombre.',
          noMeter: 'No aplica',
          noReading: '-',
          countOne: '1 activo',
          countOther: '{count} activos',
          columnAsset: 'Activo',
          columnLastMeasurement: 'Última medición',
          noPermission: 'No tienes permiso para ver los activos de este lugar.',
        },
        tickets: {
          title: 'Tickets',
          searchPlaceholder: 'Buscar por ID o nombre',
          empty: 'No hay tickets en este alcance',
          emptySearch: 'No se encontraron tickets',
          emptySearchHint: 'Intenta buscar con otro nombre.',
          createdBy: 'Creado por {name}',
        },
        signatures: {
          title: 'Firmas',
          searchPlaceholder: 'Buscar por usuario o nombre de formulario',
          empty: 'No hay firmas en este alcance',
          emptySearch: 'No se encontraron firmas',
          emptySearchHint: 'Intenta buscar con otro nombre.',
          countOne: '{count}/{total} firma',
          countOther: '{count}/{total} firmas',
          showingLimited: 'Mostrando {shown} de {total}',
        },
        tasks: {
          title: 'Tareas asignadas',
          searchPlaceholder: 'Buscar por ID o nombre de formulario',
          overdue: 'Vencida',
          completed: 'Completada',
          empty: 'No hay tareas asignadas en este alcance',
          emptySearch: 'No se encontraron tareas',
          emptySearchHint: 'Intenta buscar con otro nombre.',
          dueToday: 'Hoy',
          daysRemainingOne: 'Queda 1 día',
          daysRemainingOther: 'Quedan {count} días',
          daysOverdueOne: 'Hace 1 día',
          daysOverdueOther: 'Hace {count} días',
          showingLimited: 'Mostrando {shown} de {total}',
        },
        plannings: {
          title: 'Planificaciones',
          searchPlaceholder: 'Buscar por nombre o activo',
          empty: 'No hay planificaciones en este alcance',
          emptySearch: 'No se encontraron planificaciones',
          emptySearchHint: 'Intenta buscar con otro nombre.',
          supervisorsCount: '{count} supervisores',
          showingLimited: 'Mostrando {shown} de {total}',
        },
      },
    },
    planLimits: {
      actionBlocked1: 'Esta acción está bloqueada por los límites de tu plan actual.',
      actionBlocked2: 'Actualiza tu plan para desbloquearla.',
    },
    nestableLocationsBanner: {
      title: '¿Ya probaste los nuevos lugares?',
      description:
        'Crea listas de lugares jerárquicas para una operación más ordenada, precisa y con control de accesos. ',
      link: 'Crear lugares',
    },
    title: 'Lugares',
    searchPlaceholder: 'Buscar',
    header: {
      export: 'Exportar',
      import: 'Importar',
      createPlace: 'Crear lugar',
    },
    export: {
      success:
        'Lugares exportados con éxito. Enviaremos el archivo a tu correo electrónico apenas esté listo.',
      error:
        'Error al exportar lugares. Vuelve a intentarlo o contacta al soporte si el problema persiste.',
    },
    import: {
      title: 'Importar Lugares',
      description: 'Importar lugares desde un archivo Excel',
      step1Title: 'Paso 1: Descarga el archivo',
      step1Description:
        'Usa nuestra plantilla Excel para asegurarte de que tus lugares tengan el formato correcto',
      downloadExample: 'Descargar ejemplo',
      step2Title: 'Paso 2: Completa el Excel',
      step2Description: 'Agrega tus lugares y sublugares siguiendo el formato del ejemplo.',
      step3Title: 'Paso 3: Sube el archivo',
      step3Description: 'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora.',
      dragDropText: 'Arrastra y suelta tu archivo Excel aquí',
      browseText: 'o búscalo en tu computador',
      replaceText: 'Reemplazar',
      fileUploadedText: 'Tu archivo ha sido cargado',
      invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
      importError: 'Error al importar lugares',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      importingDescription: 'Un momento, estamos organizando todo...',
      errorTitle: 'Detectamos un error.',
      errorMessage: 'Por favor, verifica que tus datos tengan el formato correcto.',
      templateDownloadError: 'Error al descargar la plantilla',
      downloadingTemplate: 'Descargando...',
      templateUrlV2:
        'https://s3-us-west-2.amazonaws.com/data-scope/templates/nestable_locations/import_template_es_v2.xlsx',
      instructions: {
        maxSheets: 'El archivo debe contener no más de {maxSheets} hojas para anidación de lugares',
        maxRows: 'El archivo debe contener no más de {maxRows} filas por cada hoja',
        maxColumns: 'El archivo debe contener no más de {maxColumns} columnas por cada fila',
        maxLengthSheetName:
          'El nombre de la hoja debe tener no más de {maxLengthSheetName} caracteres',
        nestingSheetName:
          'El nombre de la hoja de anidación debe ser el del lugar al que se está anidando',
      },
      errors: {
        templateDownloadError: 'Error al descargar la plantilla',
        invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
        importError: 'Error al importar lugares',
        importButton: 'Importar',
        cancel: 'Cancelar',
        importing: 'Importando...',
        errorTitle: 'Detectamos un error.',
        errorMessage: 'Por favor, verifica que tus datos tengan el formato correcto.',
      },
    },
    table: {
      locationName: 'Nombre del lugar',
      users: 'Usuarios',
      lastActivity: 'Última actividad',
      actions: 'Acciones',
      resultsCount: 'Resultados: {start}-{end} de {total}',
      loadMore: 'Cargar más lugares',
      loadMoreError: 'Error al cargar más lugares. Por favor, inténtalo de nuevo.',
      noResults: 'No se encontraron resultados',
    },
    row: {
      location: 'Lugar',
      locations: 'Lugares',
      selected: 'seleccionado',
      selected_plural: 'seleccionados',
      address: 'Dirección: ',
      phone: 'Teléfono: ',
      viewLocation: 'Ver lugar',
      users: 'usuarios',
      today: 'Hoy',
      sublocation: 'Sublugar',
      sublocations: 'Sublugares',
      sublocationTooltip:
        'Para crear más sublugares necesitas un plan superior. Actualiza tu plan y desbloquea esta y otras funcionalidades',
      viewDetails: 'Ver detalles',
      edit: 'Editar',
      delete: 'Eliminar',
      view: 'Ver lugar',
      deselectAll: 'Deseleccionar todos',
      selectAll: 'Seleccionar todos',
    },
    create: {
      title: 'Crear lugar',
      success: 'Lugar creado exitosamente',
      error: 'Error al crear lugar',
    },
    update: {
      title: 'Actualizar lugar',
      success: 'Lugar actualizado exitosamente',
      error: 'Error al actualizar lugar',
    },
    form: {
      displayDescription: 'Información del lugar',
      createDescription: 'Crear nuevo lugar',
      updateDescription: 'Nuevo lugar',
      sections: {
        locationInfo: 'Información del lugar',
        contactInfo: 'Información de contacto',
        ubication: 'Ubicación',
      },
      name: {
        label: 'Nombre',
        placeholder: 'Ingresa el nombre del lugar...',
        required: 'El nombre del lugar es obligatorio',
        maxLength: 'El nombre debe tener 1000 caracteres o menos',
      },
      code: {
        label: 'Código de lugar',
        placeholder: 'Ingresa el código del lugar...',
        required: 'El código de lugar es obligatorio',
        maxLength: 'El código debe tener 255 caracteres o menos',
        tooltip: 'Opcional. Si lo dejas vacío, se generará un código único automáticamente.',
      },
      type: {
        label: 'Tipo de lugar',
        required: 'El tipo de lugar es obligatorio',
        placeholder: 'Selecciona el tipo de instalación que estás creando...',
        options: {
          plant: 'Planta',
          enterprise: 'Empresa',
          warehouse: 'Bodega',
          production_line: 'Línea de producción',
          office: 'Oficina',
          branch: 'Sucursal',
          distribution_center: 'Centro de distribución',
          other: 'Otro',
        },
      },
      origin: {
        label: 'Lugar de origen',
        required: 'El origen del lugar es obligatorio',
        placeholder: 'Selecciona un lugar existente para asociar...',
        tooltip:
          'Al elegir un Lugar de origen este nuevo lugar se ubicará dentro de otro, formando parte de una estructura.',
        options: {
          main: 'Ubicación Principal',
          subsidiary: 'Subsidiaria',
          remote: 'Ubicación Remota',
          temporary: 'Ubicación Temporal',
          partner: 'Ubicación de Socio',
        },
      },
      phone: {
        label: 'Teléfono',
        placeholder: 'Ingresa el número de teléfono...',
        validation: {
          missingCountryCode: 'El número debe incluir el código de país (ej: +56)',
          invalidCountryCode: 'Código de país no válido',
          invalidFormat: 'Formato de número inválido',
          invalidLength: 'Longitud de número inválida para este país',
        },
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingresa una descripción...',
        helper: 'Detalles opcionales para este lugar',
        validation: {
          tooLong: 'La descripción debe tener 1000 caracteres o menos',
        },
      },
      users: {
        title: 'Usuarios y grupos',
        label: 'Usuarios',
        placeholder: 'Ingresa información de usuarios...',
        helper: 'Agrega información sobre los usuarios asignados a este lugar',
        showLess: 'Mostrar menos',
        showAll: 'Mostrar todos',
      },
      emails: {
        label: 'Emails',
        placeholder: 'Ingresa direcciones de correo...',
        helper: 'Agrega direcciones de correo relevantes para este lugar',
        inputHint: 'Separa los correos con comas o presiona Enter',
        validation: {
          tooMany: 'Se ha excedido el límite máximo de caracteres.',
        },
      },
      coordinates: {
        fetchAddressError: 'No se pudo obtener la dirección para las coordenadas ingresadas.',
        latitude: {
          label: 'Latitud',
          invalid: 'La latitud debe estar entre -90 y 90.',
          placeholder: 'Ingresa la latitud...',
        },
        longitude: {
          label: 'Longitud',
          invalid: 'La longitud debe estar entre -180 y 180.',
          placeholder: 'Ingresa la longitud...',
        },
      },
      ubication: {
        label: 'Ubicación',
        search: 'Buscar dirección',
        hideMap: 'Ocultar mapa',
        showMap: 'Mostrar mapa',
        placeholder: 'Ingresa la dirección...',
        address: 'Dirección',
        city: 'Ciudad',
        region: 'Estado/Región',
        country: 'País',
        postalCode: 'Código Postal',
        noLocationsFound: 'No se encontraron ubicaciones',
        clearData: 'Borrar datos',
        optionalLabel: 'Opcional',
        coordinatesInfoTooltip:
          'Puedes ingresar la ubicación buscando una dirección o ingresando las coordenadas de latitud y longitud manualmente. Ambas opciones son válidas.',
      },
      buttons: {
        create: 'Crear',
        creating: 'Creando…',
        update: 'Actualizar',
        updating: 'Actualizando…',
        cancel: 'Cancelar',
      },
    },
    deleteConfirmation: {
      title: '¿Estás seguro que quieres eliminar este lugar?',
      message:
        'El lugar y todos sus sublugares se eliminarán, pero las respuestas, firmas y tickets no se perderán.',
      confirmButton: 'Eliminar',
      cancelButton: 'Cancelar',
      success: 'Lugar eliminado exitosamente',
      error: 'Error al eliminar el lugar',
    },
    emptyState: {
      noLocations: 'No se encontraron lugares',
      suggestion: 'Intente con diferentes palabras clave o revise su ortografía',
      noLocationsCreated: 'Aún no tienes lugares creados',
      createNewLocation: 'Crear un nuevo lugar',
      migration: {
        title: '¿Aún no has migrado tus lugares?',
        description:
          'Ahora puedes agrupar tus lugares por tipo y visualizar todo en un solo lugar.',
        button: 'Migrar mis lugares',
        close: 'Cerrar',
        imgAlt:
          'Representación de un trabajador con un calendario, un checklist y un PC flotando alrededor',
        viewTitle: 'Migra tus lugares a la nueva estructura',
        backButton: 'Volver a lugares',
        whyMigrate: '¿Por qué migrar?',
        reason1Title: 'Reúne en un solo lugar toda la actividad reciente:',
        reason1Description:
          'tickets, formularios completados, firmas, usuarios y grupos asociados.',
        reason2Title: 'Organiza tus espacios:',
        reason2Description:
          'agregando hasta cuatro subniveles por lugar, para representar cómo funcionan realmente tus sitios.',
        reason3Title:
          'Decide fácilmente qué usuarios o grupos pueden ver y trabajar en cada lugar.',
        reason3Description: 'Los usuarios sólo verán los lugares que les fueron asignados.',
        stepsTitle: 'Paso a paso para migrar tus lugares',
        step1Title: 'Usa tus lugares actuales como base',
        step1Description:
          'Descarga un Excel con los lugares que ya tienes en DataScope desde aquí y úsalo como base para completar la plantilla y ahorrar tiempo.',
        step2Title: 'Descarga la plantilla',
        step2Description:
          'Usa nuestra plantilla Excel para asegurarte de que tus lugares se carguen correctamente. En la primera hoja defines todos los lugares. Si necesitas jerarquía, crea hojas adicionales para asignar sublugares.',
        step3Title: 'Sube la nueva plantilla a la plataforma',
        step3Description:
          'Cuando completes la plantilla, impórtala aquí para actualizar tus lugares con la nueva estructura.',
        faqTitle: 'Preguntas frecuentes',
        faq1Question: '¿Qué va a pasar con mis lugares creados antes?',
        faq1Answer:
          'Los lugares antiguos seguirán funcionando por un tiempo. Próximamente comenzaremos un proceso gradual de cierre para dar paso a la nueva estructura de lugares.',
        faq2Question: '¿Puedo seguir accediendo a los lugares antiguos?',
        faq2Answer:
          '¡Sí! Vas a poder seguir accediendo a tus lugares antiguos. Se mantendrán en el mismo lugar, solo cambiarán de nombre a Lista (Lugares antiguos) para diferenciarlos de los nuevos.',
        faq3Question: '¿Mis formularios anteriores seguirán funcionando?',
        faq3Answer:
          'Sí, los formularios creados con lugares antiguos seguirán activos. En el constructor de formularios verás claramente diferenciados los lugares antiguos de los nuevos.',
        faq3Gif:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/old_locations_es.gif',
        faq4Question: '¿Cómo asigno lugares a los usuarios?',
        faq4Answer:
          'Para el caso de Lugares (nuevos) puedes asignar usuarios de manera individual desde la sección de Usuarios. Para asignaciones masivas, descarga y carga el Excel de usuarios.',
        faq5Question: '¿Puedo asociar un formulario a varios lugares?',
        faq5Answer:
          'Sí, siempre que los lugares estén en el mismo nivel jerárquico. No es posible asociar un formulario a lugares de distintos niveles.',
        faq6Question: '¿Puedo usar los lugares nuevos sin haber migrado todos los anteriores?',
        faq6Answer:
          'Sí, puedes migrar de manera parcial, siempre y cuando los lugares padre ya estén creados en la plataforma. Los lugares antiguos seguirán funcionando mientras completas la migración.',
        faq7Question: '¿Cómo identifico si un lugar ya fue migrado?',
        faq7Answer:
          'En la tabla de lugares podrás ver qué sublugares fueron migrados bajo cada lugar padre. Si ocurre algún error durante la migración, te lo notificaremos directamente en el proceso.',
        helpTitle: '¿Dudas o necesitas ayuda?',
        helpDescription:
          'Si tienes dudas sobre el proceso, contáctanos y te ayudamos a completar la migración.',
        helpButton: 'Solicitar ayuda',
        accessBanner: 'Todos los usuarios van a tener acceso a los lugares que migres',
        bannerImageUrl:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/location-migration-banner-es.png',
        modal: {
          title: 'Migrar tus lugares',
          step1: 'Paso 1: Usa tus lugares existentes como base',
          step1Description:
            'Si ya tienes lugares creados en DataScope, puedes descargarlos y usarlos como base para completar la plantilla.',
          downloadExistingButton: 'Descargar tus lugares existentes',
          downloading: 'Descargando...',
          step2: 'Paso 2: Descarga la plantilla',
          step2Description:
            'Usa el formato de la plantilla para asegurarte de que tus lugares se carguen correctamente.',
          downloadTemplateButton: 'Descargar la plantilla',
          step3: 'Paso 3: Sube tu archivo',
          step3Description:
            'Cuando tengas lista la plantilla, súbela aquí para migrar tus lugares.',
          cancel: 'Cancelar',
          migrateButton: 'Migrar lugares',
          migrating: 'Importando...',
          exportSuccess: 'Lugares exportados con éxito',
          exportError: 'Error al exportar lugares',
          helpAccordion: {
            title: '¿Cómo funciona la plantilla?',
            videoTitle: 'Video paso a paso',
            videoPlaceholder: '0:00 / 0:10',
            videoUrlV2:
              'https://fast.wistia.net/embed/iframe/jovj5zdkls?web_component=true&seo=true',
            fileStructureTitle: 'Estructura del archivo:',
            fileStructure1: 'Hoja de importación:',
            fileStructure1Description:
              'Aquí importas todos tus lugares y sublugares desde un solo archivo.',
            fileStructure2: '¿Quieres que un lugar tenga sublugares?',
            fileStructure2Description:
              'En la columna Lugar de origen, escribe el lugar al que pertenecen.',
            fileStructure3: 'Recuerda completar los campos obligatorios:',
            fileStructure3Description: 'Nombre y Tipo de lugar.',
            fileStructure4: 'Latitud y longitud opcionales:',
            fileStructure4Description:
              'Puedes obtenerlas buscando la dirección en Google Maps o desde',
            fileStructure4Link: 'aquí',
            fileStructure4Note: 'Usa la misma ubicación para evitar errores al importar.',
            technicalLimitsTitle: 'Límites técnicos para importar:',
            technicalLimit1: 'Puedes importar hasta 2.500 lugares por archivo.',
          },
        },
      },
      utility: {
        title: 'Estructura y controla tu operación con lugares',
        preConfigTitle: '¿Para qué sirve lugares?',
        utilityTitle1: 'Centralizar la información:',
        utilityDescription1:
          'reúne en un solo lugar toda la actividad reciente, incluyendo tickets, formularios, firmas y usuarios.',
        utilityTitle2: 'Crear jerarquías de lugares:',
        utilityDescription2:
          'agrega hasta cuatro sublugares por lugar para representar la estructura real de tus operaciones.',
        utilityTitle3: 'Asignar accesos fácilmente:',
        utilityDescription3: 'define qué usuarios pueden ver y trabajar en cada lugar.',
      },
      reasons: {
        title: '¿Por qué usar lugares?',
        cardTitle1: 'Estructura flexible',
        cardDescription1:
          'Adapta los niveles de lugar a cómo funciona tu operación en el mundo real.',
        cardTitle2: 'Información por niveles y tipos',
        cardDescription2:
          'Puedes ver y gestionar formularios, tickets, usuarios y firmas asociadas a cada lugar.',
        cardTitle3: 'Asigna usuarios en cada lugar',
        cardDescription3: 'Asigna responsables usuarios a cada ubicación.',
      },
      carousel: {
        title: 'Crea tu primer lugar',
        gifAlt: 'Demostración gif para crear lugares',
        step1Title: 'Crear lugar',
        step1Description:
          'Crea un lugar presionando Crear lugar y define un nombre, un nivel de lugar, su tipo y si corresponde, asócialo a uno ya existente.',
        step2Title: 'Completa los datos',
        step2Description:
          'Añade un teléfono, correo y una breve descripción te ayudarán a identificarlo más adelante.',
        step3Title: 'Agrega la ubicación',
        step3Description:
          'Ingresa la dirección y detalles extra para identificar mejor este lugar en el mapa. Para finalizar presiona Crear.',
        nextStep: 'Siguiente',
        previousStep: 'Anterior',
      },
      legacy: {
        title: 'Lugares antiguos (Temporal)',
        description:
          'Puedes seguir accediendo a ellos desde aquí, aunque no son compatibles con todas las nuevas funcionalidades',
        button: 'Ver lugares antiguos',
      },
      createNewTitle: 'Crea una nueva forma de organizar tu operación',
      oldLocationsTitle: 'Tus lugares son antiguos.',
      oldLocationsDescription: 'Crea nuevos y aprovecha los beneficios',
      createButton: 'Crear lugares',
      selectorEmptyIllustrationAlt: 'Ilustración del estado vacío de lugares',
      noLocationsAvailable: 'No hay ubicaciones disponibles',
      searchPlaceholder: 'Buscar ubicaciones...',
      loadingLocations: 'Cargando ubicaciones...',
    },
  },
  tasksForms: {
    activateScroll: 'Activar scroll en la app',
    disableScroll: 'Desactivar scroll en la app',
    scrollActiveSuccess: 'Scroll activado con éxito',
    scrollDisabledSuccess: 'Scroll desactivado con éxito',
    templates: 'Plantillas de formularios',
    useTemplate: 'Usar plantilla',
    newVersion: 'Cambiar a nueva versión',
    oldVersion: 'Cambiar a versión antigua',
    uniq: 'El nombre de la pregunta debe ser único',
    title: 'Formularios',
    preview: 'Vista previa',
    export: 'Exportar',
    export_help: 'Puedes copiar este código fuente y pegarlo en otro formulario',
    import: 'Importar',
    import_confirm: '¿Estás seguro de que quieres importar este formulario?',
    import_success: 'Se está importando su formulario, puede tardar algunos minutos',
    importSuccessSync: 'Tu formulario se importó correctamente',
    start_testing: '¡Es momento de probar tu formulario nuevo!',
    test_button: 'Probar formulario',
    start_testing_desc:
      'Felicitaciones, ya tienes tu primer formulario. Ahora puedes probarlo y mandar tu primera respuesta desde la app móvil.',
    import_error:
      'No se pudo importar el formulario. Compruebe si es un formulario válido o si ya está importado.',
    clone: 'Duplicar',
    default_title: 'Mi Formulario',
    default_question: 'Pregunta',
    drag_questions:
      'Por el momento no tienes preguntas en el formulario, arrastra tus preguntas acá',
    new: 'Nuevo formulario',
    new_ai: 'Formulario con IA',
    google_forms: 'Importar Google Form',
    are_you_sure: '¿Estas seguro?',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    publish: 'Activar',
    unpublish: 'Desactivar',
    last_info: 'Agregar HTML al final del PDF',
    current_logo: 'Logo del Formulario',
    form_logo: 'Logo Formulario',
    form_name: 'Nombre',
    // Labels of the Status sort control of the paginated forms tables. Ascending
    // is active forms first, matching the service.
    sortByStatus: {
      unsorted: 'Ordenar por estado',
      ascending: 'Formularios activos primero',
      descending: 'Formularios ocultos primero',
    },
    actions: 'Configurar',
    answer_form: 'Responder',
    edit_app: 'Configurar Formulario',
    edit_share: 'Compartir',
    error_form: 'Ha ocurrido un error',
    success_form: 'Éxito',
    delete: 'Eliminar',
    date: 'Fecha/Hora',
    date_type: 'Tipo Fecha',
    date_type_date: 'Fecha',
    date_type_datetime: 'Fecha y Hora',
    date_type_time: 'Hora',
    text: 'Texto',
    number: 'Número',
    multi_option: 'Selección Única',
    signature: 'Firma',
    barcode: 'Escáner',
    photo: 'Foto',
    select_metadata: 'Selección Lista Datos',
    select_option_metadata: 'Checklist',
    track_code: 'Código de seguimiento',
    static_text: 'Texto Fijo',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Número Lista Datos',
    select_text_metadata: 'Texto Lista Datos',
    table: 'Grupo de Preguntas Repetibles',
    name: 'Título Pregunta',
    description: 'Descripción Pregunta',
    label: 'Nombre Sección',
    choices: 'Alternativas',
    choice: 'Alternativa',
    add_choice: 'Agregar Opción',
    add_list_value: 'Agregar Valor Lista',
    add_question: 'Agregar Pregunta',
    list_values: 'Valores Lista',
    delete_choice: 'Eliminar Opción',
    drop_question: 'Arrastrar preguntas repetibles aquí',
    metadata_type: 'Fuente Lista Datos',
    create_metadata: 'Nueva Lista de Datos',
    change_metadata: 'Cambiar Lista de Datos',
    save_form: 'Guardar Formulario',
    version: 'versión',
    no_name: 'Sin Nombre',
    no_questions: 'Debe tener al menos una pregunta',
    no_data: 'No hay formularios disponibles',
    blank_table: 'Sub Formulario debe tener al menos una pregunta',
    sub_questions: 'Sub Preguntas',
    disable_gallery: 'Deshabilitar Galería',
    required: 'Obligatorio',
    back: 'Atrás',
    location: 'Lista de Lugares',
    help_title: '¿Necesitas Ayuda para crear formulario?',
    help_instruction: 'Solicitar creación de formulario',
    help_description:
      '"***Por favor explicar la información que deseas levantar y cada pregunta del formulario. Adjunta una foto o documento de este mismo"',
    example_title_1: 'Construya sus propios formularios digitales',
    example_description_1:
      'Con el Form Builder puede crear formularios perfectos. Es fácil, intuitivo y potente.',
    success_created: 'El formulario se creó correctamente.',
    hide_logic: 'Saltar preguntas',
    show_price: 'Mostrar Precio',
    show_avg: 'Mostrar Promedio',
    show_factor: 'Mostrar Multiplicación',
    show_percent: 'Mostrar Porcentaje',
    equal: 'Igual',
    not_equal: 'Diferente',
    if: 'SI',
    is: 'ES',
    to: 'A',
    go_to: 'IR A',
    next_question: 'Siguiente Pregunta',
    finish_form: 'Terminar Formulario',
    standard_pdf: 'PDF Estándar',
    customized_pdf: 'PDF Personalizado',
    open_editor: 'Abrir Editor PDF',
    own_pdf: 'Cree su propio diseño PDF',
    need_your_pdf: '¿Necesita su propio diseño PDF?',
    pdf_description:
      'El creador de PDF más flexible para crear sus propios documentos con los datos recopilados',
    folders: 'Carpetas',
    manage_folders: 'Nueva carpeta',
    manage_states: 'Ver estados',
    view_all_folders: 'Ver todas las carpetas',
    searchSend: 'Buscar',
    searchForm: 'Buscar formularios...',
    custom_pdf: {
      step1: 'Crear Plantilla',
      step1_desc:
        'Debes crear una plantilla usando el editor de PDF. Puedes utilizar todos los valores de respuestas del formulario. Se utilizaran los datos del último formulario a modo de ejemplo.',
      step2: 'Activar Plantilla',
      step2_desc:
        'Una vez que la plantilla este lista, puedes activarla. Una vez activado todas las exportaciones se generarán con el formato especificado previamente.',
    },
    help: {
      multi_option: 'Selecciona una alternativa en una lista de elementos',
      select_metadata:
        'Selecciona una alternativa dentro de una lista de datos dinámica ( Ej. Productos, Clientes, etc..)',
      select_option_metadata:
        'Selecciona alternativas fijas para cada elemento de una lista de datos dinámica',
      track_code: 'Permite asignar un código de seguimiento especifico para cada formulario',
      static_text: 'Permite agregar texto fijo como instrucción del formulario',
      select_check_metadata:
        'Permite hacer un check de múltiples elementos dentro de una lista de datos dinámica',
      select_number_metadata:
        'Selecciona un número para cada elemento de una lista de datos dinámica',
      select_text_metadata: 'Selecciona texto para cada elemento de una lista de datos dinámica',
      table: 'Crear un grupo de preguntas que se pueden responder más de una vez',
      description:
        '"Texto más extenso para mostrar en la App. No aparece al exportar datos. (Opcional)"',
      title: 'Título corto para identificar pregunta. Aparece al exportar datos.',
    },
    share: {
      title: 'Generar Link Google Forms',
      link: 'Link:',
      edit_link: 'Editar Google Form',
      export: 'Exportar Google Form',
      sendgrid_template_id: 'd-e6004a145c78496a8d02f26600dec5e0',
      inactive_public_form: 'Este formulario ya no es accesible usando este link.',
      success_message: 'Hemos recibido tu respuesta correctamente',
      make_form_private: 'Eliminar acceso público al formulario',
      make_form_private_notice:
        'Este formulario ahora es privado. Los enlaces públicos previamente compartidos han dejado de ser válidos.',
      make_form_public: 'Hacer público este formulario',
      make_form_public_notice:
        'Este formulario ahora es público. ¡Ahora puede compartirlo con personas ajenas a su organización!',
      share_via_email: 'Comparte este formulario mediante un email',
      share_email_tooltip:
        'Se enviará un enlace público, accesible a cualquier persona, a aquellos correos electrónicos que no estén asociados a esta cuenta. Se enviará un enlace de uso privado a aquellos correos electrónicos que pertenezcan a usuarios registrados de esta cuenta.',
      share_public_link: 'Comparte este formulario mediante un link público',
      share_public_link_tooltip:
        'Cualquier persona, tanto usuarios registrados como no registrados, podrá completar este formulario si comparte el enlace público con ellos. Sus respuestas quedarán registradas a nombre de un usuario genérico, webforms_user_',
      share: 'Compartir',
      copy: 'Copiar',
      trigger: 'Trigger no instalado. Límite de 20 Alcanzado.',
      loading: 'Cargando Formulario...',
      failed: 'Exportación de Formulario Fallida.',
      auth: "'TIP: 'Si tiene problemas, intente cerrar las sesiones de Google (por ejemplo, en google.com), y luego ingrese sólo con la cuenta a la que quiere exportar el formulario.'",
      add_all_permissions: 'Agregar este formulario a todos los usuarios',
      permission_success:
        'Permiso agregado para todos los usuarios, debe cerrar la sesión y volver a iniciar en la aplicación para actualizar los formularios',
    },
    delete_form_confirm: '¿Estás seguro que quieres eliminar este formulario?',
    delete_form_warning: 'Una vez que lo elimines, no podrás recuperarlo.',
    delete_form_success: 'Formulario eliminado con éxito',
    delete_form_failure: 'Error al eliminar el formulario',
    clone_form_success: 'Formulario clonado con éxito',
    clone_form_failure: 'Error al clonar el formulario',
    publish_form_success: 'Formulario activado con éxito',
    publish_form_failure: 'Error al activar el formulario',
    unpublish_form_success: 'Formulario desactivado con éxito',
    unpublish_form_failure: 'Error al desactivar el formulario',
    rename: 'Renombrar',
    rename_folder: 'Renombrar carpeta',
    folder_name: 'Nombre de la carpeta',
    new_name: 'Nuevo nombre',
    update: 'Actualizar',
    cancel: 'Cancelar',
    rename_success: 'Carpeta renombrada con éxito',
    rename_failure: 'Error al renombrar la carpeta',
    delete_folder_confirm: '¿Estás seguro que quieres eliminar la carpeta ',
    delete_warning:
      'Una vez que la elimines, estos formularios pasarán a la sección de formularios (sin carpeta).',
    delete_folder_success: 'Carpeta eliminada con éxito',
    delete_folder_failure: 'Error al eliminar la carpeta',
    move_to_folder: 'Mover a carpeta',
    lockEditing: 'Bloquear edición',
    unlockEditing: 'Habilitar edición',
    unlockEditingSuccess: 'Formulario habilitado exitosamente para edición',
    unlockEditingFailure: 'Error al habilitar el formulario para edición',
    editingLocked: 'Edición bloqueada',
    editingLockedBy: 'Edición bloqueada por:',
    unknownUser: 'Usuario desconocido',
    lockEditingConfirmModal: {
      title: 'Bloquear edición de formulario',
      message:
        'Si lo bloqueas, nadie más podrá editar este formulario. Solo tú o soporte podrán desbloquearlo.',
      confirmButton: 'Bloquear',
      cancelButton: 'Cancelar',
      successMessage: 'Formulario bloqueado exitosamente para edición',
      failureMessage: 'Error al bloquear el formulario para edición',
    },
    remove_from_folder: 'Remover de carpeta',
    move: 'Mover',
    warn_empty_folder: 'Esta acción eliminará la carpeta al quedar esta vacía.',
    move_form_success: 'Formulario movido exitosamente',
    move_forms_success: 'Formularios movidos exitosamente',
    move_form_failure: 'Error al intentar mover el formulario',
    move_forms_failure: 'Error al intentar mover los formularios',
    create: 'Crear',
    create_form_folder: 'Crear carpeta de formularios',
    create_folder_success: 'Carpeta creada con éxito',
    create_folder_failure: 'Error al crear la carpeta',
    how_to_create_folder: '¿Cómo quieres crear tu carpeta?',
    next: 'Siguiente',
    form_selection: 'Selección formularios',
    no_forms_available: 'No tienes formularios disponibles en este momento',
    forms: 'Formularios',
    form: 'formulario',
    bulk_action: {
      publish: {
        confirm: '¿Estas seguro que quieres activar',
        info: 'Una vez los actives, los podrás volver a desactivar.',
        success: 'Formularios activados con éxito',
        failure: 'Error al activar los formularios',
      },
      unpublish: {
        confirm: '¿Estas seguro que quiere desactivar',
        info: 'Una vez los desactives, los podrás volver a activar.',
        success: 'Formularios desactivados con éxito',
        failure: 'Error al desactivar los formularios',
      },
      delete: {
        confirm: '¿Estas seguro que quieres eliminar',
        info: 'Una vez los elimines, no los podrás volver a recuperar.',
        success: 'Formularios eliminados con éxito',
        failure: 'Error al intentar eliminar los formularios',
      },
    },
    formResults: 'Resultados: ',
    formResultsOf: 'de',
    current_folder: 'Carpeta actual:',
    formLimitReachedTooltip: 'Alcanzaste el límite de formularios permitidos. ',
    upgradePlanTooltipLink: 'Actualiza tu plan',
    upgradePlanTooltip: ' para crear formularios',
    importPermissionError: 'No tienes permisos para importar plantillas de formularios.',
    projectLimitReachedError:
      'No se pudo importar el formulario. Has alcanzado el número máximo de formularios permitidos.',
    folder: 'Carpeta',
    new_form_create: 'Formulario',
    form_ai: 'Formulario con IA',
    forms_limit: {
      title: 'Límite de formularios alcanzado',
      description:
        'Has alcanzado el límite de 3 formularios en tu plan actual. Para crear más formularios, actualiza tu plan y accede a más funciones:',
      benefit1: 'Formularios ilimitados',
      benefit2: 'Más opciones de personalización',
      benefit3: 'Mayor capacidad de almacenamiento',
      confirm: 'Desbloquea más formularios ahora',
      cancel: 'Seguir con versión gratuita',
      confirm_chat_message: 'Hola, necesito crear más formularios. ¿Cómo puedo actualizar mi plan?',
    },
  },
  mobileUsers: {
    users: 'Usuarios',
    new: 'Crear Usuario',
    import: 'Importar',
    import_users: 'Importar Usuarios',
    how_import: '¿Cómo importar usuarios?',
    bulk_actions: 'Acciones Masivas',
    add_users_to_group: 'Agregar usuarios a grupo',
    deactivate_users: 'Deshabilitar usuarios',
    add: 'Agregar',
    add_to_group: 'Agregar a grupo',
    selectAGroup: 'Selecciona un grupo',
    duplicate_user:
      'Ya existe un usuario eliminado con el mismo correo electrónico. Por favor, reactive ese usuario en su lugar',
    identifier_help: 'Necesario para iniciar sesión en el dispositivo móvil',
    advanced: 'Configuración Avanzada',
    old_password_required:
      'no es válido. Para cambiar la contraseña de administrador se requiere confirmación.',
    group_users: 'Grupos de Usuarios',
    group_new: 'Crear Grupo',
    you: 'usted',
    location_perm: 'Permisos a lugares',
    forms_perm: 'Permisos a formularios',
    activated: 'Activos',
    deactivated: 'Desactivados',
    modifications_history: 'Historial',
    noGroups: 'No tienes grupos de usuarios',
    infoNotice:
      'Los usuarios solo podrán ver los formularios y respuestas que les correspondan según su grupo.',
    delete_group: 'Eliminar grupo',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    rename: 'Renombrar',
    rename_group: 'Renombrar grupo',
    group_name: 'Nombre del grupo',
    new_name: 'Nombre nuevo',
    update: 'Actualizar',
    confirm_group_delete: '¿Estás seguro que quieres eliminar el grupo ',
    confirm_group_delete2:
      'Una vez lo elimines, los usuarios que no estén en otros grupos quedarán sin grupo y tendrán los permisos individuales previamente asignados.',
    update_groups_success: 'Cambios realizados con éxito',
    update_groups_error: 'Ocurrió un error al guardar los cambios',
    userInfo: 'Información del usuario',
    userGroupsHelp: 'Este usuario pertenece a los siguientes grupos:',
    manageGroupModalTitle: 'Permisos en',
    searchForm: 'Buscar formulario...',
    searchUser: 'Buscar usuario...',
    groupUpdateSuccess: 'Grupo actualizado exitosamente',
    permissions_title: 'Permisos',
    forms_title: 'Formularios',
    group_name_exists: 'Un grupo con ese nombre ya existe',
    edit_group_permissions: 'Permisos formularios',
    edit_groups: 'Agregar a grupo',
    save: 'Guardar',
    editGroupsInfo:
      'Los usuarios asignados a uno o varios grupos, obtendrán permisos para acceder a los formularios de esos grupos. En consecuencia, no podrán tener formularios asignados de manera individual al mismo tiempo.',
    modifiedGroup: 'Grupo modificado',
    modificationAuthor: 'Modificado por',
    modificationDate: 'Fecha',
    modification: 'Modificación',
    added: 'Agregados',
    removed: 'Eliminados',
    group: 'Grupo',
    createdGroup: 'Grupo creado',
    deletedGroup: 'Grupo eliminado',
    renamedGroup: 'Grupo renombrado',
    emptyHistory: 'No hay historial de modificaciones',
    previousName: 'Nombre anterior',
    assetAssigned: 'Permiso asignado al activo',
    assetRemoved: 'Permiso removido del activo',
    removeFromGroup: 'Eliminar del grupo',
    remove: 'Remover',
    removeUsersConfirm: '¿Estás seguro que quieres remover',
    removeUsersConfirm2: 'usuario(s) del grupo',
    onceUsersRemoved:
      'Una vez los remuevas, estos pasarán a usuarios sin grupo o quedarán en los otros grupos a los que pertenecen.',
    noUsersInGroup: 'Aún no has agregado usuarios a este grupo',
    searchGroups: 'Buscar grupos...',
    pendingConfirmationTitle: 'Confirmación pendiente',
    pendingConfirmationSubtitle: 'Comparte este enlace solo con este usuario',
    copy: 'Copiar',
    linkCopied: 'Enlace copiado!',
    resendInvitation: 'Reenviar',
    deleteGroupPendingSignatureError: 'Grupo contiene usuarios con firmas pendientes',
    invite_user: {
      title: 'Invitar Usuarios',
      placeholder: 'ejemplo@ejemplo.com',
      help: 'Si quieres cambiar los permisos, da clic en configurar permisos',
      btn: 'Invitar',
      config: 'Configurar Permisos',
      successSingular: 'Invitación enviada exitosamente',
      successPlural: 'Invitaciones enviadas exitosamente',
      error:
        'No se pudo invitar a los usuarios, verifique que los correos electrónicos sean válidos y no se hayan utilizado antes',
      emailFormatError: 'Formato de correo incorrecto, por favor utilice ejemplo@ejemplo.com',
      emails: 'Emails',
    },
    permissions: {
      answers: 'Ver respuestas de formularios',
      evaluate: 'Cambiar Estado Respuestas Formularios',
      chat: 'Chatear',
      tasks: 'Responder Formularios',
      assigned: 'Ver Formularios Asignados',
      users: 'Mostrar y crear nuevos usuarios',
      export: 'Exportar Datos',
      metadata: 'Crear Listas Personalizadas',
      modify: 'Modificar Respuestas de Formularios',
      edit_forms: 'Editar Formularios',
      evaluate_delete: 'Eliminar/Recuperar Respuestas Formularios',
      access_to_charts: 'Acceso a gráficos',
      admin_account_config: 'Administrar la configuración de la cuenta',
      admin_signatures: 'Administrar firmas',
      admin_findings: 'Administrar tickets',
      admin_assets: 'Administrar activos',
      admin_places: 'Administrar lugares',
      assign_new_places: 'Asignar automáticamente nuevos lugares',
    },
    roles: {
      customized: 'Customizado',
      administrator: 'Administrador',
      superadmin: 'Administrador Principal',
      supervisor: 'Supervisor',
      editing_operator: 'Operario editor',
      operator: 'Operario',
    },
    table: {
      name: 'Nombre',
      user: 'Usuario',
      role: 'Rol',
      lastConnection: 'Última conexión',
      noLastConnection: 'Última conexión no disponible',
      actions: 'Acciones',
      configure: 'Configurar',
      edit: 'Editar',
      deactivate: 'Deshabilitar',
      activate: 'Habilitar',
      no_data: 'No hay usuarios disponibles',
      groups: 'Grupos',
      viewMore: 'Ver más',
      noForms: 'Este grupo de usuarios no tiene formularios asignados',
      not_confirmed: 'Confirmación Pendiente',
    },
    logs: {
      user: 'Usuario modificado',
      author: 'Autor de la modificación',
      date: 'Fecha',
      modification: 'Modificación',
      activated: 'Reactivado',
      deactivated: 'Eliminado',
    },
    deactivation: {
      cancel: 'Cancelar',
      confirmationTitle: '¿Estás seguro que quieres deshabilitar este usuario?',
      revokesAllTitle: 'Esto le quita el acceso a TODAS sus cuentas',
      revokesAllMessage:
        'En esta cuenta vive su inicio de sesión, así que deshabilitarlo aquí lo deja fuera de las otras %{count} cuentas donde trabaja, no solo de esta. No va a poder revertirlo por su cuenta.',
      revokesAllMessageNoCount:
        'En esta cuenta vive su inicio de sesión, así que deshabilitarlo aquí lo deja fuera de las demás cuentas donde trabaja, no solo de esta. No va a poder revertirlo por su cuenta.',
      confirmationMessage:
        'Los datos no se perderán, luego podrás volverlo a activar en usuarios inactivos.',
      bulkConfirmationTitle: '¿Estás seguro que quieres deshabilitar',
      bulkConfirmationMessage:
        'Los datos no se perderán, luego podrás volverlos a activar en usuarios inactivos.',
      bulkRevokesAllTitle: 'Algunos pierden el acceso a TODAS sus cuentas',
      bulkRevokesAllMessageOne:
        'Uno de los usuarios que seleccionaste tiene su inicio de sesión en esta cuenta (%{emails}). Deshabilitarlo aquí lo deja fuera de todas las demás cuentas donde trabaja, y no va a poder revertirlo por su cuenta.',
      bulkRevokesAllMessage:
        '%{count} de los usuarios que seleccionaste tienen su inicio de sesión en esta cuenta (%{emails}). Deshabilitarlos aquí los deja fuera de todas las demás cuentas donde trabajan, y no van a poder revertirlo por su cuenta.',
      bulkRevokesAllMore: 'y %{count} más',
      bulkImpactPartial:
        'Solo pudimos revisar los primeros %{count} usuarios seleccionados, así que puede haber más.',
      bulkImpactUnavailable:
        'No pudimos verificar si alguno pierde el acceso a sus otras cuentas.',
      impactUnavailable:
        'No pudimos verificar si esto le quita el acceso a todas sus cuentas.',
      success: 'Usuario(s) desactivado(s) exitosamente',
      error: 'Ocurrió un error al desactivar los usuario(s)',
    },
    activation: {
      error: 'Ocurrió un error al activar el usuario',
    },
    createUser: {
      information: {
        title: 'Información',
        name: 'Nombre',
        lastName: 'Apellido',
        email: 'Email',
        example: 'ejemplo@ejemplo.com',
        password: 'Contraseña',
        passwordHelper: 'La contraseña debe tener al menos 6 caracteres',
        emailBelongsToIdentity:
          'Este usuario ya tiene cuenta en DataScope. Ingresará con sus propias credenciales',
        phone: 'Teléfono',
      },
      group: {
        title: 'Grupo',
        selectHelper: 'Selecciona un grupo existente (Puedes seleccionar varios)',
        noGroup: 'Sin grupo',
        newGroup: 'Nuevo grupo',
        newGroupHelper: 'Escribe el nombre del grupo',
        newGroupSuccess: 'Nuevo grupo creado con éxito!',
        newGroupError: 'Ocurrió un error creando el nuevo grupo',
        configuration: 'Debes configurar permisos a formularios para este grupo',
        formsHelp: 'Formularios a los que tendrá acceso este usuario:',
        cantEditPermissions:
          'No puedes cambiar tus propios permisos de grupos. Pide a otra persona que lo haga si deseas modificarlos.',
      },
      forms: {
        title: 'Formularios',
        allForms: 'Formularios',
        addForm: 'Agregar formulario',
        formsHelper: 'Podrás ver los formularios y las respuestas de los seleccionados.',
        formsHelperDisabled: 'Podrás ver estos formularios y sus respuestas.',
        formsGroupHelper:
          'Los formularios y lugares a los que tendrá acceso este usuario son los pertenecientes a el/los grupos previamente elegidos.',
        seeMore: 'ver más',
        groupsAlert:
          'No puedes agregar formularios porque asignaste o creaste un grupo previamente',
        back: 'Atras',
        folders: 'Carpetas',
        close: 'Cerrar',
        formHasPendingSignature:
          'Este usuario tiene firmas pendientes. Mientras no se respondan o eliminen no podrás modificar los permisos.',
        massSelectionBlockedByPendingSignature:
          'Selección masiva de formularios bloqueada por firmas pendientes.',
        foldersBlockedByPendingSignature:
          'Selección de carpetas bloqueada por firmas pendientes. Abre la carpeta para seleccionar formularios.',
        cantEditPermissions:
          'No puedes cambiar tus propios permisos de formularios. Pide a otra persona que lo haga si deseas modificarlos.',
      },
      permissions: {
        title: 'Permisos',
        editingMyself:
          'No puedes cambiar tus propios permisos. Pide a otra persona que lo haga si deseas modificarlos.',
        basic: {
          title: 'Básico',
          viewFormAnswers: 'Ver respuestas de formularios',
          chat: 'Chatear',
          submitFormAnswers: 'Responder formularios',
          viewAssignedForms: 'Ver formularios asignados',
        },
        advanced: {
          title: 'Avanzado',
          changeFormStatus: 'Cambiar estado de formularios',
          createMetadata: 'Crear listas personalizadas',
          editFormAnswers: 'Modificar respuestas de formularios',
          editForms: 'Editar formularios',
          evaluateDelete: 'Eliminar y recuperar respuestas de formularios',
          accessToCharts: 'Acceso a gráficos',
          assignNewPlaces: 'Asignar automáticamente nuevos lugares',
        },
        admin: {
          title: 'Administración',
          viewAndCreateUsers: 'Mostrar y crear nuevos usuarios',
          exportData: 'Exportar datos',
          adminAccountConfig: 'Administrar la configuración de la cuenta',
          adminSignatures: 'Administrar firmas',
          adminFindings: 'Administrar tickets',
          adminAssets: 'Administrar activos',
          adminPlaces: 'Administrar lugares',
        },
        editFormsTooltip1: 'Este usuario no tiene permiso para editar formularios. ¡',
        editFormsTooltipLink: 'Actualiza tu plan',
        editFormsTooltip2: ' ahora y desbloquea la productividad sin límites!',
      },
      locations: {
        title: 'Lugares (Opcional)',
        helper:
          'Si activas esta opción, el usuario sólo podrá ver los formularios asociados a los lugares que selecciones',
        locations: 'Lugares',
        andOthers: ', y otros...',
        cantEditPermissions:
          'No puedes cambiar tus propios permisos de lugares. Pide a otra persona que lo haga si deseas modificarlos.',
        allLocationsAccessBanner:
          'Este usuario tiene acceso a todos los lugares ya creados. Si quieres restringir los lugares que puede ver, deberás seleccionarlos manualmente desde esta sección.',
        allNewLocationsAccessBadge: 'Acceso a todos los lugares nuevos',
      },
      signature: {
        name: 'Nombre completo',
        companyName: 'Nombre sociedad',
        pronoun: 'Tu',
        userIdNumber: {
          default: 'Número de identificación',
          CL: 'RUT',
          PE: 'DNI',
          MX: 'CURP/RFC',
          CO: 'CC',
          AR: 'DNI',
          PY: 'CI',
          ES: 'DNI/NIE',
          BR: 'CPF',
          UY: 'CI',
          BO: 'CI',
          EC: 'Cédula',
          VE: 'Cédula de identidad',
          US: 'SSN/DL/PP/ID',
          CA: 'SIN',
          DO: 'Cédula de identidad y electoral',
          CR: 'Cédula',
          PA: 'Cédula',
          GT: 'DPI',
          SV: 'DUI',
          HN: 'DNI',
          NI: 'Cédula',
          PR: 'SSN',
          CU: 'CI',
          JM: 'TRN',
          PT: 'NIF',
          FR: 'INSEE',
          DE: 'Personalausweisnummer/Steuer-ID',
          IT: 'Codice Fiscale',
          GB: 'Número de Seguro Nacional',
          IE: 'Número PPS',
          NL: 'BSN',
          BE: 'Número Nacional',
          CH: 'Número AHV',
          AT: 'Número de Seguridad Social',
          SE: 'Número Personal',
          NO: 'ID Nacional',
          DK: 'Número CPR',
          FI: 'Código de Identidad Personal',
          IS: 'Kennitala',
          PL: 'PESEL',
          CZ: 'Número de Nacimiento',
          SK: 'Número de Nacimiento',
          HU: 'Número Tributario',
          RO: 'CNP',
          BG: 'EGN',
          GR: 'AMKA/AFM',
          HR: 'OIB',
          SI: 'EMSO',
          RS: 'JMBG',
          BA: 'JMBG',
          ME: 'JMBG',
          MK: 'EMBG',
          MT: 'Tarjeta de ID',
          CY: 'Número de ID',
          LU: 'ID Nacional',
          LT: 'Código Personal',
          LV: 'Código Personal',
          EE: 'Código Personal',
          TR: 'TC Kimlik No',
          IL: 'Número de ID',
          SA: 'ID Nacional',
          AE: 'Emirates ID',
          QA: 'QID',
          KW: 'ID Civil',
          BH: 'CPR',
          OM: 'ID Civil',
          JO: 'ID Nacional',
          LB: 'Número de ID',
          EG: 'ID Nacional',
          MA: 'CIN',
          TN: 'CIN',
          DZ: 'ID Nacional',
          ZA: 'Número de ID',
          NG: 'NIN',
          KE: 'Número de ID',
          GH: 'Ghana Card',
          UG: 'ID Nacional',
          TZ: 'NIDA',
          RW: 'ID Nacional',
          BW: 'Omang',
          NA: 'Número de ID',
          ZM: 'NRC',
          ZW: 'ID Nacional',
          ET: 'ID Nacional',
          CN: 'ID Nacional',
          IN: 'Aadhaar',
          PK: 'CNIC',
          BD: 'NID',
          JP: 'My Number',
          KR: 'RRN',
          SG: 'NRIC/FIN',
          MY: 'MyKad',
          ID: 'KTP',
          PH: 'UMID',
          TH: 'ID Nacional',
          VN: 'CCCD',
          HK: 'HKID',
          TW: 'ID Nacional',
          LK: 'NIC',
          NP: 'ID Nacional',
          AU: 'TFN/Medicare',
          NZ: 'Número IRD',
          RU: 'SNILS',
          UA: 'Número Tributario',
          BY: 'ID Nacional',
          KZ: 'IIN',
          UZ: 'PINFL',
          GE: 'Número Personal',
          AM: 'Tarjeta Social',
          AZ: 'FIN',
        },
        country: 'País',
        selectCountry: 'Selecciona un país',
        noResults: 'No se encontraron países',
        userEmail: 'Email personal',
        legalRepresentative: 'Representante legal',
        companyIdNumber: {
          default: 'Número de identificacion tributaria',
          CL: 'RUT',
          PE: 'RUC',
          MX: 'RFC',
          CO: 'NIT',
          AR: 'CUIT',
          PY: 'RUC',
          ES: 'NIF',
          BR: 'CNPJ',
          UY: 'RUT',
          BO: 'NIT',
          EC: 'RUC',
          VE: 'RIF',
          US: 'EIN',
          CA: 'BN',
          DO: 'RNC',
          CR: 'Cédula Jurídica',
          PA: 'RUC',
          GT: 'NIT',
          SV: 'NIT',
          HN: 'RTN',
          NI: 'RUC',
          PR: 'EIN',
          CU: 'NIT',
          JM: 'TRN',
          PT: 'NIPC',
          FR: 'SIREN',
          DE: 'Número Tributario',
          IT: 'Partita IVA',
          GB: 'Número',
          IE: 'Número',
          NL: 'KvK',
          BE: 'BCE/KBO',
          CH: 'UID',
          AT: 'Número Tributario',
          SE: 'Número Org',
          NO: 'Número Org',
          DK: 'CVR',
          FI: 'Y-tunnus',
          IS: 'Kennitala',
          PL: 'NIP',
          CZ: 'IČO',
          SK: 'IČO',
          HU: 'Número Tributario',
          RO: 'CUI',
          BG: 'UIC',
          GR: 'AFM',
          HR: 'OIB',
          SI: 'Número Tributario',
          RS: 'PIB',
          BA: 'Número Tributario',
          ME: 'Número Tributario',
          MK: 'Número Tributario',
          MT: 'Número IVA',
          CY: 'Número Tributario',
          LU: 'Número Tributario',
          LT: 'Código',
          LV: 'Número',
          EE: 'Código',
          TR: 'Número Tributario',
          IL: 'Número',
          SA: 'Número CR',
          AE: 'Licencia Comercial',
          QA: 'Número CR',
          KW: 'Número CR',
          BH: 'Número CR',
          OM: 'Número CR',
          JO: 'Número Tributario',
          LB: 'Número Tributario',
          EG: 'Número Tributario',
          MA: 'RC',
          TN: 'Número Tributario',
          DZ: 'NIS',
          ZA: 'Número',
          NG: 'Número RC',
          KE: 'PIN',
          GH: 'TIN',
          UG: 'TIN',
          TZ: 'TIN',
          RW: 'TIN',
          BW: 'Número Tributario',
          NA: 'Número Tributario',
          ZM: 'TPIN',
          ZW: 'Número Tributario',
          ET: 'TIN',
          CN: 'USCI',
          IN: 'CIN',
          PK: 'NTN',
          BD: 'TIN',
          JP: 'Número',
          KR: 'Número de Registro',
          SG: 'UEN',
          MY: 'Número SSM',
          ID: 'NPWP',
          PH: 'TIN',
          TH: 'ID Tributario',
          VN: 'Código Tributario',
          HK: 'Número BR',
          TW: 'UBN',
          LK: 'Número BRC',
          NP: 'PAN',
          AU: 'ABN',
          NZ: 'NZBN',
          RU: 'INN',
          UA: 'EDRPOU',
          BY: 'UNP',
          KZ: 'BIN',
          UZ: 'Número Tributario',
          GE: 'Número Tributario',
          AM: 'Número Tributario',
          AZ: 'Número Tributario',
        },
        companyLabel: 'empresa',
        address: 'Dirección',
        companyEmailError: 'Debes usar un correo electrónico diferente',
        userIdNumberError: 'inválido',
        userIdNumberSuccess: 'ha sido verificado',
        companyIdNumberError: 'inválido',
        companyIdNumberSuccess: 'ha sido verificado',
      },
      cancel: 'Cancelar',
      save: 'Guardar',
      success: 'Nuevo usuario creado con éxito!',
      error: 'Ocurrió un error creando el usuario',
    },
    editUser: {
      information: {
        oldPassword: 'Contraseña actual',
        newPassword: 'Contraseña nueva',
        passwordChange: 'Cambiar contraseña',
        error: 'Ocurrió un error actualizando el usuario',
        success: 'Usuario actualizado con éxito!',
      },
    },
    createGroup: {
      button: 'Crear grupo',
      title: 'Crear grupo de usuarios',
      chooseHeader: '¿Cómo quieres crear el grupo?',
      name: 'Nombre grupo',
      nameHelper: 'Nombre del grupo',
      userSelection: 'Selección usuarios',
      formSelection: 'Selección formularios',
      importExcelNote: '*Luego tendrás que asignarle permisos a formularios',
      warning:
        'Los usuarios asignados a un grupo accederán a los formularios de ese grupo y no podrán tener formularios asignados de manera individual al mismo tiempo.',
      empty_state: {
        title: 'Segmenta formularios y tareas por grupos de usuarios',
        subtitle: '¿Qué es un grupo de usuarios?',
        descriptionPart1:
          'Los grupos de usuarios permiten controlar qué información ve cada persona. Al asignar formularios a un grupo, solo sus miembros podrán acceder a esos formularios y a sus datos.',
        descriptionPart2:
          'Esto asegura que cada usuario vea únicamente lo que le corresponde según su rol o área, mejorando el control y la seguridad de la información.',
        block1: {
          title: '¿Por qué usar grupos de usuarios?',
          card1: {
            title: 'Control y seguridad de la información',
            description:
              'Agrupa usuarios con permisos y accesos especiales. Protege datos sensibles y asegura la confidencialidad.',
          },
          card2: {
            title: 'Gestión de equipos simplificada',
            description:
              'Asigna permisos por grupo para administrar equipos fácilmente. Ahorra tiempo y evita errores manuales.',
          },
          card3: {
            title: 'Optimiza la experiencia del equipo',
            description:
              'Muestra solo la información relevante para cada usuario. Agiliza procesos y mejora el trabajo en terreno.',
          },
        },
        block2: {
          title: 'Crea tu primer grupo de usuarios',
          demo1: {
            title: 'A través de DataScope',
            description:
              'Crea un grupo de usuarios directamente desde DataScope seleccionando manualmente los usuarios y formularios asociados.',
          },
          demo2: {
            title: 'Importando tu lista de usuarios',
            description:
              'Descarga la plantilla Excel desde DataScope, completa los datos de tus usuarios y súbela nuevamente a la plataforma. ¡Importante! No modifiques los encabezados y respeta el formato para garantizar una carga exitosa.',
          },
          next: 'Siguiente',
          previous: 'Anterior',
        },
        block3: {
          title: 'Agrupa, asigna y simplifica',
          description:
            'Ahora que conoces cómo funcionan los grupos, crea uno, empieza a usarlos en tus tareas diarias y empieza a optimizar tus operaciones',
        },
      },
    },
    setProfile: {
      completeProfile: 'Completa tu perfil',
      completeProfileDescription:
        'Por favor, completa los siguientes datos para ingresar a DataScope',
      newPassword: 'Nueva contraseña',
      name: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      save: 'Finalizar',
      updateSuccess: 'Perfil actualizado con éxito',
      updateError: 'Ocurrió un error al actualizar el perfil',
      identifier: 'Identificador',
    },
    exportUsers: {
      export: 'Exportar',
      success: 'Usuarios exportados con éxito!',
      error: 'No se pudo exportar los usuarios',
    },
    importUsers: {
      blockedUsersTitle: '%{blocked} correo(s) no se pueden importar',
      blockedUsersBody:
        'Estos correos ya están en uso en DataScope y no se pueden crear en esta cuenta. El resto del archivo se importa igual.',
      blockedUsersListTitle: 'Correos que no se pueden importar',
      previewUnavailable:
        'No pudimos verificar si alguno de estos usuarios ya tiene cuenta en DataScope. La importación continúa igual.',
      previewTooLarge:
        'Este archivo es demasiado grande para previsualizar, así que no pudimos verificar quién ya tiene cuenta en DataScope. La importación va a funcionar igual.',
      existingUsersTitle: '%{linked} de %{total} usuarios ya tienen cuenta en DataScope',
      existingUsersBody:
        'Estos usuarios conservarán sus credenciales actuales. La contraseña del archivo solo se aplicará a los otros %{new} usuario(s).',
      existingUsersListTitle: 'Usuarios que ya tienen cuenta en DataScope',
      invalidFileType: 'Tipo de archivo inválido. Por favor, sube un archivo .xlsx',
      dragDropHere: 'Arrastra y suelta tu archivo Excel aquí',
      orBrowse: 'o navega',
      downloadSuccess: 'Modelo descargado con éxito!',
      downloadError: 'No se pudo descargar el modelo',
      uploadSuccess: 'Archivo subido con éxito!',
      uploadError: 'No se pudo subir el archivo',
      importTitle: 'Importar Usuarios',
      upload: 'Importar',
      downloadStep: 'Paso 1: Descarga el archivo modelo',
      downloadStepHelper: 'Descarga el archivo modelo para completar la información del usuario',
      editStep: 'Paso 2: Edita el archivo',
      editStepHelper: 'Edita el archivo Excel y completa los campos requeridos *.',
      uploadStep: 'Paso 3: Sube el archivo',
      uploadStepHelper: 'Sube el archivo editado para importar usuarios.',
      downloadTemplate: 'Descargar Ejemplo',
      afterUploadInfo:
        'Después de subir, los usuarios serán procesados y se te notificará si hay errores.',
      replace: 'Reemplazar',
      fileLoadedMessage: 'Tu archivo ha sido cargado',
    },
  },
  login: {
    greeting: '¡Hola de nuevo!',
    loginHelper: 'Para continuar, ingresa tus credenciales',
    googleLogin: 'Inicia sesión con Google',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    login: 'Iniciar sesión',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate aquí',
    success: 'Inicio de sesión exitoso',
    error: 'Error al iniciar sesión',
    wrongCredentials: 'Email o contraseña incorrectos. Verifica tus datos e intenta nuevamente.',
    logoutError: 'Error al cerrar sesión',
    recaptchaError: 'Verificación de captcha falló. Por favor, intenta nuevamente.',
    mfaTitle: 'Autenticación de dos factores',
    mfaSubtitle: 'Ingresa el código de 6 dígitos de tu aplicación de autenticación',
    mfaCodeLabel: 'Código de verificación',
    verify: 'Verificar',
    backToLogin: '← Volver al inicio de sesión',
    invalidMfaCode: 'Por favor, ingresa un código válido de 6 dígitos',
    invalidMfaCodeError: 'Código de verificación inválido. Por favor, intenta nuevamente.',
    mfaStatusError: 'Error al consultar el estado de 2FA',
    mfaEnableError: 'Error al habilitar MFA',
    mfaEnabledSuccess: 'MFA habilitado correctamente',
    mfaVerifyError: 'Error al verificar MFA',
    mfaDisableError: 'Error al deshabilitar MFA',
    mfaDisabledSuccess: 'MFA deshabilitado correctamente',
    mfaSetupTitle: 'Configura tu app autenticadora',
    mfaScanQr: 'Escanea el código QR con tu app autenticadora.',
    mfaSecretCode: 'Código secreto',
    mfaCancel: 'Cancelar',
    mfaClose: 'Cerrar',
    mfaSetup: 'Configurar MFA',
    mfaDisable: 'Deshabilitar MFA',
    ssoLogin: 'Inicio de sesión SSO',
    ssoSubtitle: 'Para continuar, ingresa tu correo electrónico corporativo',
    ssoCompanyEmail: 'Correo Corporativo',
    ssoCompanyEmailPlaceholder: 'Ingresa tu dirección de correo corporativo',
    ssoValidating: 'Validando tu correo...',
    ssoContinue: 'Continuar con SSO',
    ssoHelpText: 'Te redirigiremos a la página de inicio de sesión de tu empresa',
    ssoBackToLogin: 'Iniciar sesión con contraseña',
    ssoSignInWithSSO: 'Iniciar sesión con SSO',
    ssoCompletingAuth: 'Completando autenticación...',
    ssoVerifyingCredentials: 'Verificando tus credenciales',
    ssoAuthSuccessful: '¡Autenticación exitosa!',
    ssoAuthFailed: 'Autenticación fallida',
    ssoRedirecting: 'Redirigiendo...',
    ssoError: 'La autenticación SSO falló. Por favor, intenta nuevamente.',
    ssoTooManyAttempts: 'Demasiados intentos de inicio de sesión. Por favor, intenta más tarde.',
    ssoInvalidIdentifier:
      'Dirección de correo inválida. Por favor, verifica tu correo corporativo e intenta nuevamente.',
    ssoFailedValidation:
      'Falló la validación del correo. Por favor, verifica tu correo corporativo e intenta nuevamente.',
    ssoNoAccountsFound:
      'No se encontraron cuentas habilitadas para SSO para este dominio de correo.',
    ssoFailedStatus: 'Error al verificar el estado de SSO. Por favor, inténtalo de nuevo.',
    secureLoginMessage:
      'Estás iniciando sesión con tu cuenta corporativa a través de un inicio seguro.',
    ssoFailedInitiate: 'Error al iniciar el login SSO. Por favor, inténtalo de nuevo.',
    checkingAuthentication: 'Verificando autenticación...',
    ssoConnecting: 'Conectando con tu cuenta corporativa...',
    ssoRedirectingToSSO:
      'Te estamos redirigiendo al inicio de sesión seguro de tu empresa para completar el acceso.',
    ssoNoSSO: 'Esta cuenta no utiliza inicio de sesión único (SSO).',
    ssoContinueWith: 'Continuar con',
    ssoAuthenticationFailed: 'Autenticación fallida. Por favor, intenta nuevamente.',
    ssoAuthenticationError: 'Ocurrió un error al autenticar. Por favor, intenta nuevamente.',
    ssoAuthenticationProcessing: 'Procesando autenticación...',
    ssoAuthenticationFailedRedirect: 'Autenticación fallida. Redirigiendo a inicio de sesión...',
    ssoAuthenticationCompleting: 'Completando autenticación...',
    ssoFailedProviderLogin: 'Error al iniciar el login con el proveedor seleccionado.',
    ssoSelectProvider: 'Selecciona una opción para continuar',
  },
  forgotPassword: {
    title: 'Restablecer contraseña',
    description:
      'Ingresa tu correo y te enviaremos un enlace para que puedas cambiar tu contraseña.',
    email: 'Correo electrónico',
    continue: 'Continuar',
    backToLogin: 'Volver a inicio de sesión',
    success:
      'Si el correo ingresado es válido, te enviaremos un mensaje con los pasos. Si no lo ves, revisa tu bandeja de spam.',
    error: 'Ocurrió un error al enviar el correo, por favor intenta nuevamente.',
    recaptchaError: 'Verificación de captcha falló. Por favor, intenta nuevamente.',
  },
  resetPassword: {
    title: 'Cambiar contraseña',
    description: 'Escribe y confirma tu nueva contraseña.',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    continue: 'Reestablecer contraseña',
    passwordsMatchError: 'Las contraseñas no coinciden',
    success: 'Contraseña actualizada con éxito',
    error: 'Ocurrió un error al actualizar la contraseña, por favor intenta nuevamente.',
  },
  changePassword: {
    title: 'Cambia tu contraseña',
    description: 'Ingresaste con una contraseña temporal. Define una nueva contraseña para continuar.',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    continue: 'Cambiar contraseña',
    passwordsMatchError: 'Las contraseñas no coinciden',
    minLengthError: 'La contraseña debe tener al menos 6 caracteres',
    success: 'Contraseña actualizada. Ya puedes continuar.',
    error: 'Ocurrió un error al cambiar la contraseña, por favor intenta nuevamente.',
  },
  signUp: {
    emailExistsTitle: 'Este correo ya existe',
    emailExistsBody:
      'Inicia sesión con %{email} para agregar esta cuenta a tu identidad y cambiar entre tus cuentas sin volver a iniciar sesión.',
    useAnotherEmail: 'Usar otro correo',
    title: 'Regístrate ahora',
    subtitle: 'Sin tarjeta de crédito, cancela en cualquier momento',
    templatePreviewTitle: 'Estás a solo un paso de usar:',
    name: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electrónico',
    password: 'Contraseña',
    companyName: 'Empresa',
    role: 'Cargo',
    phoneNumber: 'País y teléfono',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    signUp: 'Crear cuenta',
    error: 'Ocurrió un error al registrar el usuario, por favor intenta nuevamente.',
    privacyPolicyText: 'Haciendo click aseguras de que estás de acuerdo con nuestra',
    privacyPolicyLink: 'Política de privacidad',
    emailError: 'Correo electrónico inválido',
    phoneNumberError: 'Número de teléfono inválido',
    passwordError: 'La contraseña debe tener al menos 6 caracteres',
  },
  templates: {
    total_templates: 'Total plantillas: ',
    see_all: 'Ver todas',
    showing_results: 'Mostrando resultados de',
    categories: 'Categorías',
    in: 'en',
    useTemplate: 'Usar plantilla',
    loginToAnswerTemplate: 'Podrás responder esta plantilla después de ingresar a tu cuenta',
    backToDataScope: 'Volver a DataScope',
    noResults: '¡No hemos encontrado lo que buscas, pero nos encantaría encontrar la solución!',
    contactSupport: 'Cuéntanos qué formulario necesitas via chat',
    next: 'Siguiente',
    back: 'Atrás',
    useCase: 'Puede ser usado para:',
    createdBy: 'Creado por',
    anonymousUser: 'Usuario anónimo',
    preview: 'Vista previa',
    editableTemplate: 'Esta plantilla es editable una vez que se importa.',
    allTemplates: 'Plantillas',
    noDescription: 'Sin descripción',
    bannerSlogan: 'Transforma tus operaciones con tecnología móvil',
    templateView: 'Vista plantilla',
    seeLess: 'Ver menos',
    seeMore: 'Ver más',
    importError: {
      formLimitReached:
        'Límite de formularios alcanzado. Por favor actualiza tu plan para importar más formularios.',
      alreadyImported: 'Este formulario ya ha sido importado.',
      validationError: 'Error de validación al importar la plantilla.',
      loginRequired: 'Debes iniciar sesión para importar plantillas.',
      genericError: 'Ocurrió un error al importar la plantilla. Por favor intenta nuevamente.',
      invalidUrl: 'URL de plantilla inválida. Por favor verifica el enlace e intenta nuevamente.',
    },
  },
  navbar: {
    features: 'Funcionalidades',
    solutions: 'Soluciones',
    work_orders: 'Órdenes de Trabajo',
    safety: 'Seguridad y Salud en el Trabajo',
    inspections: 'Inspecciones',
    quality: 'Controles de Calidad',
    resources: 'Recursos',
    blog: 'Blog',
    ds_academy: 'Academia DataScope',
    digitize: 'Sube tu formulario',
    roi: 'Calculadora de Ahorro',
    pricing: 'Precios',
    sales: 'Contáctanos',
    wapp: 'Hablemos por WhatsApp',
    call: 'Agenda un llamado',
    demo: 'Solicita una demo',
    sign_in: 'Iniciar Sesión',
    sign_up: 'Prueba Gratis',
    log_out: 'Cerrar Sesión',
    paths: {
      work_orders: 'ordenes-trabajo',
      safety: 'seguridad',
      inspections: 'inspecciones',
      quality: 'calidad',
      blog: 'blog',
      ds_academy: 'como-usar-datascope',
      digitize: 'sube-tu-formulario',
      roi: 'roi-chile',
    },
  },
  uiComponents: {
    search: 'Buscar',
    showingResultsFor: 'Mostrando resultados de búsqueda para',
    found: 'encontrados',
    cancel: 'Cancelar',
    selected: 'seleccionados',
    confirm: 'Confirmar',
    close: 'Cerrar',
    chooseMethodDialog: {
      fromDatascope: 'Desde DataScope',
      importExcel: 'Importar Excel',
    },
    signature: {
      title: 'Firma electrónica',
      alert:
        'Completa la siguiente información para activar la firma electrónica. El nombre y apellido en el área de información son necesarios para crear tu firma.',
      accountAlert: ' Recuerda hacer clic en "Guardar firma".',
      saveSignature: 'Guardar firma',
      completeSignatureWarning:
        'Debes completar todos los campos obligatorios para poder guardar tu firma',
      signatureRequiredFieldError: 'Este campo es obligatorio para crear la firma electrónica',
      updateSuccess: 'Firma actualizada con éxito',
      updateError: 'Ocurrió un error al actualizar la firma',
      invalidEmailError: 'Correo electrónico inválido',
      emailExistsError: 'El correo electrónico se encuentra en uso',
      validatingRut: 'Validando RUT...',
      emailErrors: {
        REGEX_INVALID: 'Correo electrónico inválido',
        IN_USE: 'El correo electrónico se encuentra en uso',
      },
    },
  },
  accountConfig: {
    information: {
      title: 'Configuración de cuenta',
      name: 'Nombre empresa',
      description: 'Descripción empresa',
      email: 'Email empresa',
      phone: 'Teléfono empresa',
      address: 'Dirección empresa',
      timezone: 'Zona horaria',
      locale: 'Idioma',
      dateFormat: 'Formato fecha',
      dateFormatDescription:
        'Define cómo quieres que se muestren las fechas en tu resumen, reportes y formularios.',
      dateFormatDdMm: 'dd/mm/YYYY',
      dateFormatDdMmExample: 'Ejemplo: 25/12/2024',
      dateFormatMmDd: 'mm/dd/YYYY',
      dateFormatMmDdExample: 'Ejemplo: 12/25/2024',
      dateFormatPreview: 'Vista previa',
      logo: 'Logo',
      uploadLogo: 'Imagen',
      logoDescription:
        'La imagen debe estar en formato .PNG o .JPG y el tamaño debe ser 400x400 px con un peso no mayor a 2MB.',
      logoSizeError: 'El máximo tamaño de imagen permitido es de 2MB',
      saveSuccess: 'Configuración actualizada con éxito',
      saveError: 'Ocurrió un error al actualizar la configuración',
      pdfAlert: 'La información aquí configurada aparecerá en el encabezado del PDF estándar.',
      confirmDeleteLogo: '¿Estás seguro que quieres eliminar el logo?',
      languages: {
        es: 'Español',
        en: 'English',
        pt: 'Português',
      },
      exampleLabel: 'Ejemplo:',
      dateLabel: 'Fecha:',
      timeLabel: 'Hora:',
      dateTimeLabel: 'Fecha y hora:',
      dateFormatProfiles: {
        european: 'Europeo',
        english: 'Inglés',
      },
    },
    advancedConfig: {
      title: 'Configuración avanzada',
      activateSupportUser: 'Otorgar acceso al usuario de soporte DataScope',
      securityConfig: 'Configuración de seguridad',
      deactivateAccount: 'Deshabilitar cuenta',
      confirmTitle: '¿Estás seguro que deseas desactivar tu cuenta?',
      confirmMessage:
        'Esta acción es irreversible. También se desactivarán todos los usuarios y datos asociados a esta cuenta.',
    },
    mfaConfig: {
      title: 'Seguridad de la cuenta (2FA)',
      subtitle:
        'Protege tu cuenta con un nivel adicional de seguridad.\nAl activarlo, se solicitará un código temporal desde tu app autenticadora al iniciar sesión.',
      activateMfa: 'Activar autenticación en dos pasos',
      configMode: '¿Cómo quieres configurarla a los usuarios de tu cuenta?',
      optional: 'Opcional',
      mandatory: 'Obligatoria',
      optionalDescription: 'Cada usuario podrá activarla desde su configuración de usuario',
      mandatoryDescription: 'Todos los miembros deberán configurarla para acceder a la plataforma',
    },
  },
  notifications: {
    title: 'Notificaciones',
    searchPlaceholder: 'Buscar por nombre formulario...',
    viewFormAnswer: 'Ver respuesta',
    viewExcel: 'Ver Excel',
    viewPdf: 'Ver PDF',
    downloadZip: 'Descargar ZIP',
    tableHeaders: {
      date: 'Fecha',
      type: 'Tipo',
      form: 'Formulario',
      formCode: 'Código',
      user: 'Usuario',
      location: 'Lugar',
      actions: 'Acciones',
    },
    formExport: 'Exportación de formulario',
    formAnswer: 'Respuesta de formulario',
    bulkPdfZip: 'Descarga masiva de PDF',
    filters: {
      title: 'Filtros',
      filterByType: 'Por tipo',
      filterByLocation: 'Por lugar',
      filterByUser: 'Por usuario',
      filterByDateRange: 'Por rango de fecha',
      startDate: 'Inicio',
      endDate: 'Fin',
      invalidDate: 'Fecha inválida',
      invalidDateRange: 'Rango de fechas inválido',
      to: 'hasta',
      eraseAll: 'Borrar todo',
      apply: 'Aplicar',
      formAnswers: 'Respuestas',
      formExports: 'Exportaciones',
      clear: 'Borrar',
      locationPlaceholder: 'Selecciona un lugar',
      userPlaceholder: 'Selecciona un usuario',
      showingResultsFor: 'Mostrando resultados de búsqueda para',
    },
    noNotifications: 'No tienes notificaciones en este momento',
    noResults: 'No se encontraron notificaciones relacionadas con los filtros aplicados',
    limitReached:
      'Su cuenta alcanzó el límite, debes activar la cuenta para habilitar nuevamente las funcionalidades.',
    zipDownloadError: 'No se pudo descargar el ZIP. Inténtalo de nuevo.',
  },
  formEmailBuilder: {
    message: 'Mensaje',
    subject: 'Asunto',
    senderName: 'Nombre remitente del correo',
    addFooter: 'Agregar Firma',
    footerTitle: 'Firma',
    notification: 'Notificación',
    autoNotify: 'Notificar a los correos fijos',
    save: 'Guardar',
    cancel: 'Cancelar',
    linkName: 'Link descarga PDF formulario',
    linkNamePlaceholder: 'Escribe el nombre que quieres que tenga link',
    linkNameHelp: 'El nombre que configures será el del link de descarga que llegará al correo.',
    saveSuccess: 'Configuraciones guardadas con éxitos',
    saveError: 'Ocurrió un error al guardar las configuraciones',
    autoGeneratePdf: 'Generar PDF automáticamente',
  },
  formSignatureBuilder: {
    signatureTitle: 'Activación Firma',
    checkboxSignatureActivate: 'Activar firma electrónica',
    settingsTitle: 'Configuración general',
    save: 'Guardar',
    cancel: 'Cancelar',
    saveSuccess: 'Configuración guardada con éxito',
    saveError: 'Ocurrió un error al guardar la configuración',
    saveErrorReload:
      'Ocurrió un error al guardar la configuración. Por favor, recargue la página e intente nuevamente',
    accountSignatureConfigError: 'Falta configurar la firma electrónica de la cuenta',
    generalSettings: 'Configuración general',
    mandatorySignature:
      'Firma obligatoria (Todos los usuarios configurados deben responder a la solicitud, ya sea firmando o rechazándola)',
    optionalSignature: 'Firma opcional (Uno de los firmantes configurados debe firmar)',
    signersSettings: 'Configuración firmantes',
    authorMustSign: 'El usuario que envíe una respuesta también debe firmar',
    fixedSignerTitle: 'Firmante fijo',
    changeSelection: 'Cambiar selección',
    dynamicSignerTooltip:
      'Los firmantes dinámicos están disponibles en el plan Enterprise. Actualiza tu plan y accede a esta y más funciones avanzadas.',
    upgradePlan: 'Actualiza tu plan',
    quorumBlockedTitle: 'Quórum de firmas',
    quorumBlockedEnterpriseChip: 'Enterprise',
    quorumBlockedDescription:
      'Permite que un documento avance al alcanzar un número mínimo de firmas, sin requerir la firma de todos los firmantes. Disponible en el plan Enterprise.',
    quorumBlockedCta: 'Conocer los planes',
    pricingEmptyStateTag: 'Disponible en Professional y Enterprise',
    pricingEmptyStateTitle: 'Gestiona firmas y aprobaciones en un solo lugar',
    pricingEmptyStateIntro:
      'Garantiza la trazabilidad de cada aprobación y reduce errores en tus procesos de firma.',
    pricingEmptyStateFeature1: 'Solicita firmas y envía notificaciones automáticas.',
    pricingEmptyStateFeature2: 'Define procesos de aprobación y seguimiento.',
    pricingEmptyStateFeature3: 'Mantén trazabilidad de cada documento firmado.',
    pricingEmptyStateDtBanner: 'Firma electrónica validada por la Dirección del Trabajo',
    pricingEmptyStateKnowPlans: 'Conocer los planes',
    pricingEmptyStateContactSales: 'Hablar con ventas',
    pricingEmptyStateContactSalesMessage:
      'Hola, me interesa la firma electrónica. ¿Me cuentan los planes?',
    pricingEmptyStateDemoTitle: 'Conoce el proceso de firma de principio a fin',
    pricingEmptyStateEnterpriseChip: 'Enterprise',
    pricingEmptyStatePrev: 'Anterior',
    pricingEmptyStateNext: 'Siguiente',
    pricingEmptyStateSlide1Title: 'Define quién firma y en qué orden',
    pricingEmptyStateSlide1Description:
      'Configura uno o varios firmantes para cada documento. Puedes solicitar firmas simultáneas o definir una secuencia de aprobación según tu proceso.',
    pricingEmptyStateSlide2Title: 'Haz seguimiento de cada solicitud',
    pricingEmptyStateSlide2Description:
      'Revisa el estado de tus solicitudes de firma y conoce quién debe firmar a continuación. Mantén visibilidad de cada documento sin salir de DataScope.',
    pricingEmptyStateSlide3Title: 'Accede a documentos e historial de firmas',
    pricingEmptyStateSlide3Description:
      'Consulta documentos firmados, fechas y participantes para mantener un registro centralizado de cada aprobación.',
    pricingEmptyStateSlide4Title: 'Firma dinámica y quórums de aprobación',
    pricingEmptyStateSlide4Description:
      'Define firmantes automáticamente a partir de respuestas del formulario o permite que un documento avance cuando se alcance el número mínimo de firmas requeridas.',
    assignOwner: 'Asignar responsable',
    searchPlaceholder: 'Buscar usuario o grupo',
    usersTab: 'Usuarios',
    groupsTab: 'Grupos',
    addButton: 'Agregar',
    cancelButton: 'Cancelar',
    externalUsers: 'Usuarios externos',
    externalUsersDescription: 'Los usuarios externos podrán ver y firmar el formulario',
    selectResponsible: 'Selecciona el responsable de la solicitud',
    addResponsible: 'Agregar responsable',
    selectUsersToSign: 'Selecciona los usuarios que deben firmar el documento',
    selectResponsibleTooltip:
      'El usuario seleccionado podrá seguir el estado de todas las solicitudes y editarlas, pero no podrá firmar. Para que firme, debe añadirse a la lista de firmantes',
    simultaneousSign: 'Firma Simultánea',
    sequentialSign: 'Secuencia de firmas',
    simultaneousSignInfo: 'La solicitud se enviará al mismo tiempo a todos los usuarios',
    sequentialSignInfo: 'La solicitud se enviará en el orden que establezcas',
    simultaneousEmptyState: 'Arrastra aquí los usuarios para sacarlos de la secuencia',
    sequentialEmptyState: 'Arrastra aquí los usuarios para crear una secuencia de firmas',
    sequentialWarningInfo:
      'Debes agregar todos los usuarios para generar una solicitud - {value} usuarios',
    sequentialSignSuccess: 'Secuencia completa',
    automatedSignature: 'Activar solicitud de firma automática',
    locationUser: 'Mails de lugares',
    locationUserTooltip:
      'Al seleccionar "Conexión a lugares", la solicitud se enviará a todos los correos registrados en el primer lugar asociado.',
    locationUserViewEmails: 'Ver mails',
    locationConnection: 'Conexión a lugares',
    locationConnectionTooltip1:
      'Si el formulario incluye una pregunta para seleccionar un lugar, se enviará una solicitud a los mails allí configurados',
    locationConnectionTooltip2:
      'Si asignas una tarea con este formulario y eliges un lugar, los mails allí configurados recibirán una solicitud al completarse la tarea',
    optionalSignatureOrderDisabled:
      'Esta opción no esta disponible para la configuración de firma opcional',
    author: 'Autor de la respuesta',
    authorMustSignFirst:
      'Esta posición es fija dentro de la secuencia, pero puedes moverla a Firma Simultánea',
    deleteSigner: 'Eliminar usuario',
    unGroupSigner: 'Desagrupar',
    authorUserTooltip:
      'Si el autor de la respuesta ya forma parte de la secuencia, se mantendrá su posición original en lugar de la asignada para el autor',
    addSigners: 'Agregar firmantes',
    addSignersTitle: 'Agregar firmantes',
    selectConfigurationType:
      'Selecciona el tipo de configuración que necesitas. Puedes elegir uno o ambos.',
    fixedSigner: 'Firmante fijo',
    fixedSignerDescription: 'Usuarios internos o externos',
    dynamicSignerCardDescription: 'Basado en respuestas del formulario',
    dynamicSigner: 'Firmante dinámico',
    dynamicSignerDescription:
      'Los firmantes dinámicos se definen a partir de respuestas en preguntas tipo',
    dynamicSignerDescriptionBold:
      'Selección lista de datos con listas de lugares o personalizadas, o tipo Texto con validación de correo.',
    formQuestionsTitle: 'Preguntas de este formulario',
    noDynamicSignatureQuestionsAvailable: 'No tienes preguntas de este tipo\nen este momento',
    selectedSignerSingular: 'seleccionado',
    selectedSignersPlural: 'seleccionados',
    quorumLabel: 'Al menos',
    quorumSuffix: 'deben firmar',
    quorumAll: 'Todos',
    quorumTooltip:
      'La solicitud se enviará siguiendo el orden definido. Cada etapa avanzará cuando firme la cantidad de personas requerida.',
    quorumTooltipSimultaneous:
      'Todos los usuarios recibirán la solicitud al mismo tiempo. El proceso terminará cuando firme la cantidad de personas requerida.',
    quorumError: 'El quórum debe ser entre 1 y la cantidad de participantes',
    rejectReasonsTitle: 'Configuración motivos de rechazo',
    rejectReasonsInfoBanner: 'Se verán reflejados cuando un firmante rechace una solicitud',
    rejectReasonsSaveError: 'No se pudieron guardar estos motivos (revisa duplicados o largo): {reasons}',
    rejectReasonsEmptyError: 'El motivo no puede quedar vacío',
    rejectReasonsAddPlaceholder: 'Escribe el motivo de rechazo',
    rejectReasonsAddButton: '+ Agregar motivo de rechazo',
    rejectReasonsEmptyText: 'Aún no has agregado motivos de rechazo. Si no agregas ninguno, el firmante escribirá el motivo en texto libre.',
    rejectReasonsDuplicateError: 'Ya existe un motivo con ese texto en este formulario',
    rejectReasonsDeleteTitle: '¿Estás seguro que quieres eliminar este motivo de rechazo?',
    rejectReasonsDeleteDescription: 'Las solicitudes enviadas previamente no se verán afectadas y permanecerán en la plataforma',
    rejectReasonsDeleteConfirm: 'Eliminar',
    rejectReasonsDeleteCancel: 'Cancelar',
  },
  pricing: {
    title: '¡Descubre el plan perfecto para ti!',
    basic: {
      title: 'Básico',
      subtitle: 'Perfecto para explorar las funcionalidades de DataScope',
      features: [
        'Usuarios ilimitados',
        '60 respuestas de formulario/mes',
        'Datos almacenados por 30 días',
        'Constructor de formularios básico',
        'Asignador de tareas',
        'Dashboard estándar',
        'Resolución de fotografías estándar',
        'Funcionamiento sin internet',
      ],
      buttonText: 'Plan actual',
    },
    standard: {
      title: 'Estándar',
      subtitle:
        'Ideal para equipos que están dando sus primeros pasos en la digitalización de procesos',
      features: [
        'Todo lo incluido en el Plan Básico +',
        'Respuestas ilimitadas de formularios',
        'Datos almacenados por siempre',
        'Constructor de formularios avanzado',
        'Generador de informes PDF personalizados',
        'Permisos de usuarios editables',
        'Integración de datos con otras plataformas',
        'Chat entre usuarios en la App',
        'Soporte email / teléfono / chat',
      ],
    },
    premium: {
      title: 'Premium',
      subtitle:
        'Para empresas que requieren una visión integral y en tiempo real de todas sus operaciones',
      features: [
        'Todo lo incluido en el Plan Estándar +',
        'Dashboards avanzados',
        'Soporte API',
        'Resolución de fotografías configurable',
        'Ejecutivo de cuentas asignado',
        'Soporte en flujos de trabajo',
      ],
      buttonText: 'Cambiar a Premium',
    },
    enterprise: {
      title: 'Enterprise',
      subtitle: 'Para grandes empresas que buscan una solución y soporte personalizado',
      features: [
        'Todo lo incluido en el Plan Premium +',
        'Implementación personalizada',
        'Soporte preferencial 24/7',
      ],
      buttonText: 'Hablar con ventas',
    },
    features: 'Funcionalidades',
    currentPlan: 'Plan actual',
    start: 'Empezar',
    mostPopular: 'Más popular',
    free: 'Gratis',
    monthlyPerUser: 'mensual por usuario',
    users: 'usuarios',
    standardBold: 'estándar',
    off: 'off',
    finishesIn: 'Termina en',
    ofDiscount: 'de descuento.',
    days: 'Días',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    salesLink: 'https://meetings.hubspot.com/andres-rivera4',
    activePayment: {
      demoSubscription: 'Suscripción pagada',
      demoSubscriptionDescription: 'Tu plan actual incluye ',
      demoSubscriptionDescription1: ' usuario(s).',
      demoSubscriptionDescription2: 'Puedes invitar más dando clic en el botón.',
      inviteUsers: 'Invitar usuarios',
      demoBannerDescription: '¡No tienes pagos pendientes!',
      demoBannerDescription2:
        'Si tienes alguna pregunta sobre tu suscripción, no dudes en ponerte en contacto con nuestro equipo.',
      moreInfo: 'Más información',
      viewBillingDetails: 'Ver detalles de facturación',
      changeUsers: 'Cambiar número de usuarios',
      modify: 'Modificar',
      monthlyValue: 'Valor mensual',
      annualValue: 'Valor anual',
      total: 'Total',
      valuesMayDiffer: '*Valores pueden cambiar en base a su moneda local.',
      modifyUsersSuccess: 'Suscripción actualizada con éxito',
      modifyUsersError:
        'Ocurrió un error al actualizar la suscripción, por favor intente nuevamente o comuníquese con soporte.',
      confirmModifyUsers: '¿Estás seguro que quieres cambiar el número de usuarios?',
      confirmModifyUsersDescription:
        'Si cambias el número de usuarios, el valor de tu suscripción cambiará en consecuencia y se cobrará la diferencia si corresponde.',
      numberOfUsers: 'Número de usuarios',
      paymentDetails: 'Detalles de pago',
    },
  },
  sensors: {
    tabs: { map: 'Mapa', list: 'Sensores', inbox: 'Entradas', connection: 'Conexión' },
    enterpriseOnlyMessage: 'El módulo de sensores no está habilitado en esta cuenta. Escríbenos si quieres más información.',
    map: {
      showing: 'Se muestran los {shown} sensores con datos más recientes, de {total}',
      previousPage: 'Anterior',
      nextPage: 'Siguiente',
      pageLabel: 'Página {page} de {pages}',
      empty: 'Todavía ningún sensor ha enviado datos desde un lugar con coordenadas.',
    },
    inbox: {
      viewFullBody: 'Ver el mensaje completo',
      fullBodyTitle: 'Mensaje recibido',
      fullBodyClose: 'Cerrar',
      unmappedTitle: 'Entradas sin mapear',
      unmappedHint: 'Llegaron a tu cuenta y todavía no alimentan ningún sensor',
      unmappedEmpty: 'No hay entradas esperando ser mapeadas.',
      mappedTitle: 'Entradas ya asignadas',
      mappedEmpty: 'Todavía no hay entradas que alimenten un sensor.',
      mappedHint: 'Cada una alimenta el sensor que aparece en su fila',
      mapAction: 'Mapear',
      viewAction: 'Ver',
      editMappingAction: 'Editar mapeo',
      columnMapping: 'Mapeada por',
      mappingIdentifierShort: 'ID: {path}',
      mappingDateShort: 'Fecha: {path}',
      mappingDateNone: 'sin campo de fecha',
      columnWhen: 'Cuándo',
      columnOutcome: 'Resultado',
      columnMessage: 'Mensaje',
      columnSensor: 'Sensor',
      outcomeAccepted: 'Aceptado',
      outcomeRejected: 'Rechazado',
      outcomeUnknownDevice: 'Sin identificador',
      unknownDeviceHint:
        'No se pudo reconocer ningún identificador de dispositivo en este mensaje. Puedes revisarlo y mapearlo manualmente desde acá.',
      previousPage: 'Anterior',
      nextPage: 'Siguiente',
      pageLabel: 'Página {page} de {pages}',
      footnote:
        'Se muestran las últimas 100 entradas. Nada se pierde: un dispositivo que envía sin estar mapeado igual guarda su historial completo. Mapearlo solo define qué se copia al medidor de un activo.',
    },
    assetPicker: {
      searchPlaceholder: 'Buscar por nombre o código del activo',
      noResults: 'Ningún activo coincide con esa búsqueda.',
      noAssets: 'Esta cuenta todavía no tiene activos. Crea uno antes de vincularle un sensor.',
      noLocation: 'Sin lugar',
      previous: 'Anterior',
      next: 'Siguiente',
      pageLabel: 'Página {page} de {pages}',
      title: 'Elegir activo',
      clear: 'Dejarlo sin vincular',
      cancel: 'Cancelar',
    },
    newSensor: {
      action: 'Nuevo sensor',
      title: 'Nuevo sensor',
      firstBody:
        'Debes integrar tu primer sensor. Conéctalo con la dirección que te da DataScope y sus entradas van a aparecer acá.',
      firstAction: 'Ir a Conexión',
      nextBody:
        'Tus sensores ya están enviando datos. Mapea tu nuevo sensor desde las entradas recientes, donde te esperan todas las que siguen sin mapear.',
      nextAction: 'Ir a Entradas',
      close: 'Cerrar',
    },
    mapping: {
      title: 'Mapear dispositivo',
      editTitle: 'Editar este mapeo',
      editHint:
        'Al cambiar un campo se vuelven a leer todas las entradas anteriores de la misma forma, así que un campo de fecha o de identificador equivocado queda corregido también en lo que ya recibiste.',
      changeAsset: 'Cambiar',
      chooseAsset: 'Elegir activo',
      attributesTitle: 'Atributos detectados',
      attributesHint:
        'Todos los atributos del mensaje se detectan y se guardan solos, incluidos los anidados. Asignar uno a un medidor es opcional y solo define qué se copia al activo.',
      columnAttribute: 'Atributo',
      columnLastValue: 'Último valor',
      columnRole: 'Rol',
      columnMeter: 'Alimenta un medidor',
      roleIdentifier: 'Identificador',
      roleDate: 'Fecha de la lectura',
      roleLatitude: 'Latitud',
      roleLongitude: 'Longitud',
      roleData: 'Dato',
      meterNone: 'Sin asignar',
      meterRequiresAsset: 'Elige un activo para poder asignar medidores',
      meterNoneAvailable: 'Este activo no tiene medidores que alimentar. Agrégale uno al activo primero.',
      locationNoneAvailable: 'Todavía no hay lugares configurados.',
      howReadTitle: 'Cómo se lee el mensaje',
      identifierFieldLabel: 'Campo del identificador del dispositivo',
      dateFieldLabel: 'Campo de la fecha (opcional)',
      dateFieldNone: 'No usar ninguno (se usa la fecha de recepción)',
      dateFormatLabel: 'Formato de la fecha',
      dateFormatIso8601: 'ISO 8601 (2026-07-29T14:32:10Z)',
      dateFormatEpochSeconds: 'Epoch en segundos',
      dateFormatEpochMillis: 'Epoch en milisegundos',
      latFieldLabel: 'Campo de latitud (opcional)',
      lngFieldLabel: 'Campo de longitud (opcional)',
      geoFieldNone: 'No usar ninguno',
      hint: 'Es lo único que hay que configurar. Todos los demás atributos se detectan y se guardan solos.',
      sensorNameLabel: 'Nombre del sensor',
      assetLabel: 'Activo',
      assetNone: 'Sin asignar',
      locationLabel: 'Ubicación',
      locationNone: 'Sin asignar',
      submit: 'Guardar mapeo',
      cancel: 'Cancelar',
      success: 'Dispositivo mapeado. Los mensajes anteriores de la misma forma se están actualizando.',
      error: 'No pudimos guardar el mapeo, intenta de nuevo.',
    },
    landing: {
      eyebrow: 'Módulo no habilitado en esta cuenta',
      title: 'Conecta tus sensores de terreno y deja de anotar lecturas a mano',
      lead: 'Los sensores que ya tienes instalados envían sus lecturas a DataScope y alimentan solos los medidores de tus activos.',
      bullets: [
        'Registra tus sensores y conéctalos con la dirección que DataScope te entrega',
        'Vincula cada sensor a un activo y deja su medidor en modo automático',
        'Revisa dónde está cada activo y cuáles sensores dejaron de reportar',
      ],
      contactSupport: 'Contactar soporte',
      contactSupportMessage: 'Hola, quiero más información sobre el módulo de sensores.',
      enableHint: 'Escríbenos si quieres más información sobre el módulo de sensores.',
    },
    list: {
      columnId: 'ID',
      columnSensor: 'Sensor',
      columnStatus: 'Estado',
      columnLastReading: 'Última lectura',
      columnAsset: 'Activo vinculado',
      columnMeter: 'Medidor automático',
      noLocationGroup: 'Sin lugar',
      openAssetHint: 'Abrir activo en otra pestaña',
      changeAssetHint: 'Vincular este sensor a un activo',
      assetSaveSuccess: 'Sensor vinculado al activo.',
      assetSaveError: 'No pudimos cambiar el activo, intenta de nuevo.',
      renameHint: 'Cambiar el nombre de este sensor',
      renameSave: 'Guardar',
      renameCancel: 'Cancelar',
      renameSuccess: 'Nombre del sensor actualizado.',
      renameError: 'No pudimos cambiar el nombre, intenta de nuevo.',
      unlinked: 'Sin vincular',
      none: '—',
      footnote:
        'Un sensor puede recibir datos sin estar vinculado a un activo. El vínculo decide qué se copia al medidor, no qué se guarda.',
      showing: 'Se muestran {from} a {to} de {total} sensores',
      previousPage: 'Anterior',
      nextPage: 'Siguiente',
      pageLabel: 'Página {page} de {pages}',
      empty: 'Todavía no hay sensores reportando.',
      // Standalone empty state de Sensores > Sensores (SensorsListTab): sin
      // tabla ni footnote técnico, solo el mensaje y la acción que lo resuelve.
      emptyStateMessage: 'No hay ningún sensor reportando información.',
      emptyStateAction: 'Integra tu primer sensor',
      adminOnly: 'Solo los administradores pueden ver y administrar los sensores de un activo.',
      linkSensor: 'Vincular sensor',
      linkSensorTitle: 'Vincular sensor a este activo',
      linkSensorSelectLabel: 'Sensor',
      linkSensorEmpty: 'No hay sensores sin vincular disponibles.',
      linkSensorSubmit: 'Vincular',
      linkSensorCancel: 'Cancelar',
      linkSensorSuccess: 'Sensor vinculado a este activo.',
      linkSensorError: 'No pudimos vincular el sensor, intenta de nuevo.',
      unlinkSensor: 'Desvincular',
      retireSensor: 'Dar de baja el sensor',
      retireSensorSuccess: 'Sensor dado de baja.',
      retireSensorError: 'No pudimos dar de baja el sensor, intenta de nuevo.',
      retireSensorConfirmTitle: '¿Dar de baja este sensor?',
      retireSensorConfirmMessage:
        '{sensor} sale de esta lista y sus próximos mensajes se van a rechazar. No se borra nada: sus lecturas y las mediciones que alimentó se conservan, y podés reactivarlo después.',
      retireSensorConfirmAction: 'Dar de baja',
      retireSensorCancel: 'Cancelar',
      moveAssetHint: 'Mover este sensor a otro activo',
      moveAssetConfirmTitle: 'Mover sensor a otro activo',
      moveAssetConfirmBody: '¿Mover {sensor} de {from} a {to}?',
      moveAssetFeedsWarning:
        'Hoy alimenta {meters} en {from} en modo automático. Al moverlo eso se apaga, y lo vuelves a configurar en el activo nuevo. Las mediciones ya registradas se quedan en {from}.',
      moveAssetConfirmAction: 'Mover',
      moveAssetCancel: 'Cancelar',
      unlinkSensorFeedsWarning:
        'Hoy alimenta {meters} en modo automático. Al desvincularlo también se apaga eso, y el medidor conserva todas las mediciones ya registradas.',
      unlinkSensorConfirmTitle: 'Desvincular sensor',
      unlinkSensorConfirmBody:
        '¿Desvincular {sensor} de este activo? Sigue guardando todo su historial, pero deja de alimentar sus medidores.',
      unlinkSensorConfirmAction: 'Desvincular',
      unlinkSensorCancel: 'Cancelar',
      unlinkSensorSuccess: 'Sensor desvinculado de este activo.',
      unlinkSensorError: 'No pudimos desvincular el sensor, intenta de nuevo.',
    },
    status: { reporting: 'Reportando', silent: 'Sin reportar', rejecting: 'Rechazando' },
    connection: {
      title: 'Una sola dirección para todos tus sensores',
      endpointLabel: 'Dirección de destino',
      credentialLabel: 'Credencial de la cuenta',
      info: 'Todos tus dispositivos envían a la misma dirección con la misma credencial. Cada mensaje se reconoce por el identificador del dispositivo que viene adentro.',
      regenerate: 'Regenerar credencial',
      regenerateConfirmTitle: 'Regenerar credencial',
      regenerateConfirmBody:
        'La credencial anterior deja de funcionar de inmediato. Todos los dispositivos que la usaban dejarán de poder enviar datos hasta que actualices la credencial en ellos.',
      regenerateConfirmAction: 'Regenerar de todas formas',
      cancel: 'Cancelar',
      openDocs: 'Ver documentación',
      openDocsMessage: 'Necesito la documentación de integración de sensores.',
      whatToSendTitle: '¿Qué mandar?',
      whatToSendHint: 'No hay un formato obligatorio. Manda el JSON que tu sistema ya produce, tal cual:',
      whatToSendFootnote:
        'DataScope detecta y guarda todos los atributos solo, incluidos los anidados.',
    },
    catalog: {
      title: 'Otros proveedores',
      comingSoon: 'Próximamente',
      requestButton: 'Quisiera integrar otro software',
      requestIntercomMessage: 'Hola, quisiera integrar otro software con el módulo de sensores.',
    },
  },
  findings: {
    title: 'Tickets',
    new: 'Nuevos',
    all: 'Todos',
    createdBy: 'Creado por',
    assignees: 'Responsables',
    expires: 'Vence',
    type: 'Tipo',
    location: 'Lugar',
    description: 'Descripción',
    searchPlaceholder: 'Buscar por nombre, descripción, autor o ID',
    searchPlaceholderStore: 'Buscar por nombre, descripción, autor, ID o contenido del formulario',
    noResultsWithFilters: 'No tienes hallazgos disponibles en este momento',
    newResultsNotice: 'Hay tickets nuevos. Actualizar la lista',
    loadError: 'No pudimos cargar los tickets. Reintentar',
    sectionLoadError: 'No pudimos cargar esta sección. Reintentar',
    resultWindowNotice:
      '¿No encuentras el ticket que buscas? Prueba con la búsqueda o los filtros para acotar la lista.',
    createdIn: 'Creado en',
    originQuestion: 'Pregunta',
    note: 'Nota',
    viewForm: 'Ver formulario',
    createYourFirstFinding: 'Crea tu primer ticket',
    emptyState:
      'Agrega una pregunta de tipo Checklist a un formulario nuevo o existente para comenzar a crear tickets',
    goToForms: 'Ir a formularios',
    detailEmptyState: 'Selecciona un ticket para ver el historial',
    findingDetail: 'Detalle del ticket',
    idCopied: 'ID copiado!',
    findingCodePending: 'Asignando…',
    filtersLinkCopy: {
      tooltip: 'Copiar enlace con filtros',
      success: 'Enlace copiado al portapapeles',
      error: 'No se pudo copiar el enlace. Revisa los permisos del navegador.',
    },
    delete: 'Eliminar',
    deletedSuccessfully: 'Ticket eliminado exitosamente',
    tabs: {
      inProgress: 'En progreso',
      closed: 'Cerrados',
    },
    filters: {
      clearFilters: 'Borrar filtros',
      filterByPriority: 'Filtrar por prioridad',
      filterByStatus: 'Filtrar por estado',
      filterChipAssignee: 'Responsable',
      filterChipCreator: 'Creador',
      filterChipForm: 'Formulario',
      filterByForms: 'Filtrar por formularios',
      filterByAssets: 'Filtrar por activos',
      filterByLocations: 'Filtrar por lugares',
      filterByCreators: 'Filtrar por creador',
      filterByAssignees: 'Filtrar por responsable',
      noSearchResultsForms: 'No se encontraron formularios',
      noSearchResultsAssets: 'No se encontraron activos',
      noSearchResultsLocations: 'No se encontraron lugares',
      noSearchResultsCreators: 'No se encontraron creadores',
      noSearchResultsAssignees: 'No se encontraron responsables',
      formDeleted: 'Eliminado',
      formInactive: 'Inactivo',
      dateFilter: {
        title: 'Fecha',
        popoverTitle: 'Filtrar por fecha',
        creationDate: 'Fecha de creación',
        expirationDate: 'Fecha de vencimiento',
      },
    },
    options: {
      viewDetails: 'Ver detalle',
      addImage: 'Enviar imagen',
      sendFormAnswers: {
        menu: 'Enviar respuesta formulario',
        title: 'Respuesta formulario',
        button: 'Enviar a ticket',
        cancel: 'Cancelar',
        description: 'Selecciona la respuesta que deseas enviar al ticket',
        searchPlaceholder: 'Buscar formulario',
        answeredBy: 'Respondido por',
        updatedAt: 'Actualizado en',
        noResults: 'No se encontraron respuestas',
        seeAnswer: 'Ver respuesta',
        noAnswers: 'No tienes respuestas en este momento',
      },
      sendForms: {
        button: 'Enviar',
        menu: 'Enviar formulario',
        sync: 'Sincronizando',
      },
      share: {
        menu: 'Compartir enlace',
        title: 'Compartir enlace',
        text: 'Cualquier persona con el link puede acceder al ticket',
        activate: 'Habilitar',
        deactivate: 'Deshabilitar',
        loginTitle: '¡Bienvenido a DataScope!',
        loginDescription: 'Para continuar, por favor ingresa tu nombre y correo electrónico',
        loginNamePlaceholder: 'Tu nombre',
        loginEmailPlaceholder: 'Correo electrónico',
      },
    },
    createFindingType: 'Crear tipo de ticket',
    createFinding: {
      title: 'Crear ticket',
      create: 'Crear',
      requiredInformation: 'Información requerida',
      optionalInformation: 'Información opcional',
      cancel: 'Cancelar',
      name: 'Nombre',
      titleLabel: 'Título',
      titlePlaceholder: 'Describe el problema en pocas palabras',
      descriptionPlaceholder: 'Describe el problema con más detalles',
      type: 'Tipo de ticket',
      description: 'Descripción',
      assignees: 'Responsable(s)',
      dueDate: 'Vencimiento',
      location: 'Lugar',
      inviteParticipants: 'Invitar participantes',
      asset: 'Activo',
      evidence: {
        title: 'Evidencia',
        required: 'Evidencia obligatoria',
        optional: 'Evidencia (opcional)',
        addPhoto: 'Imagen',
        uploadError: 'Error al subir imagen',
        limitReached:
          'Solo se pueden adjuntar {{max}} fotos como máximo. Se ignoraron las restantes.',
        requiredError: 'Debes agregar al menos una foto como evidencia',
        invalidType: 'Solo se permiten archivos de imagen',
        sizeExceeded: 'El archivo supera el tamaño máximo permitido de 10 MB',
      },
      findingSuccess: 'Ticket creado exitosamente',
      findingError: 'Error al crear ticket',
      findingCreated: 'Ticket creado',
      editInFindings: "Dirígete a la sección de 'Tickets' para realizar algún cambio",
      evidenceImageSelected: 'imagen adjuntada',
      evidenceImagesSelected: 'imágenes adjuntadas',
    },
    editFinding: {
      title: 'Editar ticket',
      update: 'Actualizar',
      findingSuccess: 'Ticket actualizado exitosamente',
      findingError: 'Error al actualizar ticket',
    },
    closeFinding: {
      title: 'Cerrar ticket',
      instruction: 'Completa la siguiente información para cerrar el ticket',
      closingNoteLabel: '¿En qué estado cerró el ticket?',
      cancel: 'Cancelar',
      confirm: 'Cerrar ticket',
    },
    status: {
      title: 'Estado',
      open: 'Abierto',
      in_progress: 'En curso',
      paused: 'Detenido',
      closed: 'Cerrado',
    },
    priority: {
      title: 'Prioridad',
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      critical: 'Crítica',
    },
    asset: {
      label: 'Activo',
      placeholder: 'Seleccionar activo',
      noAsset: 'Sin activo',
      searchPlaceholder: 'Buscar',
      clear: 'Ninguno',
      clearSelection: 'Deseleccionar activo',
      assetsCount: '{count} activos',
      assetCount: '1 activo',
      selected: '1 seleccionado',
      noAssets: 'No se encontraron activos',
      noType: 'Sin tipo',
      emptyStateMessage: 'Crea activos y aprovecha los beneficios',
      goToCreateAssets: 'Crear activos',
      noSearchResults: 'No se encontraron activos',
    },
    deleteWarningConfirm: '¿Estás seguro que quieres eliminar este ticket?',
    deleteWarningConfirmDescription:
      'Se eliminará permanentemente y no podrás recuperarlo después.',
    chat: {
      events: {
        finding_created: 'Ticket creado',
        finding_closed: 'finalizó el ticket',
        finding_closed_expired: 'finalizó el ticket después de la fecha de vencimiento estipulada',
        status: 'actualizó el estado a',
        priority: 'actualizó la prioridad a',
        description: 'actualizó la descripción del ticket a',
        expiration_date: 'actualizó la fecha de vencimiento a',
        name: 'actualizó el nombre del ticket a',
        location: 'actualizó el lugar del ticket a',
        added_assignees: 'agregó a',
        removed_assignees: 'eliminó a',
        assignees_singular: 'como responsable',
        assignees_plural: 'como responsables',
        added_invitees: 'agregó a',
        removed_invitees: 'eliminó a',
        invitees_singular: 'como participante',
        invitees_plural: 'como participantes',
        no_expiration_date: 'sin fecha de vencimiento',
        evidence_added: 'agregó {{count}} imágenes a la evidencia',
        evidence_added_singular: 'agregó 1 imagen a la evidencia',
        evidence_removed: 'eliminó {{count}} imágenes de la evidencia',
        evidence_removed_singular: 'eliminó 1 imagen de la evidencia',
        evidence_modified: 'actualizó la evidencia',
        asset: 'actualizó el activo del ticket a',
        deleted_asset: 'eliminó el activo del ticket',
      },
      image: {
        error: 'Error',
        sync: 'Sincronizando Imagen',
      },
      evidence: {
        attached: 'Se adjuntaron {{count}} imágenes como evidencia del ticket',
        attached_singular: 'Se adjuntó 1 imagen como evidencia del ticket',
        viewerTitle: 'Evidencia del ticket',
        altMain: 'Evidencia {{n}}',
        altThumb: 'Miniatura {{n}}',
        more: '+{{count}}',
        formPhotosNote:
          'Las imágenes adjuntas desde la pregunta no se podrán eliminar, pero sí agregar más',
      },
      assignedForms: {
        message: 'Responde el siguiente formulario para entregar más información',
      },
    },
    export: {
      pdf: {
        title: 'Exportar PDF',
        tooltip: 'Exportar PDF',
        info: 'Exportarás toda la información incluida en el ticket. Una vez lo exportes, el link de descarga te llegará al mail.',
        exportSuccess: 'PDF de Ticket exportado exitosamente',
        exportError: 'Error al exportar PDF de Ticket',
        buttonTitle: 'PDF',
      },
      all: {
        title: 'Exportar todo',
        tooltip: 'Exportar a Excel',
        info: 'Exportarás las siguientes variables en formato Excel: Nombre, descripción, responsables, participantes, vencimiento, prioridad y lugar. Una vez lo exportes, el link de descarga te llegará al mail.',
        exportSuccess: 'Tickets exportados exitosamente',
        exportError: 'Error al exportar Tickets',
        buttonTitle: 'Excel',
      },
      emailInputLabel: 'Email',
      cancel: 'Cancelar',
      confirm: 'Exportar',
    },
    pricing: {
      landing: {
        tagTrial: 'Prueba Tickets durante 30 días gratis',
        tagPaid: 'Disponible en los planes Professional y Enterprise',
        titleTrial: 'Identifica, reporta y resuelve problemas en tiempo real',
        titleExpired: 'Gestiona incidentes y acciones correctivas en un solo lugar',
        intro:
          'Registra tickets, asigna responsables y realiza seguimiento hasta su resolución, con toda la evidencia y conversación en un solo lugar.',
        bullet1: 'Reporta problemas con evidencia y prioridad.',
        bullet2: 'Asigna responsables y coordina su resolución.',
        bullet3: 'Mantén trazabilidad de cada ticket hasta su cierre.',
        startTrial: 'Comenzar prueba gratuita',
        startTrialError: 'No pudimos activar tu prueba gratuita. Intenta nuevamente.',
        disclaimer:
          'Al terminar la prueba, tus tickets se conservan y podrás recuperarlos al pasar a un plan Professional o Enterprise.',
        knowPlans: 'Conocer los planes',
        contactSales: 'Hablar con ventas',
        contactSalesIntercomMessage:
          'Hola, quiero saber más sobre Tickets y los planes que lo incluyen.',
        demoTitle: 'Conoce el proceso de resolución de principio a fin',
        demo1Title: 'Toda la gestión de cada ticket, en un solo lugar',
        demo1Description:
          'Revisa el estado, prioridad y responsable de cada ticket. Coordina su resolución desde el mismo registro y mantén toda la evidencia centralizada.',
        demo2Title: 'Reporta problemas desde terreno al instante',
        demo2Description:
          'El equipo puede registrar incidentes con fotos, comentarios y ubicación desde la app, para que sean asignados y gestionados de inmediato.',
        demo3Title: 'Haz seguimiento hasta el cierre',
        demo3Description:
          'Mantén visibilidad del avance de cada ticket, conversa con los involucrados y registra la solución aplicada para conservar la trazabilidad completa.',
        previous: 'Anterior',
        next: 'Siguiente',
        illustrationAlt: 'Ilustración del módulo Tickets',
        accessLapsed: 'Tu acceso a Tickets terminó. Puedes seguir en esta pantalla, pero al recargar necesitarás un plan Professional o Enterprise.',
        illustrationImage:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/ilustracion-tickets.svg',
        demo1Image:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-1.png',
        demo2Image1:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-2-1.png',
        demo2Image2:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-2-2.png',
        demo3Image:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-3.png',
        remainingDays: '{count} días restantes de tu prueba',
      },
    },
    adminAlert:
      'Podrás ver todos los tickets, pero para recibir actualizaciones debes asignarte como responsable o invitado.',
    configure: 'Configurar',
    config: {
      findingTypes: 'Tipos de tickets',
      createType: 'Crear tipo',
      editType: 'Editar',
      deleteType: 'Eliminar',
      deleteTypeDisabled: 'No puedes quedarte sin tipos de tickets',
    },
    integrations: {
      title: 'Integracion Tickets',
      button: 'Integraciones',
      gsheetsMenuName: 'Google Sheets',
      gsheetsIntegrationLabel: 'Ir a Google Sheets',
      infoTextPart1:
        'Para garantizar una integración adecuada, privada y segura, comparte tu documento con permisos de',
      infoTextPart2: 'editor',
      infoTextPart3: 'únicamente a',
      inputLabel: 'Nuevo Enlace',
      inputPlaceholder: 'Ingresa el enlace del documento a integrar',
      save: 'Guardar',
      cancel: 'Cancelar',
      copyUrl: '¡URL copiada!',
      created:
        '¡Integración configurada exitosamente! Por favor, espera unos segundos para que se reflejen los cambios',
      saved: '¡Cambios guardados con éxito!',
      savingError: 'Error al configurar la integración',
      confirmation: '¿Quieres guardar los cambios realizados antes de salir?',
      webhooks: 'Webhooks',
      webhookUrl: 'Webhook URL',
      infoWebhooksTextPart1:
        'Automatiza tus flujos de trabajo permitiendo que DataScope active procesos en plataformas externas.',
      infoWebhooksTextPart2: 'Mantén todo sincronizado sin esfuerzo.',
      import: 'Importar',
      populateGSheet: 'Poblar GSheet',
      populatingGSheet: 'Poblando GSheet...',
      populateGSheetSuccess: 'Google Sheet poblado exitosamente',
      populateGSheetError: 'Error al poblar el Google Sheet',
    },
    findingTypes: {
      noType: 'Otro',
      createTitle: 'Crear Tipo de Ticket',
      editTitle: 'Editar Tipo de Ticket',
      name: 'Nombre',
      assignees: 'Responsable (Asignar a)',
      assigneesCaption: 'Si no asignas responsable, en la app lo podrás hacer',
      assigneesNoSearchResults: 'No hay usuarios que coincidan con tu búsqueda',
      removeChipAriaLabel: 'Quitar',
      clearAllSelectionAriaLabel: 'Borrar todo',
      location: 'Lugar',
      locationCaption: 'Si no asignas un lugar, en la app lo podrás hacer',
      assets: 'Activos',
      save: 'Guardar',
      update: 'Actualizar',
      cancel: 'Cancelar',
      dueDateAndPriority: 'Vencimiento y Prioridad',
      priorityInformationBanner:
        'Puedes seleccionar una prioridad como predeterminada (opcional). El creador del ticket no podrá cambiarla, pero verá su descripción.',
      dueDate: 'Vencimiento',
      dueDateCaption: 'Esta configuración empezará a contar desde la creación del ticket',
      dueDateValueRequired: 'Ingresa un valor mayor a 0',
      dueDatePriorityRequired: 'Debes configurar el vencimiento para esta prioridad',
      dueDatePriorityCompatibility:
        'En versiones anteriores a la v4.4.2 de la app, se utilizará el vencimiento más cercano disponible ({{shortestValue}}).',
      dueDateTypes: {
        days: 'Días',
        hours: 'Horas',
      },
      dueDateTypesSingular: {
        days: 'día',
        hours: 'hora',
      },
      mandatoryRequirements: 'Requisitos obligatorios',
      mandatoryRequirementsTooltip: 'Selecciona qué elementos serán obligatorios en el ticket',
      mandatoryRequirementsNoMatches: 'No hay opciones que coincidan con la búsqueda',
      evidence: 'Evidencia',
      evidenceDescription: 'Requiere al menos una imagen al crear el ticket',
      closureComment: 'Comentario de cierre',
      closureCommentDescription: 'Requiere un comentario obligatorio al cerrar el ticket',
      dueDateRequirement: 'Fecha de vencimiento',
      dueDateRequirementDescription:
        'La fecha se calculará automáticamente a partir de los días/horas definidos',
      configureDueDate: 'Configurar vencimiento',
      priority: 'Prioridad',
      description: 'Descripción',
      descriptionPlaceholder: 'Escribe la descripción o instrucción de la prioridad',
      additionalInformation: 'Información Adicional (Opcional)',
      additionalInformationBanner:
        'Asignar formularios pre determinados para que respondan las personas que participarán en el ticket',
      evidenceBanner:
        'Define si los creadores del ticket deben adjuntar fotos como evidencia al momento de creación.',
      evidenceOptions: {
        none: 'No requerir',
        optional: 'Opcional',
        required: 'Obligatoria',
      },
      typeCreatedSuccess: 'Tipo de ticket creado con éxito',
      typeCreatedError: 'Error al crear tipo de ticket',
      typeDeletedSuccess: 'Tipo de ticket eliminado con éxito',
      typeDeletedError: 'Error al eliminar tipo de ticket',
      typeUpdatedSuccess: 'Tipo de ticket actualizado con éxito',
      typeUpdatedError: 'Error al actualizar tipo de ticket',
      deleteTypeAlertTitle: '¿Estás seguro que quieres eliminar este tipo de ticket?',
      deleteTypeAlertMessage:
        'Si lo eliminas ya no lo podrás recuperar, pero la información relacionada con este permanecerá en la plataforma',
    },
  },
  commonComponents: {
    sortByName: {
      unsorted: 'Ordenar por nombre',
      ascending: 'Ordenado de A a Z',
      descending: 'Ordenado de Z a A',
    },
    formSelector: {
      title: 'Formularios',
      addForm: 'Agregar formulario',
      searchPlaceholder: 'Buscar formulario, carpeta...',
      forms: 'Formularios',
      folders: 'Carpetas',
      save: 'Guardar',
      cancel: 'Cancelar',
      see: 'Ver',
      more: 'más',
      close: 'Cerrar',
      maxFormsSelected: 'Máximo de formularios seleccionados',
      noFormsFound: 'No se encontraron formularios',
      noFoldersFound: 'No se encontraron carpetas',
    },
    confirmActionAlert: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    formDropdownSelector: {
      loading: 'Cargando...',
      noFormsFound: 'No se encontraron formularios',
    },
    dateRangePicker: {
      last7Days: 'Últimos 7 días',
      last14Days: 'Últimos 14 días',
      last30Days: 'Últimos 30 días',
      last60Days: 'Últimos 60 días',
      last90Days: 'Últimos 90 días',
      thisYear: 'Este año',
      today: 'Hoy',
      thisWeek: 'Esta semana',
      nextWeek: 'Próxima semana',
      next7Days: 'Próximos 7 días',
      next14Days: 'Próximos 14 días',
      next30Days: 'Próximos 30 días',
      next60Days: 'Próximos 60 días',
      next90Days: 'Próximos 90 días',
      moreOptions: 'Más opciones',
      pastRanges: 'Rangos Pasados',
      futureRanges: 'Rangos Futuros',
    },
    locationSelector: {
      loading: 'Cargando...',
      noLocationsFound: 'No se encontraron lugares',
      placeholder: 'Selecciona un lugar',
      nestableLocations: 'Lugares',
      legacyLocations: 'Lista de Lugares (Antiguo)',
    },
  },
  webHooks: {
    title: 'WebHooks',
    new: {
      title: 'Crear nuevo WebHook',
      token: 'Token:',
      expires_in: 'Expira en:',
      expires_at: 'Expira a las:',
      form: 'Formulario',
      select_form: 'Seleccionar un formulario',
      select_all_forms: 'Todos los formularios',
      url: 'Url de la conexión',
      example_url: 'http://www.tuservidor.com/servicio',
      send_modifications: 'Enviar modificaciones',
      oauth_checkbox: 'Autenticar con OAuth2',
      save: 'Guardar',
      back: 'Volver a WebHooks',
      configure_oauth: 'Configurar OAuth 2.0',
      access_token: 'URL del Token de Acceso',
      client_id: 'ID del cliente',
      client_secret: 'Llave secreta del cliente',
      scope: 'Scope',
      save_oauth: 'Guardar Configuración OAuth',
      save_oauth_success: 'Token de OAuth creado con éxito',
      save_oauth_error: 'Hubo un error al crear el token de OAuth',
      token_details: 'Detalles del Token',
      create_webhook: 'Crear WebHook',
      create_webhook_success: 'WebHook creado con éxito',
      create_webhook_error: 'Hubo un error al crear el WebHook',
    },
    update: {
      update_webhook: 'Actualizar WebHook',
      update_webhook_success: 'WebHook actualizado con éxito',
      update_webhook_error: 'Hubo un error al actualizar el WebHook',
    },
    webhook_not_found: 'WebHook no encontrado',
    load_webhook_error: 'Hubo un error al cargar el WebHook',
  },
  answerView: {
    correction: {
      correct: 'Corregir',
      success: 'Formulario corregido. La solicitud de firma fue enviada exitosamente',
      error: 'No pudimos reenviar la solicitud de firma. La solicitud sigue rechazada, puedes intentarlo nuevamente.',
      alreadyCorrected: 'Esta solicitud ya fue corregida y está pendiente de firma. No hace falta corregirla otra vez.',
      alreadySigned: 'Esta respuesta tiene una solicitud de firma en curso y no se puede editar.',
      manualResendNotice: 'Al corregir, la solicitud de firma no se reenvía sola: este formulario no la envía automáticamente. Después de guardar, vuelve a enviarla.',
      savedResendByHand: 'Formulario corregido. Recuerda enviar la solicitud de firma nuevamente: este formulario no la envía automáticamente.',
      goToRequest: 'Ver la solicitud',
    },
    alreadyRejectedSignature: 'Rechazaste firmar este formulario',
    rejectConfirmationTitle: '¿Estás seguro que quieres rechazar la solicitud?',
    rejectConfirmationDescription: 'Una vez rechazado, no podrás volver a firmar este formulario.',
    reject: 'Rechazar',
    rejectSuccess: '¡Solicitud de firma rechazada!',
    rejectError: 'No se pudo rechazar la firma',
    rejectAlreadyRejected: 'La solicitud ya había sido rechazada y por eso no se pudo rechazar.',
    location: 'Lugar',
    address: 'Dirección',
    assignee: 'Responsable',
    taskInformation: 'Información de la tarea asignada',
    description: 'Descripción',
    tasks: 'Tareas',
    answeredFromMobile: 'Enviado desde aplicación móvil',
    answeredFromWeb: 'Enviado desde la web',
    electronicallySignedBy: 'Firmado electrónicamente por:',
    verifySignatureAlert:
      'Para firmar el formulario primero debes verificar tu firma, esto solo lo harás una vez.',
    configureSignatureAlert:
      'Para firmar el formulario primero debes configurar y verificar tu firma, esto solo lo harás una vez.',
    configureSignature: 'Configurar firma electrónica',
    lackOfPermissions:
      'No tienes permisos para editar tu perfil. Solicita al administrador que complete tu información para que puedas continuar.',
    verifySignature: 'Verificar firma',
    sign: 'Firmar',
    alreadySignedAlert: 'Ya firmaste este formulario',
    rejectedAlert: 'Rechazaste firmar este formulario',
    goToSignatures: 'Ir a firmas',
    signatureConfigAlert: 'Por favor revisa la configuración de firma electrónica',
    reverifySignatureAlert:
      'La configuración de firma de tu cuenta fue actualizada. Debes verificar tu firma nuevamente para poder firmar.',
    quorumReached: {
      title: '¡Listo! Ya se alcanzaron las firmas requeridas.',
      description:
        'Este documento ya cuenta con las firmas necesarias en tu grupo. No es necesario que firmes, aunque puedes revisar si tienes otras pendientes.',
      button: 'Ir a firmas',
    },
    signSuccess: '¡Formulario firmado exitosamente!',
    signError: 'Ocurrió un error al firmar el formulario',
    signatureVerifySuccess:
      '¡Verificaste tu firma electrónica exitosamente! Ahora podrás firmar todos tus formularios',
    signatureVerifyError: 'Ocurrió un error al verificar tu firma electrónica',
    checkedCountInfo: 'elementos seleccionados',
    checkedCountListInfo: 'Elementos seleccionados de una lista de',
    items: 'elementos',
    total: 'total',
    group: 'Grupo',
    nestableLocationBelongsTo: 'Pertenece a',
    attachedFiles: 'Estos son los archivos adjuntos a esta pregunta',
    editAnswer: 'Editar respuesta',
    editAnswerDisabled: 'No puedes editar la respuesta porque tiene una solicitud de firma',
    editAnswerNoPermission: 'No tienes permisos para editar esta respuesta',
    viewDocumentValidation: 'Ver Validación de Documento',
    qrUniqueDocumentTitle: 'QR único del documento',
    qrUniqueDocumentDescription:
      'Este documento incorpora firma electrónica, la autenticidad de este puede ser verificada escaneando el código QR',
    metadataComments: {
      item: 'Ítem',
      answer: 'Respuesta',
      description: 'Comentario',
      images: 'Imágenes',
      issues: 'Ticket creado',
      viewIssue: 'Ver ticket',
    },
    expiredLink: {
      description: 'Este link ha vencido. Solicita uno nuevo dando click en el botón',
      button: 'Solicitar link',
      newLinkRequestedSuccess: 'El link ha sido enviado a tu correo',
      newLinkRequestedError: 'Ocurrió un error al solicitar el link',
    },
    externalUserSign: {
      title: 'Registra tu firma',
      registeredDescription:
        'Tu firma se encuentra registrada, por favor confirma tus datos para poder continuar',
      unregisteredDescription:
        'Tu información personal no se encuentra registrada, te invitamos a completar los siguientes datos',
      name: 'Nombre completo',
      company: 'Empresa',
      role: 'Cargo',
      confirm: 'Continuar',
      cancel: 'Cancelar',
      success: '¡Formulario firmado exitosamente!',
      error: 'Ocurrió un error al firmar el formulario',
    },
    rejectModal: {
      title: 'Rechazar solicitud',
      subtitle: 'Ingresa el motivo del rechazo de la solicitud de firma',
      selectSubtitle: 'Selecciona el motivo para rechazar la solicitud:',
      placeholder: 'Escribe la razón aquí (Obligatorio)',
      minLength: 'Mínimo 5 caracteres',
      otherOption: 'Otro',
      cancel: 'Cancelar',
      confirm: 'Rechazar',
    },
    locationInfo: {
      title: 'Información de ubicación detectada',
      description: 'La respuesta se detectó en una ubicación de tu lista de lugares',
      viewInMap: 'Ver en mapa',
      nameAndDistance: 'Nombre y distancia',
      distanceHelpIcon:
        'La ubicación fue detectada automáticamente. Se muestra la distancia entre el lugar detectado y el punto desde donde se respondió.',
      awayFromLocation: 'km de la ubicación',
      detectedByGps: 'Detectado por GPS',
    },
    formatErrors: {
      warningMessage:
        'Hubo problemas para mostrar ciertas respuestas. Por favor, contacta a soporte.',
      workingWarningMessage:
        'Estamos al tanto de un error en el registro de datos. Estamos trabajando en una solución.',
      answerListTitle: 'Respuestas con problemas de visualización:',
    },
    signature: {
      name: 'Nombre',
      idNumber: {
        CL: 'RUT',
        PE: 'DNI',
        MX: 'CURP',
        CO: 'CC',
        AR: 'DNI',
        PY: 'CI',
        ES: 'DNI/NIE',
        BR: 'CPF',
        UY: 'CI',
        BO: 'CI',
        EC: 'Cédula',
        VE: 'Cédula',
        US: 'SSN',
        CA: 'SIN',
        DO: 'Cédula',
        CR: 'Cédula',
        PA: 'Cédula',
        GT: 'DPI',
        SV: 'DUI',
        HN: 'DNI',
        NI: 'Cédula',
        PR: 'SSN',
        CU: 'CI',
        JM: 'TRN',
        PT: 'NIF',
        FR: 'INSEE',
        DE: 'ID Tributario',
        IT: 'Codice Fiscale',
        GB: 'Número de Seguro Nacional',
        IE: 'Número PPS',
        NL: 'BSN',
        BE: 'Número Nacional',
        CH: 'Número AHV',
        AT: 'Número de Seguridad Social',
        SE: 'Número Personal',
        NO: 'ID Nacional',
        DK: 'Número CPR',
        FI: 'Código de Identidad Personal',
        IS: 'Kennitala',
        PL: 'PESEL',
        CZ: 'Número de Nacimiento',
        SK: 'Número de Nacimiento',
        HU: 'Número Tributario',
        RO: 'CNP',
        BG: 'EGN',
        GR: 'AMKA/AFM',
        HR: 'OIB',
        SI: 'EMSO',
        RS: 'JMBG',
        BA: 'JMBG',
        ME: 'JMBG',
        MK: 'EMBG',
        MT: 'Tarjeta de ID',
        CY: 'Número de ID',
        LU: 'ID Nacional',
        LT: 'Código Personal',
        LV: 'Código Personal',
        EE: 'Código Personal',
        TR: 'TC Kimlik No',
        IL: 'Número de ID',
        SA: 'ID Nacional',
        AE: 'Emirates ID',
        QA: 'QID',
        KW: 'ID Civil',
        BH: 'CPR',
        OM: 'ID Civil',
        JO: 'ID Nacional',
        LB: 'Número de ID',
        EG: 'ID Nacional',
        MA: 'CIN',
        TN: 'CIN',
        DZ: 'ID Nacional',
        ZA: 'Número de ID',
        NG: 'NIN',
        KE: 'Número de ID',
        GH: 'Ghana Card',
        UG: 'ID Nacional',
        TZ: 'NIDA',
        RW: 'ID Nacional',
        BW: 'Omang',
        NA: 'Número de ID',
        ZM: 'NRC',
        ZW: 'ID Nacional',
        ET: 'ID Nacional',
        CN: 'ID Nacional',
        IN: 'Aadhaar',
        PK: 'CNIC',
        BD: 'NID',
        JP: 'My Number',
        KR: 'RRN',
        SG: 'NRIC/FIN',
        MY: 'MyKad',
        ID: 'KTP',
        PH: 'UMID',
        TH: 'ID Nacional',
        VN: 'CCCD',
        HK: 'HKID',
        TW: 'ID Nacional',
        LK: 'NIC',
        NP: 'ID Nacional',
        AU: 'TFN/Medicare',
        NZ: 'Número IRD',
        RU: 'SNILS',
        UA: 'Número Tributario',
        BY: 'ID Nacional',
        KZ: 'IIN',
        UZ: 'PINFL',
        GE: 'Número Personal',
        AM: 'Tarjeta Social',
        AZ: 'FIN',
      },
      email: 'Email',
      date: 'Fecha',
      of: 'de',
      rejectedInfoPartial: 'rechazó este documento el',
      rejectedWithReason:
        '{name} rechazó este documento el {date} debido a que {reason}. Te invitamos a realizar las correcciones necesarias en el documento actual y a generar una nueva solicitud de firma.',
      rejectedWithoutReason:
        '{name} rechazó este documento el {date}. Te invitamos a realizar las correcciones necesarias en el documento actual y a generar una nueva solicitud de firma.',
      rejectedWithReasonStandardized:
        '{name} rechazó este documento el {date} debido a que {reason}. La solicitud quedó detenida hasta que el documento sea corregido y reenviado.',
      rejectedWithoutReasonStandardized:
        '{name} rechazó este documento el {date}. La solicitud quedó detenida hasta que el documento sea corregido y reenviado.',
      rejectedWithReasonStandardizedSelf:
        'Rechazaste este documento el {date} debido a que {reason}. La solicitud quedó detenida hasta que el documento sea corregido y reenviado.',
      rejectedWithoutReasonStandardizedSelf:
        'Rechazaste este documento el {date}. La solicitud quedó detenida hasta que el documento sea corregido y reenviado.',
      weInviteYouTo: 'Te invitamos a',
      makeCorrections:
        'hacer las correcciones necesarias en el documento actual y generar una nueva solicitud de firma.',
    },
    back: 'Volver',
    paywall: {
      title: 'Has alcanzado el límite de respuestas. Actualiza tu plan para ver más',
      button: 'Actualizar plan',
      chat_message: 'Hola, necesito ver más respuestas. ¿Cómo puedo actualizar mi plan?',
    },
    downloadPdf: 'Descargar PDF',
    status: 'Estado',
    noStatus: 'Sin estado',
    activityPeriodTime: {
      startTime: 'Inicio de actividad',
      endTime: 'Fin de actividad',
      activity: 'Actividad',
      duration: 'Duración',
    },
  },
  electronic_signature: {
    verifySignature: 'Verificar firma',
    annex: 'Anexo',
    sendCode: 'Enviar código',
    errorSendingCode: 'Ha ocurrido un error enviando el código',
    successSendingCode: 'Código enviado correctamente',
    code_sent_to_email: 'Enviamos el código de verificación a tu correo:',
    resendCodeLabel: 'No recibiste el código? ',
    resend: 'Reenviar',
    incorrect_code: 'Código incorrecto, te quedan {remaining_attempts} intentos',
    maxAttemptsReached: 'Has alcanzado el máximo de intentos, se reenvió un nuevo código',
    errorVerifyingCode: 'Error al verificar el código',
    back: 'Volver',
    share: 'Compartir',
    signatures: {
      title: 'Mis firmas',
      signature_date: 'Fecha de firma',
      noPendingSignatures: '¡Felicitaciones! No tienes firmas pendientes en este momento',
      noCompletedSignatures: 'No tienes firmas completadas en este momento',
      noRejectedSignatures: 'No tienes firmas rechazadas en este momento',
      noSignaturesAvailable: 'No tienes firmas disponibles en este momento',
      selected: 'seleccionados',
      sign: 'Firmar',
      downloadSigned: 'Descargar',
      massiveSignError: 'Ocurrió un error al firmar los formularios',
      massiveSignSuccess: 'Formularios firmados exitosamente',
      downloadError: 'Ocurrió un error al descargar el archivo',
    },
    documentValidation: {
      validDocumentTitle: 'Documento Válido',
      formSummary:
        'Formulario {form_name} respondido por {user_name}. Fecha respuesta: {answer_date}.',
      openDetails: 'Accede a los detalles del documento aquí',
      respondedByLabel: 'Respondido por:',
      answerDateLabel: 'Fecha respuesta:',
      signedByTitle: 'Firmado por:',
      signerNameLabel: 'Nombre',
      signerRutLabel: 'RUT',
      signerEmailLabel: 'Email',
      signerDateLabel: 'Fecha',
      accessRestrictionNote:
        'Para acceder a los detalles del documento debes estar registrado en DataScope',
      footerLegalText:
        'Este documento cumple con la normativa chilena vigente y su firma electrónica está validada por la Dirección del Trabajo.',
      footerOrdinanceIntro: 'Consulta la ordenanza ',
      footerOrdinanceLinkLabel: 'aquí',
      footerCta: 'Digitaliza tus documentos con DataScope',
      noSigners: 'Este documento aún no tiene firmas registradas',
      error: 'No pudimos validar este documento. Verifica el enlace o contacta a soporte.',
    },
    filters: {
      date: 'Fecha',
      datePopoverTitle: 'Filtrar por fecha',
      allDates: 'Todas',
      form: 'Formulario',
      formPopoverTitle: 'Filtrar por formularios',
      requester: 'Responsable',
      requesterPopoverTitle: 'Filtrar por responsable',
      participants: 'Participantes',
      participantsPopoverTitle: 'Filtrar por participante',
      location: 'Lugar',
      locationPopoverTitle: 'Filtrar por lugar',
      all: 'Todos',
      selected: 'seleccionados',
      search: 'Buscar',
      noOptions: 'No encontramos resultados',
      status: 'Estado',
      statusPopoverTitle: 'Filtrar por estado',
      formCode: 'Código formulario',
      formCodePopoverTitle: 'Filtrar por código de formulario',
      formCodePlaceholder: 'Escribe el código',
      clearAll: 'Borrar filtros',
      deletedSuffix: 'Eliminado',
      inactiveSuffix: 'Inactivo',
      allTab: 'Usuarios',
      groupTab: 'Grupos',
      noUsers: 'No se encontraron usuarios',
      noGroups: 'No se encontraron grupos',
      formsTab: 'Formularios',
      foldersTab: 'Carpetas',
      dateFieldRequested: 'Fecha de solicitud',
      dateFieldSignedMine: 'Fecha de firma (firmas completadas)',
      dateFieldSignedRequest: 'Fecha de firma (firmas finalizadas)',
      dateFieldSignedShort: 'Fecha de firma',
      noForms: 'No se encontraron formularios',
    },
    statusFilter: {
      allStatuses: 'Todas',
      rejected: 'Rechazadas',
      pending: 'Pendientes',
      completed: 'Completadas',
      ongoing: 'En curso',
      finished: 'Finalizadas',
    },
    statusChip: {
      pending: 'Pendiente',
      signed: 'Firmada',
      ongoing: 'En curso',
      finished: 'Finalizada',
      rejected: 'Rechazada',
    },
    lastActivity: {
      title: 'Última actividad',
      signed: 'firmó el documento',
      rejected: 'rechazó la solicitud',
      reason: 'Motivo',
      unknownUser: 'Un usuario',
      rejectedBy: 'Rechazado por',
      rejectReasonLabel: 'Motivo rechazo',
      nextSigner: 'Siguiente',
      signedShort: 'Firmó',
      rejectedShort: 'Rechazó',
      correctedShort: 'Solicitud corregida',
      onDate: 'El',
      andMore: 'y {count} más',
      moreSigners: 'firmantes más',
      sent: 'Solicitud enviada',
    },
    statusCards: {
      pending: 'Pendientes',
      signed: 'Firmadas',
      ongoing: 'En curso',
      finished: 'Finalizadas',
      rejected: 'Rechazadas',
      requiresAction: 'Requieren acción',
      filterHint: 'Click para filtrar',
      totalSignatures: 'Total firmas',
      totalRequests: 'Total solicitudes',
    },
    requests: {
      notifyByEmail: 'Notificar vía email',
      title: 'Solicitudes enviadas',
      mandatory: 'Firma obligatoria',
      optional: 'Firma opcional',
      ongoing: 'En curso',
      completed: 'Finalizadas',
      searchPlaceholder: 'Buscar por usuario o formulario...',
      form: 'Formulario',
      requestDate: 'Fecha solicitud',
      requestDateLong: 'Fecha de solicitud',
      requestedBy: 'Solicitado por',
      goToSign: 'Ir a firmar',
      signatureDate: 'Fecha firma',
      signatures: 'Firmas',
      signed: 'Ya firmaron',
      pending: 'Pendientes',
      actions: 'Acciones',
      deleteRequest: 'Eliminar solicitud',
      viewRequestDetail: 'Ver detalle de solicitud',
      correct: 'Corregir',
      correctNoPermission: 'No tienes permisos para editar esta solicitud de firma rechazada',
      deleteSuccess: 'Solicitud eliminada con éxito',
      deleteError: 'Ocurrió un error al eliminar la solicitud',
      notifyByEmailSuccess: 'Usuarios notificados exitosamente',
      notifyByEmailError: 'Ocurrió un error al notificar a los usuarios',
      loadError: 'No pudimos cargar la lista. Intenta nuevamente.',
      noOngoingRequests: '¡Todo en orden! No tienes solicitudes en curso en este momento',
      noCompletedRequests: 'No tienes solicitudes finalizadas en este momento',
      noRejectedRequests: 'No tienes solicitudes rechazadas en este momento',
      noRequestsAvailable: 'No tienes solicitudes disponibles en este momento',
      noFilterResults: 'No tienes firmas disponibles en este momento',
      clearFilters: 'Borrar filtros',
      shareModal: {
        title: 'Compartir solicitud de firma finalizada',
        share: 'Compartir',
        infoAlert:
          'Se enviará un archivo por correo electrónico. Los destinatarios podrán acceder a los detalles y revisarlos fácilmente.',
        emailInstruction: 'Ingresa la direccion a la que deseas enviar el archivo.',
        inputInstruction: 'Puedes agregar tareas rápidamente separándolas con comas ",".',
        cancel: 'Cancelar',
      },
      shareSuccess: 'Solicitud compartida exitosamente',
      shareError: 'Ocurrió un error al compartir la solicitud',
      deleteWarningTitle: '¿Estás seguro que quieres eliminar esta solicitud?',
      deleteWarningMessage:
        'Las firmas ya realizadas seguirán siendo válidas y quedarán guardadas en el historial.',
      timeline: {
        title: 'Detalle de solicitud',
        close: 'Cerrar',
        correctRequest: 'Corregir solicitud',
        createdRequired: '{user} ha enviado una solicitud de firma obligatoria',
        createdOptional: '{user} ha enviado una solicitud de firma opcional',
        createdRequiredSimultaneous: '{user} ha enviado una solicitud de firma obligatoria a:',
        createdOptionalSimultaneous: '{user} ha enviado una solicitud de firma opcional a:',
        createdQuorumSimultaneous: '{user} ha enviado una solicitud de firma',
        createdRequiredSequential:
          '{user} envió una solicitud de firma obligatoria con este orden:',
        createdOptionalSequential: '{user} envió una solicitud de firma opcional con este orden:',
        createdQuorumSequential: '{user} envió una solicitud de firma con este orden:',
        signed: '{user} firmó el documento',
        rejected: '{user} rechazó la solicitud',
        rejectReason: 'Motivo',
        signatureRequested: 'Solicitud enviada a {user} ({number} firmantes)',
        signatureRequestedGroupSingular: 'Solicitud enviada a {users} (Firmante grupo {group})',
        signatureRequestedGroupPlural: 'Solicitud enviada a {users} (Firmantes grupo {group})',
        completed: 'Todas las firmas requeridas fueron completadas. El documento ya está listo',
        corrected: 'Solicitud corregida por {user}',
        signer: 'Firmante',
        signerSingular: 'firmante',
        signerPlural: 'firmantes',
        group: 'Grupo',
        quorumRequiredSingular: 'se requiere al menos {min} firma',
        quorumRequiredPlural: 'se requieren al menos {min} firmas',
      },
      tooltip: {
        signed: 'Solicitud finalizada',
        rejected: 'Solicitud rechazada',
      },
    },
    promo: {
      title: 'Firma reportes de forma digital y asegura procesos',
      description:
        'Con el módulo de Firmas podrás solicitar y firmar procesos de forma simple y segura.',
      actionButton: '¡Quiero implementar Firmas!',
      moreInfoTitle: '¡Garantiza la trazabilidad y reduce el margen de error!',
      infoPoint1: 'Solicita firmas a tu equipo en terreno y envía notificaciones automáticas',
      infoPoint2: 'Garantiza el cumplimiento de tus procesos',
      infoPoint3: 'Aprobado por la Dirección del Trabajo (válido solo en Chile)',
      infoPoint4: 'Accede a tus datos de forma segura desde cualquier dispositivo',
      moreInfoButton: '¡Quiero más información!',
      moreInfoLink: 'https://help.mydatascope.com/es/articles/8728763-firma-electronica-verificada',
    },
    emptyState: {
      mainBanner: {
        title: 'Firma reportes de forma digital y asegura procesos',
        description:
          'Con el módulo "Firmas" podrás solicitar y firmar procesos de forma simple y segura.',
        actionButton: '¡Quiero implementar Firmas!',
        actionButtonError:
          'Ocurrió un error al solicitar la implementación. Contáctese con soporte para más información.',
        actionButtonSuccess: 'Solicitud de implementación enviada exitosamente',
        actionButtonTooltipAdminUnrequested: 'Solicitar implementación',
        actionButtonTooltipAdminRequested: 'Ya se ha solicitado la implementación',
        actionButtonTooltipUser: 'Solo el administrador de la cuenta puede realizar esta acción',
      },
      gallery: {
        title: 'Gestiona firmas con validez legal',
        verifySignatures: 'Verifica y guarda las firmas del personal',
        verifySignaturesAlt: 'Smartphone visualizando en la app la verificación de la firma',
        requestSignatures: 'Solicita firmas en formularios específicos',
        requestSignaturesAlt:
          'Smartphone visualizando en la app una respuesta y el botón de solicitar firma',
        acceptSignatures: 'Acepta o rechaza firmas',
        acceptSignaturesAlt:
          'Smartphone visualizando en la app una respuesta con firma solicitada y los botones de aceptar y rechazar firma',
        trackSignatures: 'Monitorea el estado de cada firma',
        trackSignaturesAlt:
          'Smartphone visualizando en la app la lista de solicitudes de firma incompletas y sus detalles',
        pdfSignatures: 'Obtén reportes en PDF con firmas digitales',
        pdfSignaturesAlt:
          'Smartphone visualizando en la app el reporte en PDF con las firmas digitales incluidas y remarcadas',
      },
      requestMoreInfo: {
        title: '¡Súmala a tu plan hoy mismo!',
        description:
          'Conversa con un especialista y descubre cómo implementar el módulo en tu organización',
        button: 'Solicitar más información',
        link: 'https://datascope.io/es/nueva_firma/#',
      },
      newFeatures: {
        title: '¡A partir de hoy puedes usar estas nuevas funcionalidades!',
        preConfigTitle: 'Preconfiguración de firmantes',
        preConfigDescription:
          'Define previamente quién debe firmar tus documentos, automatizando flujos recurrentes y ahorrando tiempo.',
        externalSignatureTitle: 'Firma a usuarios externos',
        externalSignatureDescription:
          'Invita a colaboradores fuera de la organización a firmar de manera segura, sin necesidad de que tengan una cuenta en DataScope.',
        sequentialSignatureTitle: 'Configura secuencia de firmas',
        sequentialSignatureDescription:
          'Asigna un orden preestablecido en la firma de documentos para cuando tengas múltiples firmantes involucrados con diferente jerarquía.',
      },
    },
    activation: {
      processTitle: '¡Tu solicitud de activación del módulo de Firmas ya está en proceso!',
      processMessage:
        'Un representante de nuestro equipo se pondrá en contacto contigo para explicarte los detalles del proceso de activación de Firmas.',
      stepsTitle: 'Siguientes pasos',
      step1Title: 'Solicitud de activación del módulo de Firmas ingresada con éxito.',
      step2Title: 'Un experto de DataScope te contactará.',
      step2Description: 'Máximo 1 día hábil',
      step3Title: 'Reunión para presentar el módulo de Firmas.',
      step3Description: 'Fecha a coordinar con especialista',
      step4Title: 'Activación del módulo de Firmas.',
      step4Description: '¡Podrás acceder desde esta misma pestaña!',
    },
  },
  resume: {
    stats: {
      assignedTasks: 'Tareas Asignadas',
      completedTasks: 'Tareas completadas',
      forms: 'Formularios',
      totalForms: 'Total respondidos',
      locations: 'Lugares Visitados',
      totalLocations: 'Total lugares',
      signatures: 'Firmas',
      completedSignatures: 'Firmas completadas',
      findings: 'Tickets',
      closedFindings: 'Tickets cerrados',
      previousDays: 'días anteriores',
    },
    emptyState: {
      description:
        '¡Aún no has respondido ningún formulario! Empieza a optimizar tus procesos creando el primero',
      createFirstForm: 'Crear un formulario ahora',
    },
    statuses: {
      pending: 'Pendiente',
      accepted: 'Aceptado',
      rejected: 'Rechazado',
      noStatus: 'Sin estado',
    },
    table: {
      configure: 'Configurar',
      viewAnswer: 'Ver Respuesta',
      form: 'Formulario',
      code: 'Código',
      user: 'Usuario',
      date: 'Fecha',
      status: 'Estado',
      actions: 'Acciones',
      changeLog: 'Registro de cambios',
      modifyAnswer: 'Modificar respuesta',
      chat: 'Chat',
      sendToGoogleSheets: 'Enviar a Google Sheets',
      sendBackupToEmail: 'Enviar respaldo al correo',
      downloadPdf: 'Descargar PDF',
      duplicateAnswer: 'Duplicar respuesta',
      statusUpdateError: 'Hubo un error al actualizar el estado de la respuesta',
      noResults: 'No hay respuestas de formularios que coincidan con los filtros aplicados',
      deleteAnswer: 'Eliminar',
      recoverAnswer: 'Recuperar',
    },
    bulkActions: {
      delete: 'Eliminar',
      changeStatus: 'Cambiar estado',
      selected: 'seleccionados',
      confirmDelete: '¿Estás seguro que quieres eliminar {count} respuestas de formularios?',
      confirmDeleteDescription: 'Una vez eliminados, no podrán ser recuperados',
      cancel: 'Cancelar',
      selectStatus: 'Seleccionar estado',
      select: 'Seleccionar',
      statuses: 'Estados',
      selectStatusPlaceholder: 'Seleccionar un estado',
      statusesUpdated: '¡Estados actualizados exitosamente!',
      errorUpdatingStatuses: 'Error al actualizar estados',
      deleteSuccess: '¡Respuestas eliminadas exitosamente!',
      deleteError: 'Error al eliminar respuestas',
      recover: 'Recuperar',
      recoverSuccess: 'Respuestas recuperadas con éxito',
      recoverError: 'Error al recuperar respuestas',
    },
    filters: {
      addFilter: 'Agregar filtro',
      clearFilters: 'Borrar filtros',
      dateRange: {
        title: 'Fecha',
        popoverTitle: 'Filtrar por fecha',
      },
      location: {
        title: 'Lugar',
        popoverTitle: 'Filtrar por lugar',
        noLocations: 'No se encontraron lugares',
      },
      form: {
        title: 'Formulario',
        popoverTitle: 'Filtrar por formulario',
        inactive: 'Inactivo',
        deleted: 'Eliminado',
        folders: 'Carpetas',
        forms: 'Formularios',
        noForms: 'No se encontraron formularios',
      },
      status: {
        title: 'Estado',
        popoverTitle: 'Filtrar por estado',
      },
      user: {
        title: 'Usuario',
        popoverTitle: 'Filtrar por usuario',
        allTab: 'Usuarios',
        groupTab: 'Grupos',
        noUsers: 'No se encontraron usuarios',
        noGroups: 'No se encontraron grupos',
      },
      formCode: {
        title: 'Código del formulario',
        popoverTitle: 'Filtrar por código del formulario',
        placeholder: 'Escribe el código',
      },
      questionAndAnswer: {
        title: 'Pregunta y respuesta',
        popoverTitle: 'Filtrar por pregunta y respuesta',
        questionLabel: 'Pregunta',
        questionPlaceholder: 'Selecciona una pregunta',
        questionTextInputPlaceholder: 'Escribe el nombre de la pregunta',
        answerLabel: 'Respuesta',
        answerDisabledPlaceholder: 'Selecciona una pregunta para activar el filtro',
        answerTextInputPlaceholder: 'Escribe el nombre de una pregunta para activar el filtro',
        answerPlaceholder: 'Escribe la respuesta',
        info: 'El filtro solo se aplicará si hay una pregunta y una respuesta',
        disabledTooltip: 'Para usar este filtro, primero debes agregar un filtro de formulario',
      },
      finding: {
        title: 'Ticket',
        popoverTitle: 'Filtrar por ticket',
        includesFinding: 'Incluye ticket',
        withoutFindings: 'Sin tickets',
      },
      signature: {
        title: 'Firma',
        popoverTitle: 'Filtrar por firma',
      },
      answeredFrom: {
        title: 'Medio de envío',
        popoverTitle: 'Filtrar por medio de envío',
        mobile: 'Móvil',
        web: 'Web',
      },
      assets: {
        title: 'Activos',
        popoverTitle: 'Filtrar por activos',
        noAssets: 'No se encontraron activos',
      },
    },
    signature: {
      mandatoryIncomplete: 'Firma obligatoria - Pendiente',
      mandatoryComplete: 'Firma obligatoria - Completa',
      optionalIncomplete: 'Firma opcional - Pendiente',
      optionalComplete: 'Firma opcional - Completa',
      rejected: 'Firma rechazada',
      quorumPending: 'Firma pendiente',
      quorumComplete: 'Firma completa',
    },
    recentTitle: 'Formularios Recientes',
    deletedTitle: 'Formularios Eliminados',
    searchBarPlaceholder: 'Buscar por nombre del formulario',
    dateRange: 'Mostrando resultados para',
    changeLog: {
      title: 'Registro de cambios',
      details: 'Ver detalles',
      userChangedAnswer: '{user} cambió la respuesta',
      userChangedState: '{user} cambió el estado de la respuesta a {state}',
      userRecoveredAnswer: '{user} recuperó la respuesta',
      userDeletedAnswer: '{user} eliminó la respuesta',
      userDuplicatedAnswer: '{user} duplicó la respuesta',
      userStartedAnswer: '{user} empezó a responder',
      userResetState: '{user} ha reestablecido el estado de la respuesta',
      googleSheets: 'Google Sheets',
      webhookSyncErrors: '{count} errores al sincronizar con',
      webhookSyncError: '1 error al sincronizar con',
      webhookSyncRestored: 'Sincronización restaurada con',
      webhookSyncOk: 'Sincronización exitosa con',
      viewErrorDetails: 'Ver detalle de errores',
      hideErrorDetails: 'Ocultar errores',
    },
    close: 'Cerrar',
    export: {
      title: 'Exportar',
      taskForm: 'Formulario',
      dateRange: 'Rango de fecha',
      downloadFormat: 'Formato de descarga',
      email: 'Email',
      downloadFormats: {
        answers: 'Excel agrupado por pregunta',
        forms: 'Excel agrupado por formularios',
        subforms: 'Excel agrupado por preguntas repetibles',
        pdfs: 'Excel con documentos PDF',
        pdfsZip: 'Documentos PDF en ZIP',
      },
      exportInfo: 'Las respuestas serán exportadas conforme a los filtros de la tabla',
      exportFormFilterRequired:
        'Para exportar las respuestas, primero debes filtrar por formulario',
      exportDateRangeLimit:
        'Límite de exportación: 180 días (6 meses). Selecciona un rango de fecha más pequeño',
      cancel: 'Cancelar',
      success: 'Exportación enviada con éxito',
      error: 'Hubo un error al exportar las respuestas',
      disabledForFreeUser: 'Actualiza tu plan para habilitar la exportación de datos',
      selectOrFilterToExport: 'Filtra por formulario o selecciona respuestas para exportar.',
      clearSelectionForExcel: 'Quita la selección para exportar a Excel.',
      formatPlaceholder: 'Seleccionar formato',
      documentsGroup: 'Documentos',
      excelGroup: 'Excel',
      excelUnavailableReason:
        'Excel exporta el filtro completo, no una selección. Quita la selección para exportar a Excel.',
      zipSelectionNotice: 'Se exportarán {count} respuestas seleccionadas en un archivo ZIP',
      filterNotice: 'Se exportarán {count} respuestas',
      zipFilterNotice: 'Se exportarán {count} respuestas en un archivo ZIP',
      zip: {
        countNotice: 'Se descargarán {count} respuestas en un ZIP con sus documentos PDF.',
        emptyNotice: 'No hay respuestas para descargar con los filtros actuales.',
        generating:
          'Estamos preparando tu archivo ZIP. Esto puede tardar unos minutos, mantén esta ventana abierta.',
        done: 'Tu ZIP está listo. La descarga comenzará automáticamente. Si no ocurre, usa el enlace de abajo.',
        doneWithWarnings:
          'Tu ZIP está listo, pero {count} documentos no se pudieron incluir. Revisa el archivo errores.csv dentro del ZIP.',
        error: 'Hubo un error al generar el ZIP. Inténtalo de nuevo.',
        errorConflict:
          'Ya tienes una exportación en curso. Espera a que termine e inténtalo de nuevo.',
        errorTimeout: 'La exportación está tardando demasiado. Inténtalo más tarde.',
        action: 'Descargar ZIP',
        progressPill: 'Generando archivos PDF',
        downloadPart: 'Descargar parte {n}',
      },
    },
    sendToGoogleSheets: {
      success: 'Enviado a Google Sheets correctamente',
      error: 'Hubo un error al enviar la respuesta a Google Sheets',
      gsheetBusy:
        'Google Sheets está ocupado en este momento. Espera unos minutos y vuelve a intentarlo.',
      integrationError:
        'No se pudo enviar a Google Sheets. Revisa tu integración (permisos, fórmulas y enlace a la hoja de cálculo).',
      unknownError:
        'Ocurrió un error desconocido al enviar a Google Sheets. Vuelve a intentarlo más tarde.',
      sendModifyConfirmTitle: 'Esta respuesta ya fue enviada a Google Sheets',
      sendModifyConfirmMessage:
        'Esta integración no tiene activada la sincronización de ediciones o segundas instancias. Reenviar manualmente puede crear filas duplicadas en la hoja de cálculo. ¿Quieres continuar de todas formas?',
      sendModifyConfirmButton: 'Sí, enviar igual',
    },
    duplicateAnswer: {
      success: 'Respuesta duplicada exitosamente',
      error: 'Error al duplicar respuesta',
    },
    sendBackupModal: {
      title: 'Enviar respaldo al correo',
      description:
        'Escribe el correo donde quieres recibir el archivo de respaldo de este formulario',
      send: 'Enviar',
      cancel: 'Cancelar',
    },
    deleteAnswer: {
      title: '¿Estás seguro que quieres eliminar esta respuesta?',
      description:
        'Una vez la elimines, podrás recuperarla filtrando por formularios eliminados y restaurándola desde su configuración.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
      success: 'Respuesta eliminada con éxito',
      error: 'Error al eliminar respuesta',
    },
    recoverAnswer: {
      success: 'Respuesta recuperada con éxito',
      error: 'Error al recuperar respuesta',
    },
    statusSelector: {
      newStatus: 'Selecciona o crea un estado',
      newStatusPlaceholder: 'Escribe aquí el nuevo estado',
      newStatusError: 'El estado ya existe',
      delete: 'Eliminar',
      color: 'Color',
      colors: {
        white: 'Blanco',
        blue: 'Azul',
        yellow: 'Amarillo',
        red: 'Rojo',
        green: 'Verde',
        gray: 'Gris',
      },
      editStatusError: 'Error al actualizar estado',
      deleteStatusError: 'Error al eliminar estado',
      createStatusError: 'Error al crear estado',
      deleteConfirmationTitle: '¿Estás seguro que quieres eliminar este estado?',
      deleteConfirmationMessage:
        'Al eliminarlo no podrás recuperarlo, pero las respuestas que lo usen no se verán afectadas',
    },
    chat: {
      notifyUsersError: 'Error al notificar a los usuarios',
    },
    filtersLinkCopy: {
      tooltip: 'Copiar enlace con filtros',
      success: 'Enlace copiado al portapapeles',
      error: 'No se pudo copiar el enlace. Revisa los permisos del navegador.',
    },
    answerView: {
      previous: 'Anterior',
      next: 'Siguiente',
    },
  },
  assets: {
    title: 'Activos',
    assetsSearchPlaceholder: 'Buscar por nombre o identificador',
    historySearchPlaceholder: 'Buscar por nombre, identificador o usuario',
    noAssets: 'No se encontraron activos.',
    noAssetMeters: 'No hay medidores configurados para este activo',
    noHistory: 'No se encontró historial.',
    create: 'Crear',
    update: 'Actualizar',
    createAsset: 'Crear activo',
    name: 'Nombre',
    configuration: 'Configuración',
    addUsers: 'Agregar usuarios',
    showAll: 'Mostrar todos ({count})',
    showLess: 'Mostrar menos',
    usersAssignedSuccess: 'Usuarios asignados exitosamente',
    usersAssignedError: 'Error al asignar usuarios',
    history: 'Historial',
    code: 'Identificador',
    dateAndTime: 'Fecha y hora',
    asset: 'Activo',
    modifiedField: 'Campo modificado',
    modification: 'Modificación',
    modifiedBy: 'Modificado por',
    createNewAsset: 'Crear nuevo activo',
    editAsset: 'Editar activo',
    assetInformation: 'Información del activo',
    metersDescription:
      'Asocia y gestiona los medidores de cada activo para registrar mediciones de forma precisa',
    namePlaceholder: 'Nombre del activo',
    codePlaceholder: 'Número de serie, placa o ID único',
    location: 'Lugar',
    locationPlaceholder: 'Selecciona un lugar',
    restrictAccess: 'Restringir el acceso a este activo a usuarios específicos',
    usersAndGroups: 'Usuarios y grupos responsables',
    description: 'Descripción',
    descriptionPlaceholder: 'Escribe una descripción para el activo',
    meterType: 'Tipo de medidor',
    meterTypePlaceholder: 'Selecciona un tipo de medidor',
    meter: 'Medidor',
    lastMeasurement: 'Última medición',
    lastSyncedMeasurement: 'Última medición sincronizada: ',
    lastMeasurements: 'Última(s) Medición(es)',
    listFilters: {
      location: 'Lugar',
      lastMeasurementDate: 'Fecha Última Medición',
      filterByLocation: 'Filtrar por lugar',
      customField: 'Campo personalizado',
      selectField: 'Selecciona un campo',
      selectOption: 'Selecciona una opción',
      option: 'Opción',
      dateRange: 'Rango de fechas',
      value: 'Valor',
      selectDateRange: 'Seleccionar rango',
      enterValue: 'Ingresa un valor',
      clearOption: 'Limpiar opción',
      filterByCustomField: 'Filtrar por campo personalizado',
      field: 'Campo',
      noOptions: 'No hay opciones disponibles',
      search: 'Buscar',
    },
    actions: 'Acciones',
    viewDetails: 'Ver detalle',
    edit: 'Editar',
    delete: 'Eliminar',
    edited: 'Editado',
    editedBy: 'Editado por',
    previousValue: 'Valor anterior',
    confirmDeleteTitle: '¿Estás seguro que quieres eliminar este activo?',
    deactivateTitle: 'Desactivar activo',
    deactivateWithPlanningsDescription:
      'Este activo tiene {count} planificaciones activas que se pausarán automáticamente hasta que vuelva a activarse. Además dejará de estar disponible en las listas de activos.',
    deactivateDescription: 'Este activo dejará de estar disponible en las listas de activos.',
    pausedMaintenanceCount: '{count} mantenimiento pausado',
    pausedMeterTooltipInactivity: 'Horómetro pausado por inactividad',
    pausedMeterTooltipDeactivated: 'Mantenimiento pausado por activo desactivado',
    confirmDeleteDescription:
      'El activo {assetName} se eliminará, pero los datos registrados anteriormente se conservarán.',
    cancel: 'Cancelar',
    assetCreated: 'Activo creado exitosamente',
    assetRestored: 'Activo restaurado',
    assetUpdated: 'Activo actualizado exitosamente',
    assetDeleted: 'Activo eliminado exitosamente',
    assetDeletedError: 'Error al eliminar activo',
    activate: 'Activar',
    deactivate: 'Desactivar',
    assetDeactivated: 'Activo desactivado exitosamente',
    assetDeactivatedError: 'Error al desactivar activo',
    assetReactivated: 'Activo reactivado exitosamente',
    assetReactivatedError: 'Error al reactivar activo',
    confirmDeactivateTitle: '¿Estás seguro que quieres desactivar este activo?',
    confirmDeactivateDescription:
      'El activo {assetName} será desactivado. Seguirá apareciendo en la tabla pero con acceso limitado.',
    assetUpdatedError: 'Error al actualizar activo',
    noAssetPermissions: 'No tienes permisos para ver activos',
    assetCreatedError: 'Error al crear activo',
    meterCreated: 'Medidor creado exitosamente',
    meterUpdated: 'Medidor actualizado exitosamente',
    meterDeleted: 'Medidor eliminado exitosamente',
    meterDeactivated: 'Medidor desactivado correctamente',
    meterDuplicated: 'Medidor duplicado exitosamente',
    assetLimitReachedError:
      'Límite de activos alcanzado. No puedes crear más activos con tu plan actual.',
    assetCodeAlreadyExists: 'El código del activo ya existe',
    assetInfo: 'Información del activo',
    export: 'Exportar',
    import: 'Importar',
    editTableColumns: 'Personalizar columnas',
    selectedCount: '{count} seleccionados',
    changeTypeButton: 'Cambiar tipo de activo',
    changeTypeTitle: 'Cambiar tipo de activo',
    changeTypeInfo: 'Reemplazará el tipo actual de los activos seleccionados',
    changeTypeApply: 'Agregar',
    changeTypeSearchPlaceholder: 'Buscar un tipo de activo',
    confirmChangeTypeTitle: '¿Estás seguro de cambiar el tipo de los activos seleccionados?',
    confirmChangeTypeMessage:
      'Los campos personalizados en los activos seleccionados no estarán visibles, pero la información seguirá registrada.',
    usersAndGroupsTooltip:
      'Estos usuarios y grupos son los responsables de este activo. Si además marcas "Restringir el acceso", serán los únicos que puedan verlo y gestionarlo.',
    v1MetersDescription: 'Actualmente, solo soportamos medidores de tipo horómetro.',
    addUsersDescription:
      'Los usuarios seleccionados quedan como responsables de este activo. El acceso para verlo y gestionarlo depende de sus permisos y de si activas "Restringir el acceso".',
    addUsersExpirationNotice:
      'Estos usuarios recibirán los avisos de vencimiento de los documentos de este activo.',
    findOutMore: 'Saber más',
    findOutMoreLink: 'https://help.mydatascope.com/es/articles/12098023-activos-en-datascope',
    betaBannerTitle: 'Activos está en beta',
    betaBannerDescription:
      'Estamos trabajando en la versión completa, que incluirá propiedades, medidores y lugares. Muy pronto disponible en planes pagos.',
    moreInfo: 'Más información',
    viewMeasurements: 'Ver mediciones',
    noMeasurements: 'Sin mediciones',
    noData: 'Sin datos',
    initialMeasurementPlaceholder: 'Ingresa el valor inicial',
    initialMeasurementsTitle: 'Lecturas iniciales de medidores',
    initialMeasurementsDescription: 'Define el valor inicial de cada medidor para este activo',
    initialMeasurementTooltip:
      'Este es el valor inicial definido al crear el activo. Para actualizarlo, registra una nueva medición.',
    summaryTitle: 'Resumen',
    noAssetTypeSelected: 'Aún no seleccionado',
    noMeters: 'Sin medidores',
    fieldRequired: 'Este campo es obligatorio',
    inactive: 'Inactivo',
    inactiveMeterTooltip:
      'Este medidor está inactivo para el tipo de activo actual. Puedes ver las lecturas anteriores. Para activarlo, agrégalo al tipo de activo o cambia el tipo del activo.',
    automatic: 'Automático',
    automaticMeterTooltip: 'Este medidor recibe sus mediciones automáticamente desde un sensor.',
    blockedAssetTooltip:
      'Este activo está bloqueado por límite de plan. Actualiza tu plan para acceder al detalle.',
    blockedAssetHistoryTooltip:
      'Este activo está limitado por tu plan actual. Actualiza tu plan para ver los detalles del historial.',
    assetStatus: 'Estado del activo',
    changeTypes: {
      asset_created: 'Activo creado',
      asset_deleted: 'Activo eliminado',
      asset_deactivated: 'Activo desactivado',
      asset_reactivated: 'Activo reactivado',
      asset_revived: 'Activo restaurado',
      asset_updated_by_import: 'Activo actualizado por importación',
      added_user: 'Usuario(s) asignado(s)',
      removed_user: 'Usuario(s) eliminado(s)',
      added_group: 'Grupo(s) asignado(s)',
      removed_group: 'Grupo(s) eliminado(s)',
      added_meter: 'Medidor(es) asignado(s)',
      removed_meter: 'Medidor(es) eliminado(s)',
      name: 'Nombre cambiado',
      code: 'Código cambiado',
      description: 'Descripción cambiada',
      asset_type: 'Tipo de activo cambiado',
      nestable_location: 'Lugar cambiado',
    },
    importDrawer: {
      title: 'Importar Activos',
      step1Title: 'Paso 1: Descarga el archivo',
      step1Description:
        'Descarga el archivo de ejemplo. Contendrá una hoja por cada tipo de activo configurado en tu cuenta. Asegúrate de campos marcados con * para importar tu archivo correctamente.',
      step1DescriptionPart1:
        'Descarga el archivo de ejemplo. Contendrá una hoja por cada tipo de activo configurado en tu cuenta. Asegúrate de campos marcados con',
      step1DescriptionPart2: 'para importar tu archivo correctamente.',
      downloadExample: 'Descargar ejemplo',
      step2Title: 'Paso 2: Edita el archivo',
      step3Title: 'Paso 3: Sube tu archivo',
      step3Description: 'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora.',
      dragDropText: 'Arrastra y suelta aquí tu Excel',
      browseText: 'o búscalo en tu computador',
      replaceText: 'Reemplazar',
      fileUploadedText: 'Tu archivo ha sido cargado',
      invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
      importSuccess: 'Activos importados correctamente',
      importError: 'Error al importar activos',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      importingDescription: 'Un momento, estamos organizando todo...',
      errorTitle: 'Detectamos un error.',
      errorMessage: 'Por favor, verifica que tus datos tengan el formato correcto.',
      sheetsWithErrorsMessage: 'El archivo contiene errores en las hojas: ',
      sheetsWithErrorsRecommendation:
        'Revisa las hojas indicadas y corrige los datos para continuar.',
      andMore: 'y {remainingCount} más',
      nameErrorMessage: '{errorCount} filas fueron enviadas sin nombre de activo.',
      templateDownloadError: 'Error al descargar el archivo de ejemplo',
      downloadingTemplate: 'Descargando...',
      showMore: 'Mostrar {count} más',
      showLess: 'Mostrar menos',
      errorsListTitle: 'Errores encontrados',
      rowLabel: 'Fila',
      formatLabel: 'Formato',
      summary: {
        created: '{count} activo(s) creado(s)',
        restored: '{count} activo(s) restaurado(s)',
        updated: '{count} activo(s) actualizado(s)',
      },
    },
    googleSheets: {
      button: 'Google Sheets',
      modalTitle: 'Integrar Activos',
      infoMessage: 'Para una integración segura, comparte tu documento con permisos de',
      editorPermission: 'editor',
      infoMessageTo: 'a',
      linkLabel: 'Nuevo enlace',
      linkPlaceholder: 'Ingresa el enlace del documento a integrar',
      goToSheets: 'Ir a Google Sheets',
      copied: 'Enlace copiado',
      copyError: 'No se pudo copiar el enlace. Inténtalo copiándolo manualmente.',
      deleted: 'Integración con Google Sheets eliminada correctamente',
      deleteError: 'Error al eliminar la integración con Google Sheets',
      deleteConfirmTitle: '¿Quitar la integración con Google Sheets?',
      deleteConfirmMessage:
        'La hoja dejará de recibir actualizaciones de activos desde DataScope. El documento en Google Drive no se elimina.',
      deleteConfirmAction: 'Quitar',
      cancel: 'Cancelar',
      save: 'Guardar',
      success: 'Integración con Google Sheets creada correctamente',
      error: 'Error al crear la integración con Google Sheets',
    },
    exportSuccess: 'Activos exportados correctamente',
    exportError: 'Error al exportar activos',
    exporting: 'Exportando...',
    exportModal: {
      title: 'Exportar activos',
      assetTypesLabel: 'Selecciona los tipos de activo a exportar',
      assetTypesPlaceholder: 'Selecciona los tipos de activo',
      selectAll: 'Seleccionar todos los tipos de activo',
      confirm: 'Exportar',
      cancel: 'Cancelar',
      infoBanner: 'La exportación incluirá solo los tipos de activos que tengan activos asociados.',
    },
    origin: 'Origen',
    meters: {
      title: 'Medidores',
      subtitle: 'Gestiona los medidores disponibles para tus activos',
      create: 'Crear',
      createMeter: 'Crear medidor',
      automaticHintTitle: 'Este medidor puede alimentarse de un sensor',
      automaticHintBody:
        'Una vez creado y agregado a un activo, ponlo en modo automático desde el activo y elige qué campo del sensor lo alimenta.',
      automaticHintDisabled:
        'El módulo de sensores no está habilitado en esta cuenta, así que los medidores solo se llenan a mano. Escríbenos si quieres más información.',
      editMeter: 'Editar medidor',
      deactivateMeter: 'Desactivar medidor',
      backToAssets: 'Volver a Activos',
      cancel: 'Cancelar',
      update: 'Actualizar',
      metersSearchPlaceholder: 'Buscar por nombre de medidor',
      noResults: 'No se encontraron resultados',
      feedDialogTitle: 'Alimentar {meter} con un sensor',
      feedSensorLabel: 'Sensor',
      feedAttributeLabel: 'Atributo que alimenta el medidor',
      feedAlreadyAutomatic: 'Este medidor ya está en modo automático. Quítalo para elegir otro sensor.',
      feedNoSensorsLinked: 'Este activo no tiene sensores vinculados todavía.',
      feedAdminOnly: 'Solo los administradores pueden poner un medidor en modo automático.',
      feedNoSensorsTitle: 'Este activo todavía no tiene sensores vinculados',
      feedNoSensorsBody:
        'Un medidor solo puede alimentarse de un sensor vinculado a este activo. Vincula uno desde la pestaña Sensores y vuelve acá.',
      feedNoSensorsAction: 'Ir a Sensores',
      feedNoAttributesTitle: 'Este sensor todavía no ha enviado datos',
      feedNoAttributesBody:
        'No hay campos para elegir hasta que llegue su primer mensaje. Revisa la pantalla de Entradas para ver qué está enviando.',
      feedNoAttributes: 'Este sensor todavía no ha enviado datos.',
      feedCancel: 'Cancelar',
      feedSubmit: 'Activar modo automático',
      feedRemove: 'Quitar modo automático',
      feedConfigureSuccess: 'Medidor en modo automático.',
      feedConfigureError: 'No pudimos activar el modo automático, intenta de nuevo.',
      feedRemoveSuccess: 'Modo automático desactivado.',
      feedRemoveError: 'No pudimos desactivar el modo automático, intenta de nuevo.',
      table: {
        name: 'Nombre',
        unit: 'Unidad de medida',
        usage: 'Uso',
        actions: 'Acciones',
        usedInAssetTypes: 'Usado en {count} tipo(s)',
        notUsed: 'No usado',
        edit: 'Editar',
        duplicate: 'Duplicar',
        deactivate: 'Desactivar',
        activate: 'Activar',
      },
      pagination: {
        results: 'Resultados: {start}-{end} de {total}',
      },
      noMeters: 'No se encontraron medidores',
      confirmDeactivateDescription:
        'El medidor {meterName} será desactivado. Al desactivar este medidor dejará de estar disponible para nuevos activos. Si deseas, luego lo podrás reactivar.',
      meterInUseError:
        'No se puede desactivar el medidor porque está en uso en tipos de activos. Retíralo de los tipos de activos primero.',
      deactivationDisabled:
        'Este medidor no se puede desactivar porque ya está en uso por uno o más tipos de activo.',
      units: {
        hour: 'Hora',
        minute: 'Minuto',
        seconds: 'Segundo',
        day: 'Día',
        mile: 'Milla',
        kilometer: 'Kilómetro',
        meter: 'Metro',
        foot: 'Pie',
        yard: 'Yarda',
        inch: 'Pulgada',
        centimeter: 'Centímetro',
        millimeter: 'Milímetro',
        nautical_mile: 'Milla Náutica',
        celsius: 'Celsius',
        fahrenheit: 'Fahrenheit',
        kelvin: 'Kelvin',
        volt: 'Voltio',
        megavolt: 'Megavoltio',
        megavolts: 'Megavoltio',
        kilovolt: 'Kilovoltio',
        kilovolts: 'Kilovoltio',
        millivolt: 'Milivoltio',
        millivolts: 'Milivoltio',
        microvolt: 'Microvoltio',
        microvolts: 'Microvoltio',
        bar: 'Bar',
        pascal: 'Pascal',
        psi: 'PSI',
        kilogram: 'Kilogramo',
        ton: 'Tonelada',
        pound: 'Libra',
        kilometer_per_hour: 'Kilómetro por Hora',
        mile_per_hour: 'Milla por Hora',
        meter_per_second: 'Metro por Segundo',
        newton_meter: 'Newton Metro',
        pound_foot: 'Libra Pie',
        liter: 'Litro',
        gallon: 'Galón',
        cubic_meter: 'Metro Cúbico',
        cubic_foot: 'Pie Cúbico',
        rpm: 'RPM',
        hertz: 'Hertz',
        watt: 'Vatio',
        kilowatt: 'Kilovatio',
        ampere: 'Amperio',
        square_meter: 'Metro Cuadrado',
        square_foot: 'Pie Cuadrado',
        hectare: 'Hectárea',
        farad: 'Faradio',
        ohm: 'Ohmio',
        siemens: 'Siemens',
        lux: 'Lux',
        radian_per_second: 'Radián por Segundo',
        coulomb: 'Culombio',
        unit: 'Unidad',
      },
      assetTypeModal: {
        title: 'Tipos de activo asociados a ',
        description: 'Este medidor está asociado a los siguientes tipos de activo:',
        close: 'Cerrar',
      },
    },
    value: 'Valor',
    assetsCreated: 'activos creados',
    duplicatesSkipped: 'duplicados omitidos',
    errorsCount: 'errores',
    readings: 'Lecturas',
    meterHistory: {
      containsEditedReading: 'Contiene una lectura editada',
      containsEditedReadings: 'Contiene {count} lecturas editadas',
      clickGoesToEdited: 'El clic lleva a la del {reading}',
      dayDetail: 'Detalle del día',
      // Plural and lowercase, for inline use after a value and as the chart's
      // axis label. assets.meters.units holds the SINGULAR Title Case names the
      // meters table and drawer need, which would read as "2179 Hora" here.
      unitNames: {
        hour: 'horas',
        minute: 'minutos',
        day: 'días',
        mile: 'millas',
        kilometer: 'kilómetros',
        meter: 'metros',
        foot: 'pies',
        yard: 'yardas',
        nautical_mile: 'millas náuticas',
        celsius: 'grados Celsius',
        fahrenheit: 'grados Fahrenheit',
        kelvin: 'kelvin',
        volt: 'voltios',
        megavolt: 'megavoltios',
        megavolts: 'megavoltios',
        kilovolt: 'kilovoltios',
        kilovolts: 'kilovoltios',
        millivolt: 'milivoltios',
        millivolts: 'milivoltios',
        microvolt: 'microvoltios',
        microvolts: 'microvoltios',
        bar: 'bar',
        pascal: 'pascales',
        psi: 'psi',
        kilogram: 'kilogramos',
        ton: 'toneladas',
        pound: 'libras',
        kilometer_per_hour: 'kilómetros por hora',
        mile_per_hour: 'millas por hora',
        meter_per_second: 'metros por segundo',
        newton_meter: 'newton metro',
        pound_foot: 'libras pie',
        liter: 'litros',
        gallon: 'galones',
        cubic_meter: 'metros cúbicos',
        cubic_foot: 'pies cúbicos',
        rpm: 'rpm',
        hertz: 'hertz',
        watt: 'vatios',
        kilowatt: 'kilovatios',
        ampere: 'amperios',
        square_meter: 'metros cuadrados',
        square_foot: 'pies cuadrados',
        hectare: 'hectáreas',
        farad: 'faradios',
        ohm: 'ohmios',
        siemens: 'siemens',
        lux: 'lux',
        radian_per_second: 'radianes por segundo',
        coulomb: 'culombios',
        unit: 'unidades',
      },
      readingsHistoryTitle: 'Historial de lecturas',
      chartTitle: 'Visualización de lecturas',
      viewLabel: 'Vista',
      emptyNoHistoryTitle: 'Aún no hay lecturas registradas',
      emptyNoHistoryBody:
        'Registra una medición desde un formulario o manualmente para visualizar las lecturas del medidor.',
      emptyNoResultsTitle: 'No hay lecturas en el período seleccionado',
      emptyNoResultsBody: 'Ajusta o quita el filtro de fecha para visualizar otras lecturas.',
      errorTitle: 'No se pudo cargar el historial',
      retry: 'Reintentar',
      accumulatedView: 'Acumulado',
      usageView: 'Uso',
      groupedByDay: 'Agrupado por día',
      groupedByWeek: 'Agrupado por semana',
      groupedByMonth: 'Agrupado por mes',
      readingsCountOne: '1 lectura',
      readingsCountOther: '{count} lecturas',
      noReadingInBucket: 'Sin lectura en este período',
      nearestReading: 'Lectura más cercana',
      editedReading: 'Lectura editada',
      usageNeedsPreviousReading: 'Se necesita al menos una lectura anterior para calcular el uso.',
      dateFilterTitle: 'Fecha',
      dateFilterPopoverTitle: 'Filtrar por fecha',
    },
    configure: 'Configurar',
    initialMeasurement: 'Medición inicial',
    measurementUpdated: 'Editado exitosamente',
    measurementUpdatedError: 'Error al editar',
    measurementDeleted: 'Eliminado exitosamente',
    measurementDeletedError: 'Error al eliminar',
    confirmDeleteMeasurementTitle: '¿Estás seguro de que quieres eliminar esta medición?',
    confirmDeleteMeasurementDescription:
      'Esta acción es permanente y la medición ya no aparecerá en la tabla.',
    mustEnterNumber: 'Debes ingresar un número',
    action: 'Acción realizada',
    newValue: 'Nuevo valor',
    measurements: 'Mediciones',
    historyTitle: 'Historial de cambios',
    deleted: 'Eliminado',
    measurementsHistoryEmptyState: 'Aún no hay modificaciones en este medidor',
    formCustomFieldsLabel: 'Detalles del activo',
    imageDragDropText: 'Arrastra y suelta una imagen aquí',
    filesDragDropText: 'Arrastra y suelta archivos aquí',
    uploadFileError: 'Error al subir el archivo',
    uploadErrorDismiss: 'Error al subir. Descártalo y vuelve a agregar el archivo.',
    removeFileLabel: 'Eliminar archivo',
    discardFileLabel: 'Descartar archivo',
    maxWeightError: 'Alcanzaste el límite de 100 MB por activo. Ajusta la selección.',
    maxFilesReached: 'Alcanzaste el máximo de archivos para este campo.',
    savingDisabledUploadsTooltip: 'Espera a que los archivos terminen de subir antes de guardar.',
    cancelWithUploadsConfirm: 'Hay archivos subiéndose. ¿Seguro que quieres salir?',
    filesQuotaUsed: '{used} de {total} MB usados',
    filesQuotaUnknownWarning:
      'Algunos archivos no se pudieron medir; el total real puede ser mayor.',
    filesQuotaExceededError: 'Los archivos superan el límite de 100 MB por activo.',
    filesItemFallbackName: 'Archivo {number}',
    documents: {
      addExpirationDate: 'Añadir fecha de vencimiento',
      singleFileNotice: 'Al activar el vencimiento, el campo admite un solo archivo.',
      remindersTitle: 'Avisar antes del vencimiento',
      reminderDays: '{days} días',
      reminderOnDueDate: 'El día del vencimiento',
      noRemindersSelected: 'Sin anticipaciones seleccionadas, no se enviará ningún correo.',
      expirationDateLabel: 'Fecha de vencimiento',
      replaceLabel: 'Reemplazar',
      replaceDocumentLabel: 'Reemplazar documento',
      editDocumentLabel: 'Editar documento',
      removeLabel: 'Eliminar',
      clearDateLabel: 'Limpiar fecha',
      openCalendarLabel: 'Abrir calendario',
      documentRequired: 'Debes adjuntar un documento.',
      singleFileDropzone: 'Este campo admite un solo archivo porque lleva fecha de vencimiento.',
      dateBlockedByMultipleFiles:
        'Este campo tiene más de un archivo. Deja solo uno para poder cargar su fecha de vencimiento.',
      noRecipientsFieldNotice:
        'Nadie recibirá los avisos de este vencimiento: el activo no tiene a nadie asignado.',
      expiresOn: 'Vence:',
      expiredOn: 'Venció:',
      withoutExpirationDate: 'Fecha de vencimiento sin configurar',
      status: {
        valid: 'Vigente',
        expiring: 'Por vencer',
        expired: 'Vencido',
        noDate: 'Sin fecha',
      },
      countOne: '{count} documento',
      countMany: '{count} documentos',
      banner: {
        attentionOne: 'Este activo tiene {documents} que requiere atención.',
        attentionMany: 'Este activo tiene {documents} que requieren atención.',
        attentionAction: 'Gestionar documentos',
        expiringOne: 'Este activo tiene {documents} próximo a vencer.',
        expiringMany: 'Este activo tiene {documents} próximos a vencer.',
        expiringAction: 'Revisar documentos',
        noDate: 'Este activo tiene {documents} sin su fecha de vencimiento.',
        noDateAction: 'Completar fechas',
      },
      noRecipientsWarning:
        'Nadie recibirá los avisos de vencimiento de los documentos de este activo hasta que asignes un usuario o un grupo.',
      noRecipientsAction: 'Asignar responsable',
      listTooltip: {
        attentionOne: '{documents} requiere atención:',
        attentionMany: '{documents} requieren atención:',
        expiringOne: '{documents} próximo a vencer:',
        expiringMany: '{documents} próximos a vencer:',
        noDateOne: '{documents} requiere fecha de vencimiento:',
        noDateMany: '{documents} requieren fecha de vencimiento:',
      },
    },
    assetLimitReachedTitle: 'Límite de activos alcanzado',
    assetLimitReachedDescription:
      'Has alcanzado el límite de activos en tu plan. Para agregar o gestionar más activos, actualiza tu plan y obtén acceso a más funciones:',
    assetLimitFeature1: 'Mayor cantidad de activos disponibles',
    assetLimitFeature2: 'Historial completo de activos',
    assetLimitFeature3: 'Información completa de los activos',
    assetLimitUpgradeButton: 'Desbloquear más activos ahora',
    assetLimitContinueButton: 'Seguir con mi plan actual',
    limitedFeaturesAlert:
      'Algunas funciones no están disponibles en tu plan actual. Actualiza tu plan para ver todas las lecturas y configuraciones de tus activos.',
    changePlan: 'Cambiar plan',
    landing: {
      headerTitle: 'Empieza a gestionar tus activos en un solo lugar',
      headerSubtitle: '¿Para qué sirven los activos?',
      headerBullet1Bold: 'Personaliza los campos según el tipo de activo: ',
      headerBullet1: 'define qué datos necesitas y crea campos para cada tipo de activo.',
      headerBullet2Bold: 'Vincula fácilmente varios medidores: ',
      headerBullet2: 'asigna uno o más medidores a cada tipo de activo según tus necesidades.',
      headerBullet3Bold: 'Gestión centralizada de tus recursos: ',
      headerBullet3:
        'crea y organiza tus activos desde una sola plataforma, visualizando su información clave como estado, ubicación y lecturas de medidores.',
      headerButton: 'Usar activos',
      carouselTitle: 'Crea tu primer activo',
      carouselStep1Title: 'Crea tipo de activo',
      carouselStep1Description:
        'Crea un tipo de activo y define una categoría para tus activos, como Equipo o Vehículos. Luego podrás ',
      carouselStep1DescriptionBold: 'personalizar los campos que cada activo debe tener.',
      carouselStep2Title: 'Selecciona medidores',
      carouselStep2Description:
        'Elige los medidores que quieras usar para este tipo de activo, como ',
      carouselStep2DescriptionBold:
        'horómetro, kilometraje, temperatura o crea nuevos si lo necesitas.',
      carouselStep3Title: 'Crea tu primer activo',
      carouselStep3Description: 'Después de configurar el tipo de activo, presiona ',
      carouselStep3DescriptionBold: 'Crear activo',
      carouselStep3DescriptionEnd: ' y completa la información correspondiente.',
      carouselStep4Title: '¿No encuentras el medidor que necesitas?',
      carouselStep4Description:
        'Si el medidor que necesitas no está disponible, puedes crearlo desde la pestaña ',
      carouselStep4DescriptionBold: 'Medidores.',
      carouselNext: 'Siguiente',
      carouselPrevious: 'Anterior',
      footerTitle: 'Organiza, mide y gestiona',
      footerDescription:
        'Ahora que sabes cómo funcionan los activos, crea un tipo de activo, personaliza su información y empieza a vincularlos a tus formularios y lecturas.',
      footerButton: 'Crear tipo de activo',
    },
    assetTypes: {
      title: 'Tipos de activos',
      noAssetType: 'No se ha seleccionado un tipo de activo',
      noAssetTypes: 'No se encontraron tipos de activos',
      create: 'Crear',
      createAssetType: 'Crear tipo de activo',
      createAssetTypeSuccess: 'Tipo de activo creado correctamente',
      createAssetTypeError: 'Error al crear el tipo de activo',
      createAssetTypeErrorDuplicateName: 'El nombre del tipo de activo ya existe',
      type: 'Tipo de activo',
      description: 'Descripción',
      createdAssets: 'Activos creados',
      actions: 'Acciones',
      confirmDeleteTitle: '¿Estás seguro de eliminar este tipo de activo?',
      confirmDeleteDescription:
        'El tipo de activo {assetTypeName} se eliminará. Esta acción no se puede deshacer.',
      assetTypeDeleted: 'Tipo de activo eliminado correctamente',
      assetTypeDeletedError: 'Error al eliminar el tipo de activo',
      searchPlaceholder: 'Buscar tipo de activo',
      viewAssets: 'Ver activos',
      assetTypeDeleteSuccess: 'Tipo de activo eliminado correctamente',
      assetTypeDeleteError: 'Error al eliminar el tipo de activo',
      assetTypeUpdateSuccess: 'Tipo de activo actualizado correctamente',
      assetTypeUpdateError: 'Error al actualizar el tipo de activo',
      formTitleEdit: 'Editar tipo de activo',
      formSubtitleCreate: 'Proporciona los datos para cada atributo del tipo de activo.',
      formSubtitleEdit: 'Actualiza los atributos del tipo de activo y guarda los cambios.',
      formNameLabel: 'Nombre',
      formDescriptionLabel: 'Descripción',
      formCustomIdLabel: 'Nombre de ID personalizado',
      formIconLabel: 'Ícono',
      formLoadError: 'No fue posible cargar este tipo de activo.',
      formBackToList: 'Volver a tipos de activos',
      formReset: 'Restablecer',
      formSave: 'Guardar',
      formCancel: 'Cancelar',
      formMeterSelectLabel: 'Selecciona un medidor',
      formCustomIdTooltip:
        'Para una mejor experiencia, tus activos deben tener un identificador único. Llámalo como quieras: ID, Placa, Serial, etc',
      iconSelectorColors: 'Colores',
      iconSelectorIcons: 'Íconos',
      addMeterTitle: 'Agregar medidor',
      addMeterDescription:
        'Agrega medidores según el uso de tu activo. Podrás editarlos cuando lo necesites',
      addMeterPlaceholder: 'Selecciona un medidor para tu tipo de activo',
      addFieldsTitle: 'Añadir campos personalizados',
      addFieldsDescription:
        'Define los campos que aparecerán en el formulario de creación de activos',
      addFieldButton: 'Agregar campo',
      requiredField: 'Campo obligatorio',
      dragFieldLabel: 'Arrastrar campo {name}',
      backToAssets: 'Volver a activos',
      fieldNameAlreadyExists: 'El nombre del campo personalizado ya existe',
      reachedAssetTypeFieldsLimit: 'Has alcanzado el límite de campos para un tipo de activo',
      selectType: 'Selecciona un tipo de activo',
      search: 'Buscar tipos de activos...',
      fieldTypes: {
        text: 'Texto',
        number: 'Número',
        date: 'Fecha',
        image: 'Imagen',
        files: 'Archivos',
      },
      fileTypeSelector: {
        label: 'Tipo de archivo',
        allFormats: 'Todos los formatos',
        audio: 'Audio',
        video: 'Video',
      },
    },
  },
  mainMenu: {
    home: 'Inicio',
    forms: 'Formularios',
    integrations: 'Integraciones',
    taskAssigner: 'Asignar tareas',
    plannings: 'Planificaciones',
    findings: 'Tickets',
    signatures: 'Firmas',
    locations: 'Lugares',
    lists: 'Listas',
    assets: 'Activos',
    charts: 'Gráficas',
    map: 'Mapa',
    sensors: 'Sensores',
    training: 'Capacitaciones',
    settings: {
      main: 'Ajustes y ayuda',
      changelog: 'Notificaciones',
      account: 'Ajustes cuenta',
      users: 'Usuarios',
      billing: 'Pagos',
      invite: 'Invita y gana',
      helpCenter: 'Centro de ayuda',
      news: 'Novedades',
      upgrade: 'Mejorar plan',
    },
    new: 'Nuevo',
    askDataScope: 'Pregúntale a DataScope',
    whatsapp: 'WhatsApp',
    myDashboards: 'Mis Dashboards',
  },
  dashboards: {
    title: 'Mis Dashboards',
    empty: 'Aún no tienes dashboards guardados.',
    emptyHint: 'Pide un gráfico en Ask DataScope y guárdalo aquí.',
    delete: 'Eliminar dashboard',
    refresh: 'Actualizar',
    loading: 'Cargando...',
    loadError: 'No se pudieron cargar los dashboards.',
    addTo: 'Agregar a Mis Dashboards',
    viewIn: 'Ver en Mis Dashboards',
    saving: 'Guardando...',
    saveError: 'Error al guardar',
    noDataToSave: 'Sin datos para guardar',
    updatedAt: 'Actualizado',
    back: 'Volver',
  },
  whatsappModule: {
    title: 'Módulo WhatsApp',
    subtitle: 'Completa formularios y recibe respuestas directo por WhatsApp.',
    loadError: 'No pudimos cargar el estado del módulo. Intenta de nuevo.',
    onboarding: {
      title: 'Prueba el Módulo WhatsApp',
      intro: 'Tus usuarios completan formularios conversando por WhatsApp: texto, audio y fotos.',
      trialOffer: 'Empieza con una prueba gratuita de {limit} formularios por {days} días.',
      startTrial: 'Empezar prueba gratuita',
      phoneTitle: 'Confirma tu número de WhatsApp',
      phoneHint: 'Con código de país. Lo activaremos para que puedas hablar con el bot.',
      confirm: 'Confirmar y activar',
      confirming: 'Activando...',
      readyTitle: '¡Listo! Mándale un mensaje al bot',
      readyDetail: 'Escanea el QR o abre WhatsApp con el botón y envía "{greeting}".',
      openWhatsapp: 'Abrir WhatsApp',
      noBotNumber: 'Tu número quedó activado. El número del bot se configurará pronto.',
      done: 'Ir al panel',
      invalidPhone: 'El número no parece válido. Revisa el código de país.',
      enrolledElsewhere: 'Ese número ya está activado en otra cuenta.',
      genericError: 'No pudimos activar el número. Intenta de nuevo.',
    },
    usage: {
      title: 'Uso del período',
      responses: 'Respuestas',
      messagesSent: 'Mensajes enviados',
      messagesReceived: 'Mensajes recibidos',
      quota: 'Cuota',
    },
    trial: {
      title: 'Prueba gratuita',
      usedOfLimit: '{used} de {limit} formularios usados',
      daysRemaining: 'Te quedan {days} días de prueba.',
      active: 'Vigente',
      exhausted: 'Terminada',
      exhaustedHint: 'Usaste los formularios de la prueba. Activa el módulo para seguir.',
      expiredHint: 'Se acabó el tiempo de prueba. Activa el módulo para seguir.',
    },
    price: {
      title: 'Precio',
      activationTitle: 'Activación',
      pitch: '¿Te gustó el módulo? Escríbenos y lo activamos con tu operación.',
      contactCta: 'Hablar con nosotros',
      activate: 'Hablar con nosotros',
      activeBadge: 'Módulo activo',
      trialBadge: 'En prueba',
      inactiveBadge: 'Inactivo',
      contactHint: 'Estás en prueba. Cuando quieras activarlo, escríbenos.',
      trialEndedPitch: 'Tu prueba terminó. Escríbenos para activar el módulo en tu operación.',
      contactMessage: 'Hola, quiero activar el Módulo WhatsApp en mi cuenta.',
    },
    start: {
      title: 'Empieza a usarlo',
    },
    users: {
      title: 'Usuarios',
      enabledSection: 'Activados',
      readySection: 'Listos para activar',
      noPhoneSection: 'Sin número',
      enable: 'Activar',
      disable: 'Desactivar',
      noPhoneHint: 'Agrega un teléfono a este usuario para poder activarlo.',
      cutoverWarning: 'Al activar el primer usuario, solo los usuarios activados podrán usar el bot.',
      empty: 'No hay usuarios en este grupo.',
    },
    responses: {
      title: 'Respuestas por WhatsApp',
      form: 'Formulario',
      code: 'Código',
      user: 'Usuario',
      date: 'Fecha',
      empty: 'Aún no hay respuestas por WhatsApp.',
    },
  },
  askDataScope: {
    title: 'Pregúntale a DataScope',
    placeholder: 'Pregunta lo que quieras sobre tus datos...',
    placeholderWithActions: 'Pregunta sobre tus datos, o pídeme crear cuentas...',
    newChat: 'Nueva conversación',
    modules: {
      all: 'Todos',
      forms: 'Formularios',
      tasks: 'Tareas',
      locations: 'Lugares',
      assets: 'Activos',
      signatures: 'Firmas',
      tickets: 'Tickets',
    },
    mentions: {
      categories: {
        forms: 'Formularios',
        users: 'Usuarios',
        locations: 'Lugares',
        assets: 'Activos',
        groups: 'Grupos',
      },
      noResults: 'Sin resultados',
      back: 'Volver',
      loading: 'Buscando...',
      loadError: 'No se pudo cargar. Intenta de nuevo.',
    },
    chartTypePrompt: {
      question: '¿Qué tipo de gráfico quieres ver?',
      types: {
        bar: 'Barras',
        line: 'Línea',
        pie: 'Torta',
        donut: 'Dona',
        stat: 'Número',
        heatmap: 'Mapa de calor',
      },
    },
    export: {
      chooseFormat: '¿En qué formato lo quieres?',
      chooseRecord: 'Las firmas se descargan de a un documento. Hay {count}; elige cuál quieres:',
      exportObject: 'Exportar {object}',
      periodPrompt: 'Esta exportación necesita un rango de fechas. Elige el período que quieres en el archivo.',
      working: 'Exportando…',
      success: 'Los datos se exportaron correctamente',
      objects: {
        tasks: 'tareas',
        form_answers: 'respuestas',
        plannings: 'planificaciones',
        assets: 'activos',
        locations: 'lugares',
        lists: 'listas',
        tickets: 'tickets',
        signatures: 'firmas',
      },
      download: 'Descargar {module}',
      preparing: 'Preparando el archivo…',
      stillPreparing: 'El archivo sigue generándose. Te avisamos por correo cuando esté listo.',
      expired: 'El enlace de descarga expiró. Pide la exportación de nuevo.',
      expiredOrFailed: 'La descarga ya no está disponible.',
      retry: 'Reintentar',
      limitWarning:
        'La exportación admite hasta {max} días y estás pidiendo {requested}, así que el archivo va a cubrir solo los últimos {max} días del rango.',
      droppedFilters: 'El archivo no aplica estos filtros: {fields}.',
      droppedFiltersGeneric: 'El archivo no aplica todos los filtros de la consulta.',
      // Nombres de campo del backend -> etiqueta legible. El aviso los imprimía
      // crudos ("form_state_id"). Los campos de persona no están y no deben estar:
      // el backend los saca de toda declaración, así que no pueden llegar acá.
      filterFields: {
        form_id: 'formulario',
        form_ids: 'formulario',
        task_form_id: 'formulario',
        form_name: 'nombre del formulario',
        form_state_id: 'estado',
        form_state_ids: 'estado',
        status: 'estado',
        acceptance_status: 'estado de aceptación',
        priority: 'prioridad',
        asset_id: 'activo',
        asset_ids: 'activo',
        asset_type_id: 'tipo de activo',
        location_id: 'lugar',
        location_ids: 'lugar',
        location: 'lugar',
        nestable_location_id: 'lugar',
        location_type: 'tipo de lugar',
        place_type_id: 'tipo de lugar',
        planning_type_id: 'tipo de planificación',
        signer_type: 'tipo de firmante',
        active: 'activo o inactivo',
        name: 'nombre',
        code: 'código',
        city: 'ciudad',
        region: 'región',
        country: 'país',
      },
      droppedPeriod: 'El archivo no aplica el rango de fechas de la consulta.',
      caveats: {
        search_not_ids:
          'La exportación busca por texto, así que puede incluir registros distintos a los contados.',
        whole_account_only: 'La exportación incluye toda la cuenta, sin los filtros de la consulta.',
        nestable_only: 'La exportación incluye solo los lugares del módulo actual.',
        pdf_index_not_files:
          'Recibirás una planilla con un enlace al PDF de cada respuesta, no los PDF juntos.',
      },
      formats: {
        excel: 'Excel',
        excel_by_question: 'Excel por pregunta',
        excel_by_form: 'Excel por formulario',
        excel_by_repeatable: 'Excel por tabla repetible',
        excel_all: 'Excel completo',
        pdf_single: 'PDF',
        pdf_documents: 'PDF de los documentos',
      },
      reasons: {
        export_failed: 'No pudimos generar el archivo. Intenta de nuevo en unos minutos.',
        export_not_in_plan: 'Tu plan no incluye exportaciones.',
        export_module_has_none: 'Este módulo no tiene exportación.',
        export_module_unknown: 'No puedo exportar este módulo.',
        export_not_available_yet: 'Todavía no puedo entregarte este archivo desde el chat.',
        export_no_data_yet: 'Primero necesito consultar los datos que quieres descargar.',
        export_needs_form_scope:
          'No puedo exportar todos los formularios al mismo tiempo. Menciónalos con @ o cuéntame qué datos necesitas.',
        export_form_scope_ambiguous:
          'Ese nombre coincide con más de un formulario. Dime cuál o cuáles quieres exportar.',
        export_format_unknown: 'Ese formato no está disponible para este módulo.',
        export_needs_single_record:
          'Este formato es de un solo registro. Dime cuál quieres descargar.',
        export_period_required: 'Necesito un rango de fechas para exportar.',
        export_requires_places_admin: 'Necesitas permisos de administración de lugares para exportar.',
        export_already_in_progress: 'Ya tienes una exportación en curso. Espera a que termine.',
        export_not_permitted: 'No tienes permiso para exportar este módulo.',
        export_upload_failed: 'El archivo se generó pero no pudimos subirlo. Intenta de nuevo.',
        empty_export: 'No hay registros para exportar.',
      },
    },
    chartRefine: {
      personalize: 'Personalizar',
      states: { na: 'No aplica', fixed: 'Fijo', recomputing: 'Recalculando…' },
      value: { title: 'Valor', count: 'Cantidad', percent: 'Porcentaje' },
      period: { title: 'Periodo', day: 'Día', week: 'Semana', month: 'Mes' },
      order: {
        title: 'Orden',
        none: 'Cronológico',
        desc: 'Mayor a menor',
        asc: 'Menor a mayor',
      },
      breakdown: {
        title: 'Desglosar por',
        none: 'Sin desglose',
        user: 'Por usuario',
        status: 'Por estado',
        location: 'Por Lugar',
      },
    },
    chartDetail: {
      record: 'respuesta',
      records: 'respuestas',
      close: 'Cerrar',
      loading: 'Cargando…',
      empty: 'Sin respuestas en este punto.',
      viewIn: 'Ver en {module} →',
      viewCountIn: 'Ver los {count} registros en {module} →',
      goToRecord: 'Ir a la respuesta →',
      modules: {
        form_answers: 'Respuestas',
        tasks: 'Tareas',
        tickets: 'Tickets',
        assets: 'Activos',
        locations: 'Lugares',
        signatures: 'Firmas',
      },
    },
    // It.3 "Fuente del dato": la línea que declara sobre qué se calculó la
    // respuesta. `dateFormat` es el patrón (date-fns) con que se muestra el
    // periodo en este idioma.
    sourceLine: {
      prefix: 'Base:',
      separator: '·',
      dateFormat: 'dd/MM/yyyy',
      allTime: 'todo el histórico',
      periodRange: '{start} a {end}',
      periodFrom: 'desde {start}',
      periodTo: 'hasta {end}',
      viewIn: 'Ver en {module} →',
      viewFilteredIn: 'Ver en {module} con estos filtros →',
      summaryOrigins: '{count} orígenes',
      summaryTotal: '{count} registros en total',
      expand: 'Ver el detalle por origen',
      collapse: 'Ocultar el detalle por origen',
      modules: {
        form_answers: 'Respuestas',
        tasks: 'Tareas',
        tickets: 'Tickets',
        assets: 'Activos',
        locations: 'Lugares',
        lists: 'Listas',
        plannings: 'Planificaciones',
        signatures: 'Firmas',
      },
      records: {
        form_answers: { one: 'respuesta', other: 'respuestas' },
        tasks: { one: 'tarea', other: 'tareas' },
        tickets: { one: 'ticket', other: 'tickets' },
        assets: { one: 'activo', other: 'activos' },
        locations: { one: 'lugar', other: 'lugares' },
        lists: { one: 'lista', other: 'listas' },
        plannings: { one: 'planificación', other: 'planificaciones' },
        signatures: { one: 'firma', other: 'firmas' },
      },
    },
    errors: {
      timeout: 'La solicitud ha expirado. Inténtalo de nuevo.',
      rateLimit: 'Límite diario de mensajes alcanzado.',
      generic: 'Algo salió mal. Inténtalo de nuevo.',
    },
    typing: 'Pensando...',
    readOnly: 'Solo puedo ayudarte a consultar datos. No puedo realizar cambios.',
    greeting: 'Hola',
    howCanIHelp: '¿Cómo te puedo ayudar hoy?',
    suggestions: 'Sugerencias',
    recentChats: 'Chats recientes',
    noRecentChats: 'Sin conversaciones recientes.',
    conversationKind: {
      action: 'Creación de cuentas',
      query: 'Consulta',
    },
    moduleLockedNote:
      'El filtro de módulo está fijo para esta conversación. Inicia un nuevo chat para cambiarlo.',
    dateFilter: {
      from: 'Desde',
      to: 'Hasta',
      clear: 'Limpiar',
      selectRange: 'Seleccionar rango de fechas',
    },
    prompts: [
      'Resume las respuestas de [nombre del formulario]',
      'Crea un gráfico con las respuestas de cada mes',
      '¿Cuántas firmas siguen pendientes?',
      'Muéstrame todas las tareas completadas este mes',
      'Dame un resumen general de las estadísticas de mi cuenta',
    ],
    report: {
      buttonInline: 'Reportar este problema',
      title: 'Reportar un problema',
      description: 'Cuéntanos qué salió mal o qué te gustaría ver.',
      defaultText: 'Me gustaría solicitar una funcionalidad',
      yourQuestion: 'Tu pregunta:',
      cancel: 'Cancelar',
      send: 'Enviar reporte',
      sending: 'Enviando...',
      successDescription: 'Gracias por tus comentarios. Lo revisaremos.',
      close: 'Cerrar',
    },
    trial: {
      title: 'Período de prueba gratuito',
      description:
        'Explora Pregúntale a DataScope sin costo. Hazle preguntas a tus datos en lenguaje natural y obtén respuestas en segundos.',
      expired: 'El periodo gratuito ha terminado.',
      feedback:
        'Tu opinión nos ayuda a mejorarlo. Usa el ícono {icon} junto a cualquier respuesta para contarnos qué cambiarías.',
      timeRemaining: 'Tiempo restante:',
      days: 'Días',
      hours: 'Horas',
      minutes: 'Min',
      seconds: 'Seg',
      gotIt: 'Empezar a explorar',
      expiredDismiss: 'Entendido',
    },
    supportHandoff: {
      openChat: 'Abrir chat de soporte',
      connectWithPerson: 'Sí, hablar con una persona',
      fromLabel: 'Enviado desde Pregúntale a DataScope IA',
    },
    feedback: {
      helpful: 'Respuesta útil',
      notHelpful: 'Respuesta no útil',
    },
    aiDisclaimer: 'Esta función usa IA. Verifica los datos antes de tomar decisiones.',
    actions: {
      folders: {
        title: 'Carpetas que puedes replicar (en esta cuenta)',
        forms: 'formularios',
      },
      result: {
        successTitle: 'Listo, todo cargado',
        partialTitle: 'Lote completado en parte',
        successBody: 'Cada formulario quedó asociado a su formulario maestro de origen.',
        partialBody: 'Lo ya cargado no se tocó. Puedes reintentar lo pendiente.',
        failedTitle: 'Pendientes por error',
        credentialsTitleOne: 'Información de la cuenta creada',
        credentialsTitleMany: 'Información de las cuentas creadas',
        emailLabel: 'Correo',
        passwordLabel: 'Contraseña',
        copyAll: 'Copiar todas',
        copied: 'Copiadas',
        emailNote: 'Se envió un correo al administrador con la contraseña de un solo uso; deberá cambiarla al primer acceso.',
        retry: 'Reintentar lo pendiente',
      },
      progress: {
        title: 'Cargando en cola',
        of: 'de',
        sequentialNote:
          'Procesamiento secuencial: una empresa a la vez.',
        status: {
          queued: 'En cola',
          processing: 'Procesando…',
          done: 'Listo',
          failed: 'Falló · queda pendiente',
        },
      },
      excel: {
        attach: 'Adjuntar Excel',
        title: 'Adjuntar Excel',
        description:
          'Sube tu planilla con las empresas, su correo de administrador y las carpetas a replicar. La IA la lee y te muestra un resumen antes de ejecutar.',
        dropzone: 'Arrastra tu Excel aquí o haz clic para buscar',
        formats: 'Formatos .xlsx o .xls',
        ready: 'Listo para interpretar',
        invalidType: 'Formato no válido. Adjunta un archivo .xlsx o .xls',
        cancel: 'Cancelar',
        use: 'Usar este archivo',
      },
      summary: {
        title: 'Resumen de la solicitud',
        awaitingConfirm: 'Falta tu confirmación',
        statNew: 'cuentas nuevas',
        statExisting: 'ya existen',
        statFolders: 'carpetas en total',
        statForms: 'formularios',
        colCompany: 'Empresa',
        colAccount: 'Cuenta',
        colFolders: 'Carpetas',
        colForms: 'Formularios',
        badgeExisting: 'Ya tiene cuenta',
        badgeNew: 'Nueva',
        inferred: 'inferido',
        moreCompanies: 'Ver {n} empresas más',
        showLess: 'Ver menos',
        existingNote:
          'A las empresas que ya tienen cuenta no se les crea una nueva: solo se les replican las carpetas en su cuenta actual.',
        queueNote:
          'La carga se procesa en cola, una por una. Cada formulario queda asociado a su formulario maestro de origen.',
        adjust: 'Ajustar',
        confirm: 'Confirmar y ejecutar',
        confirmed: 'Confirmado',
        adjustNote: 'Solicitud en ajuste. Escribe los cambios en el chat.',
        errorNote: 'No se pudo procesar la acción. Recarga la conversación e inténtalo de nuevo.',
        excludedTitle: 'No se incluyeron estas cuentas',
        excludedItem: '{company}: no se creará porque no existen en tu cuenta: {items}',
      },
      manage: {
        title: 'Crear y gestionar cuentas',
        createAccounts: 'Crear cuentas para varias empresas',
        replicableFolders: '¿Qué carpetas puedo replicar?',
        exampleFolder: 'Inspecciones de terreno',
        createExample:
          'Habiliten estas empresas con {folder}: Constructora del Valle (constructoradelvalle@example.cl), Minera San Rafael (minerasanrafael@example.cl), Transportes Andes (transportesandes@example.cl).',
      },
    },
  },
  mainTopBar: {
    accountSwitcher: {
      switchingTitle: 'Cambiando a {{account}}...',
      switchingSubtitle: 'Te estamos redirigiendo, esto puede tardar unos segundos',
      title: 'Cambiar cuenta',
      error: 'No pudimos cambiar de cuenta. Sigues en la cuenta actual.',
      unnamedAccount: 'Cuenta {{id}}',
      currentAccount: 'Cuenta actual',
      searchPlaceholder: 'Buscar por nombre',
      searchAction: 'Buscar',
      seeAllAccounts: 'Ver todas las cuentas ({{count}})',
      noResults: 'No encontramos cuentas con ese nombre.',
      back: 'Volver',
      close: 'Cerrar',
    },
    createIssue: 'Crear ticket',
    featureRequest: 'Envíanos tu idea',
    featureRequestText: '¿Necesitas una herramienta que aún no tenemos?',
    logout: 'Cerrar sesión',
    languageOptions: {
      es: 'Español',
      en: 'Inglés',
      pt: 'Portugués',
    },
    newNotifications: 'Nuevo mensaje en {formName}',
    companySettings: 'Ajustes de empresa',
    myAccount: 'Mi cuenta',
  },
  notFound: {
    title: '404',
    description:
      'Lo sentimos, pero la página que estás buscando no se encuentra. Intenta verificar la URL para un error, luego haz clic en el botón de actualización en tu navegador o intenta encontrar algo más en nuestra aplicación.',
    button: 'Ir a inicio',
  },
  actionsOverview: {
    title: 'Acciones mensuales disponibles',
    explanation: '¿Qué son las acciones?',
    actionsUsed: 'Acciones usadas',
    exceedActionsInfo:
      'Si realizas más acciones de las incluidas en tu plan, se aplicará un cargo adicional por cada una.',
    moreInfo: 'Más información',
    error: 'Error al cargar información de acciones',
    explanationLink:
      'https://help.mydatascope.com/es/articles/11321884-planes-de-datascope-como-funcionan-y-que-incluyen#h_23898674ca',
    moreInfoLink:
      'https://help.mydatascope.com/es/articles/11321884-planes-de-datascope-como-funcionan-y-que-incluyen#h_5897cfe9c1',
  },
  billing: {
    externalIframe: {
      tokenAuthorizeError: 'No pudimos autorizar tu sesión. Por favor, refresca la página.',
    },
  },
  maps: {
    title: 'Ubica tus respuestas en el mapa',
    emptyState: {
      title: 'Mapea tus respuestas fácilmente',
      subtitle: '¿Para qué usar la función de mapas?',
      description: 'Con esta funcionalidad es posible:',
      feature1:
        'Visualizar en tiempo real dónde se completan formularios, se ejecutan tareas o se reportan tickets.',
      feature2:
        'Detectar zonas con baja o alta cobertura para tomar decisiones operativas estratégicas.',
      feature3: 'Obtener trazabilidad y control geográfico de las operaciones diarias.',
      demo: {
        title: 'Visualiza la ubicación de tus respuestas',
        mobile: {
          title: 'Responde desde terreno con la app',
          description:
            'Responde desde la app con ubicación GPS activada y valida que las respuestas fueron enviadas desde el lugar asignado.',
          description2:
            '¡Importante! Asegúrate que tu equipo registre respuestas usando la app con la ubicación habilitada.',
        },
        web: {
          title: 'Visualiza tus respuestas en el mapa',
          description:
            'Una vez respondas tus formularios desde la App podrás visualizar tus respuestas en un mapa interactivo.',
        },
      },
    },
  },
  lists: {
    banner: {
      message:
        '¡Lugares nuevos ya están disponibles! Ahora puedes organizar, asignar usuarios y visualizar la actividad en un solo lugar.',
      action: 'Prueba ahora',
    },
  },
  mfa: {
    title: 'Activa el 2FA',
    next: 'Siguiente',
    finish: 'Finalizar',
    close: 'Cerrar',
    scanQr: 'Escanea el código QR',
    scanQrDescription: 'Escanea el QR con tu app de autentificación',
    manualEntry: 'O ingresa el código manualmente',
    verifying: 'Verificando...',
    verifyCode: 'Ingresa el código de autenticación',
    verifyCodeDescription: 'Escribe el código de 6 dígitos que aparece en tu app de autenticación',
    verifyCodeInvalid: 'Código incorrecto. Inténtalo de nuevo.',
    verifyCodeError: 'Error al verificar el código',
    verifyCodeCognitoError: 'Tuvimos un error interno. Escríbenos por el chat para solucionarlo.',
    successTitle: 'Autenticación configurada con éxito',
    successDescription:
      'A partir de ahora, cada vez que inicies sesión, se te pedirá un código temporal desde tu app autenticadora para mayor seguridad',
    successDescriptionMobile:
      'Para continuar, por favor cierra la app de DataScope y ábrela nuevamente.',
    maybeLater: 'Más tarde',
    activateNow: 'Activar ahora',
    protectAccount: 'Protege tu cuenta con una capa extra de seguridad',
    protectAccountDescription:
      'Con la autenticación en dos pasos, necesitarás un código temporal desde tu app autenticadora para iniciar sesión. Podrás gestionar esta configuración más adelante desde tu perfil de usuario.',
    organizationRequires: 'Tu organización requiere activar la autenticación en dos pasos (2FA)',
    organizationRequiresDescription:
      'Usa una app autenticadora para generar el código temporal que se pedirá al iniciar sesión',
    userSettings: {
      title: 'Seguridad de la cuenta (2FA)',
      descriptionActive:
        'Añade una capa extra de seguridad a tu cuenta.\n Al activar la autenticación en dos pasos (2FA), se solicitará un código desde tu app autenticadora al iniciar sesión.',
      descriptionDisable:
        'Tienes activada la verificación en dos pasos. Para iniciar sesión necesitas un código temporal de tu app autenticadora.\nPuedes quitarla, pero tu cuenta será menos segura.',
      activate: 'Activar 2FA',
      disableConfig: 'Quitar verificación en dos pasos',
      disableDialogTitle: '¿Quieres quitar la verificación en dos pasos?',
      disableDialogDescription:
        'Si la quitas, tu cuenta quedará menos protegida. Podrás activarla otra vez cuando quieras.',
      disableDialogConfirm: 'Quitar',
      disableDialogCancel: 'Cancelar',
      justSameUserCanActivate:
        'Solo el mismo usuario puede activar la autenticación en dos pasos(2FA)',
    },
  },
  scheduledSend: {
    sendNow: 'Enviar ahora',
    sameDay: 'Al inicio de la tarea',
    dayBefore: 'día antes',
    daysBefore: 'días antes',
    weekBefore: '1 semana antes',
    monthBefore: '1 mes antes',
    blockTitle: 'Programar envío de la tarea',
    blockDescription: 'Define cuántos días antes del inicio de la tarea se enviará al responsable',
    statsLabel: 'Programadas',
    scheduled: 'Programada',
    onboardingModal: {
      title: 'Ahora puedes programar el envío de tus tareas',
      description:
        'Ahora puedes decidir cuándo el operario recibirá la tarea: el mismo día o con anticipación, para mejorar la planificación y ejecución.',
      primaryButton: 'Entendido',
      secondaryButton: 'Descubre cómo funciona',
      helpCenterUrl:
        'https://help.mydatascope.com/es/articles/14536340-programacion-de-tareas-asignadas',
    },
    tooltip: {
      sendNow: 'La tarea se enviará hoy',
      sameDay: 'La tarea se enviará al inicio de la tarea',
      nDaysBefore: 'La tarea se enviará el {{dates}}',
      sentOn: 'La tarea se envió el {{dates}}',
      disabledSingular: '{{count}} fecha seleccionada no permite programar este envío: {{dates}}',
      disabledPlural: '{{count}} fechas seleccionadas no permiten programar este envío: {{dates}}',
      noStartDate: 'Selecciona al menos una fecha y hora de inicio',
    },
  },
};
